//group indexing working code
import React, { useState, useEffect, useRef } from "react";
import Commonheader from "./Commonheader";
import useAxios from "../hooks/useAxios";
import { QueryBuilder, formatQuery, Rule } from "react-querybuilder";
import FieldMappingEditor from "./CreateView";
import PayloadTile from "./PayloadTile";
import { Button, Col, Input, Modal, Row, Checkbox,Form,Select,InputNumber } from "antd";
import { Option } from "antd/lib/mentions";
import { ChromePicker } from "react-color";
import { Card } from 'antd';
import { DeleteOutlined, DownloadOutlined, EditOutlined, UploadOutlined, RedoOutlined } from "@ant-design/icons";
import 'react-querybuilder/dist/query-builder.css';
import { FaEye, FaEyeSlash, FaLock, FaLockOpen } from 'react-icons/fa';
import { ConditionBuilder } from "./ConditionGroup";

//import { button, div, PEInput } from "./permissionComponents/index";
import { ReactFormBuilder, ReactFormGenerator } from '@acen-navadhan/react-form-builder';
import '@acen-navadhan/react-form-builder/dist/app.css';
import "react-querybuilder/dist/query-builder.css";


const payloadTypeOptions = {
  API:"A",
  MongoDB:"M",
  Bucket: "B"
};
const selectPayloadValues = {
  API_Selection: "A",
  MongoDB_Selection:"M",
  Base_url:"B"
};
const select_url_type ={
  Without_base_url: "N"
}
//const { Option } = Select;

function Create_view(props) {
  const [loading, sendRequest] = useAxios();
  const [searchKey, setsearchKey] = useState([
    { searchKey: "", operator: "", searchValue: "", inputType: "string" },
  ]);
  const [searchKeygetpayloadfields, setsearchKeygetpayloadfields] = useState([
    { searchKey: "", operator: "", searchValue: "", inputType: "string" },
  ]);
  const [tempsearchKey, settempsearchKey] = useState([
    { searchKey: "", operator: "", searchValue: "", inputType: "string" },
  ]);
  const [istempsearch, setistempsearch] = useState("0");
  const [get_bucketfield, setget_bucketfield] = useState(false);
  const [fetch_onload, setfetch_onload] = useState(true);
  const [queue_flag, setqueue_flag] = useState("false");
  const [hide_loadmore, sethide_loadmore] = useState();
  const [hide_pagination, sethide_pagination] = useState();
  const [new_field_mapping, setnew_field_mapping] = useState();
  const [editsearchKey, seteditsearchKey] = useState();
  const [searchValue, setsearchValue] = useState();
  const [fields_array, setfields_array] = useState();
  const [fields_array_payload, setfields_array_payload] = useState();
  const [default_payload, setdefault_payload] = useState([]);
  const [isErrOpen, setisErrOpen] = useState(false);
  const [api_error_message, setapi_error_message] = useState();
  const [api_fields_list, setapi_fields_list] = useState();
  const [api_fields_payload, setapi_fields_payload] = useState();
  const [bucket_list, setbucket_list] = useState();
  const [bucket_name, setbucket_name] = useState("");
  const [event_name, setevent_name] = useState("");
  const [event_location, setevent_location] = useState("");
  const [view_name, setview_name] = useState();
  const [view_type, setview_type] = useState();
  const [commit_type, setcommit_type] = useState();
  const [agg_view, setagg_view] = useState();
  const [form_view, setform_view] = useState();
  const [formview, setformview] = useState();
  const [isexpand, setisexpand] = useState();
  const [select_payload, setselect_payload] = useState();
  const [mongo_combinesearch, setmongo_combinesearch] = useState();
  const [processedis, setprocessedis] = useState("false");
  const [status, setstatus] = useState("A");
  const [effetive_designation_id, seteffetive_designation_id] = useState();
  const [save_design_flag, setsave_design_flag] = useState(false);
  const [db_name, setdb_name] = useState();
  const [db_namegetpayload, setdb_namegetpayload] = useState();
  const [collection_name, setcollection_name] = useState();
  const [sourcedataoutputformat, setsourcedataoutputformat] = useState();
  const [outputfilter, setoutputfilter] = useState();
  const [payloaddataoutputformat, setpayloaddataoutputformat] = useState();
  const [collection_namegetpayload, setcollection_namegetpayload] = useState();
  const [finalArray, setfinalArray] = useState({});
  const [db_list, setdb_list] = useState();
  const [collection_list, setcollection_list] = useState();
  const [component_mapping, setcomponent_mapping] = useState();
  const [get_data_by, setget_data_by] = useState("C");
  const [hide_filter, sethide_filter] = useState();
  const [setupdated_at, setsetupdated_at] = useState();
  const [reload_api_data, setreload_api_data] = useState();
  const [show_action_column, setshow_action_column] = useState();
  const [updated_at, setupdated_at_timestamp] = useState();
  const [updated_by, setupdated_by] = useState();
  const [isDropdown, setisDropdown] = useState(false);
  const [isservice_id, setisservice_id] = useState(false);
  const [dropdownResponse, setdropdownResponse] = useState([]);
  const [service_idResponse, setservice_idResponse] = useState([]);
  const [filteredservice_id, setfilteredservice_id] = useState([]);
  const [hide_exportBtn, sethide_exportBtn] = useState();
  const [setcreated_at, setsetcreated_at] = useState();
  const [rules, setRules] = useState([]);
  // const [colorPickers, setColorPickers] = useState({});
  const [validDateCondition, setvalidDateCondition] = useState();
  const [initialRender, setInitialRender] = useState(false)
  const [clearedRules, setClearedRules] = useState([]);
  const [initialReset, setInitialReset] = useState(false);
  const [parentFieldCount, setParentFieldCount] = useState(0);
  const [fileteredViewList, setFilteredViewList] = useState([]);
  const [selectedViews, setSelectedViews] = useState([]);
  const [
    collection_listgetpayloadfields,
    setcollection_listgetpayloadfields,
  ] = useState();
  const [record_per_call, setrecord_per_call] = useState();
  const [dropdownResponsebasedata, setdropdownResponsebasedata] = useState([]);
  const [view_list, setview_list] = useState();
  const [disableedit, setdisableedit] = useState([]);
  const [checkboxcopyoption, setCheckboxcopyoption] = useState(
    props.location.state.copyOptions|| {}
  );
  const [selectedviewOption, setSelectedviewOption] = useState(
    props.location.state.selectedView || {}
  );
  const [isDataLoaded, setIsDataLoaded] = useState(false); 
    // Ankur Makavana | 04-08-2023 | Disable Bucket, Event and Designation id on edit
  const [view_id, setview_id] = useState();
  const [resondropdownlist, setresondropdownlist] = useState();
  const [
    effetive_designation_idList,
    seteffetive_designation_idList,
  ] = useState();
  const [versionData, setVersionData] = useState([]);
  const [view_version, setview_version] = useState();
  const [fieldlist, setfieldlist] = useState([
    {
      fieldname: "",
      BucketField: "",
      isEdit: "0",
      isRequired: "0",
      isVisible: "1",
      defaultfilter: "",
      addapi: "0",
      datatype: "textbox",
      tablesource: "",
      showLabel: "1",
      dropdownlist: "",
      Downloadfile: "",
      isSearch: "0",
      productlist: "",
      tenure: "",
      productid: "",
      massupdate: "0",
      isConfirm: "0",
      isEditDisable: "0",
      isRedirect: "0",
      RedirectData: "path:'',requiredata:[]",
      RedirectCondition: "",
      //DisableOnField: "",
      DisableOnFieldValue: "",
      FieldLength: "",
      FieldLengthErrorMessage: "",
      FileType: "",
      FileSize: "",
      FilePath: "",
      FileName: "",
      //tabledata: [{ id: 1, tablekey: "", tablevalue: "" }],
    },
  ]);
  const [divs, setDivs] = useState([
    {
      id: 1,
      action_name: "",
      api_url: "",
      output_path: "",
      formdata: [
        {
          id: 1,
          formdatakey: "",
          formdatavalue: "",
          inputtype: "text",
          defaultvalue: "",
        },
      ],
      inputType: "formdata",
      formrow: "",
      action_event: "",
      url_type: "",
      condition_value: '',
      select_field: '',
    },
  ]);
  const [datasource, setdatasource] = useState([
    {
      id: 1,
      action_name: "",
      api_url: "",
      output_path: "",
      formdata: [{ id: 1, formdatakey: "", formdatavalue: "", manual_input: "0", getdata_from: "", useasinput: "", inputapi: "" }],
      inputType: "formdata",
      formrow: "",
      action_event: "",
      url_type: "",
      outputformat: "",
      outputfilter: ""
    },
  ]);

  const [payloadfields, setpayloadfields] = useState([
    {
      id: 1,
      action_name: "",
      api_url: "",
      output_path: "",
      formdata: [{ id: 1, formdatakey: "", formdatavalue: "" }],
      inputType: "formdata",
      formrow: "",
      action_event: "",
      url_type: "",
      outputformat: "",
    },
  ]);
  const [exprow, setexprow] = useState([
    {
      fieldname: "",
      BucketField: "",
      isEdit: "0",
      isRequired: "0",
      isVisible: "1",
      defaultfilter: "",
      addapi: "0",
      datatype: "textbox",
      tablesource: "",
      showLabel: "1",
      dropdownlist: "",
      Downloadfile: "",
      isSearch: "0",
      massupdate: "0",
      isConfirm: "0",
      isEditDisable: "0",
      isRedirect: "0",
      RedirectData: "path:'',requiredata:[]",
      RedirectCondition: "",
      //DisableOnField: "",
      DisableOnFieldValue: "",
      FieldLength: "",
      FieldLengthErrorMessage: "",
      FileType: "",
      FileSize: "",
      FilePath: "",
      FileName: "",
    },
  ]);
  const [apidata, setapidata] = useState([
    {
      id: 1,
      action_name: "",
      api_url: "",
      output_path: "",
      formdata: [
        { id: 1, formdatakey: "", formdatavalue: "", defaultvalue: "" },
      ],
      outputdata: [{ id: 1, outputkey: "", outputvalue: "" }],
      tabledata: [{ id: 1, tablekey: "", tablevalue: "" }],
      inputType: "",
      formrow: "",
      getoutputdata: "",
      output_path: "",
    },
  ]);
  const [search_fields, setsearch_fields] = useState();
  const [isMobileview, setisMobileview] = useState(false);
  const [query, setQuery] = useState({ combinator: "and", rules: [] });
  // const [colorPickers, setColorPickers] = useState([]);
  const [colorPickers, setColorPickers] = useState(() => {
    const initialColors = {};
    query.rules.forEach((rule, index) => {
      initialColors[index] = {
        color: rule.color || "#ffffff",
        display: false
      };
    });
    return initialColors;
  });

  const [hasInitialized, setHasInitialized] = useState(false);
  
  const [Operators, setOperators] = useState([
    { name: "select", label: "select" },
    { name: "=", label: "=" },
    { name: "!=", label: "!=" },
    { name: ">", label: ">" },
    { name: "<", label: "<" },
    { name: ">=", label: ">=" },
    { name: "<=", label: "<=" },
    { name: "exists", label: "Exists" },
    // { name: "TDHG", label: "Time Different > (In Hour)" },
    // { name: "TDHL", label: "Time Different < (In Hour)" },
    // { name: "isNthDayBeforeToday", label: "is exactly N days before today" },
  ]);
  const [dateOperators, setDateOperators] = useState([
    { name: "select", label: "select" },
    { name: "TDHG", label: "Time Different > (In Hour)" },
    { name: "TDHL", label: "Time Different < (In Hour)" },
    { name: "NDaysBefore", label: "N days before" },
    { name: "lastNDays", label: "last N days" },
    { name: "isNthDayBeforeToday", label: "is exactly N days before today" },
    { name: "nextNDays", label: "next N days" },
    { name: "NDaysAfter", label: "N days after" },
  ])
  const [allRules, setallRules] = useState([]);
  const [displayColorPicker, setDisplayColorPicker] = useState(false);
  const [marqueeColorPicker, setmarqueeColorPicker] = useState(false);
  const [configurations, setConfigurations] = useState([
    {
      name: "",
      color: "#000",
      items: [
        { type: "dropdown", value: "" },
        { type: "operator", value: "" },
      ],
      isEditable: 0,
    },
  ]);
  const [conditional_update, setconditional_update] = useState([
    {
      field: "",
      operator: "",
      condition_value: "",
      check_data_from: "",
      fields_to_update: [
        { field_name: "", field_value: "" }
      ]
    },
  ]);
  const [fieldForPartialSubmit, setFieldForPartialSubmit] = useState([
    ...new Set(fieldlist),
  ]);
  const [selectedFieldForPartial, setSelectedFieldForPartial] = useState([]);
  const [entries, setEntries] = useState([
    { partialfield: "", defaultvalue: "" },
  ]);

  // Field Dependencies: control one field based on another field's value
  const dependencyActionOptions = [
    { label: "Disable Edit", value: "isEditDisable" },
    { label: "Can Edit", value: "isEdit" },
    { label: "is Required", value: "isRequired" },
    { label: "is Visible", value: "isVisible" },
    { label: "is Not Visible", value: "isNotVisible" },
    { label: "Set Value", value: "setValue" },
  ];

  const [fieldDependencies, setFieldDependencies] = useState([
    { id: 1, controllerField: "", operator: "", value: "", targetField: "", action: "isEditDisable", actionValue: "" },
  ]);

  const addFieldDependency = () => {
    setFieldDependencies((prev) => [
      ...prev,
      {
        id: prev.length ? prev[prev.length - 1].id + 1 : 1,
        controllerField: "",
        operator: "",
        value: "",
        targetField: "",
        action: "isEditDisable",
        actionValue: "",
      },
    ]);
  };

  const removeFieldDependency = (index) => {
    setFieldDependencies((prev) => prev.filter((_, i) => i !== index));
  };

  const updateFieldDependency = (index, key, value) => {
    setFieldDependencies((prev) => {
      const next = [...prev];
      next[index] = { ...next[index], [key]: value };
      return next;
    });
  };

  // Apply dependencies to fieldlist in real-time
  const applyDependencyToFieldlist = (depIndex) => {
    const dep = fieldDependencies[depIndex];
    if (!dep || !dep.targetField) return;
    
    const updated = [...fieldlist];
    const idx = updated.findIndex((fld) => fld.BucketField === dep.targetField);
    if (idx === -1) return;
    
    const fld = updated[idx];
    if (dep.action === 'isEditDisable') {
      if (!dep.controllerField || !dep.operator) return;
      const op = dep.operator === '==' ? '=' : dep.operator;
      const expression = op === 'exists' ? `${dep.controllerField} exists` : `${dep.controllerField}${op}${dep.value}`;
      updated[idx] = { ...fld, isEditDisable: "1", DisableOnFieldValue: expression };
    } else {
      const newValue = dep.actionValue !== undefined && dep.actionValue !== null && dep.actionValue !== "" ? dep.actionValue : "1";
      updated[idx] = { ...fld, [dep.action]: newValue };
    }
    
    setfieldlist(updated);
  };

  // Apply dependencies to fieldlist before saving
  const applyDependenciesBeforeSave = (list) => {
    const updated = [...list];
    fieldDependencies.forEach((dep) => {
      if (!dep || !dep.targetField) return;
      const idx = updated.findIndex((fld) => fld.BucketField === dep.targetField);
      if (idx === -1) return;
      const fld = updated[idx];
      if (dep.action === 'isEditDisable') {
        if (!dep.controllerField || !dep.operator) return;
        const op = dep.operator === '==' ? '=' : dep.operator;
        const expression = op === 'exists' ? `${dep.controllerField} exists` : `${dep.controllerField}${op}${dep.value}`;
        updated[idx] = { ...fld, isEditDisable: "1", DisableOnFieldValue: expression };
      } else {
        const newValue = dep.actionValue !== undefined && dep.actionValue !== null && dep.actionValue !== "" ? dep.actionValue : "1";
        updated[idx] = { ...fld, [dep.action]: newValue };
      }
    });
    return updated;
  };

  const [dropdownList_hideConditions, setDropdownListHideConditions] = useState([]);

  const dropdownOptions = ["Option 1", "Option 2", "Option 3"]; // Common dropdown options
  const operatorOptions = ["+", "-", "*", "/", "equals", "greater", "less"]; // Common operators

  const [ruleVisibility, setRuleVisibility] = useState({});
  const [marquee_flag, setmarquee_flag] = useState(0);
  const [marquee_message, setmarquee_message] = useState();
  const [marquee_message_color, setmarquee_message_color] = useState();
  const [apiExtraDatapoints, setApiExtraDatapoints] = useState(
    fieldlist && fieldlist[0] && fieldlist[0].api_datapoints 
      ? fieldlist[0].api_datapoints 
      : [{
          flag: "",
          key: "",
          value: "",
          api_endpoints: []
        }]
  );
  const [import_config_flag, setimport_config_flag] = useState(0);
  const [saveConfigModalVisible, setSaveConfigModalVisible] = useState(false);
  const [updateInCurrentVersion, setUpdateInCurrentVersion] = useState(1); // 1 for update, 0 for new
  const [newVersionName, setNewVersionName] = useState("");
  const [versionCreationDetails, setVersionCreationDetails] = useState("");
  const handleChangepartial = (index, field, value) => {
    const newEntries = [...entries];
    newEntries[index][field] = value;
    setEntries(newEntries);
  };
  const [operation_type, setoperation_type] = useState();
  const [isAtomic, setIsAtomic] = useState("");
  const [isAggregation, setIsAggregation] = useState("");
  const [aggregation_db, setaggregation_db] = useState();
  const [aggregation_collection, setaggregation_collection] = useState();
  const [insertion_collection, setinsertion_collection] = useState();
  const [insertion_database, setinsertion_database] = useState();
  const [transactionArrayFlag, setTransactionArrayFlag] = useState();

  const [config, setConfig] = useState({});
  const [configLoading, setConfigLoading] = useState(true);
  const [activeTabs, setActiveTabs] = useState({});
  const [availableKeys, setAvailableKeys] = useState([]); // dropdown options
  const [selectedNewKey, setSelectedNewKey] = useState(""); // selected value from dropdown

  // ---- Handlers ----
  const handleFieldChange = (mainKey, field, value) => {
    setConfig((prev) => ({
      ...prev,
      [mainKey]: {
        ...prev[mainKey],
        [field]: value
      }
    }));
  };

  const handleListChange = (mainKey, section, index, value, tab = null) => {
    setConfig((prev) => {
      const updated = { ...prev };
      if (["output_projection", "labels"].includes(section)) {
        if (section === "output_projection") {
          updated[mainKey].output_projection[tab][index] = value;
        } else if (tab) {
          updated[mainKey][tab][index] = value;
        } 
      }else {
        updated[mainKey][section][index] = value;
      }
      return updated;
    });
  };

  const addListItem = (mainKey, section, tab = null) => {
    setConfig((prev) => {
      const updated = { ...prev };
      if (section === "output_projection" && tab) {
        updated[mainKey].output_projection[tab].push("");
      } else if (section === "labels" && tab) {
        // For labels, map tabs to actual fields
        const labelKey = tab === "node_labels" ? "node_labels" : "source_labels";
        if (!updated[mainKey][labelKey]) updated[mainKey][labelKey] = [];
        updated[mainKey][labelKey].push("");
      } else {
        if (!updated[mainKey][section]) updated[mainKey][section] = [];
        updated[mainKey][section].push("");
      }
      return updated;
    });
  };

    const deleteListItem = (mainKey, section, index, tab = null) => {
    setConfig((prev) => {
      const updated = { ...prev };
      if (section === "output_projection" && tab) {
        updated[mainKey].output_projection[tab].splice(index, 1);
      } else if (section === "labels" && tab) {
        const labelKey = tab === "node_labels" ? "node_labels" : "source_labels";
        if (updated[mainKey][labelKey]) {
          updated[mainKey][labelKey].splice(index, 1);
      }
      } else if (updated[mainKey][section]) {
        updated[mainKey][section].splice(index, 1);
      }
      return updated;
    });
  };

  const handleTabChange = (mainKey, section, tab) => {
    setActiveTabs((prev) => ({
      ...prev,
      [mainKey]:  {
        ...prev[mainKey],
        [section]: tab,
      },
    }));
  };

  // ---- Add new config using dropdown ----
  const addNewConfig = () => {
    if (!selectedNewKey) {
      alert("Please select a key from the dropdown!");
      return;
    }

    if (config[selectedNewKey]) {
      alert("This key already exists in the config!");
      return;
    }

    const newConfig = {
      key_to_serach_in_mongo: selectedNewKey,
      output_projection: {
        inner_collection: [],
        source_collection: []
      },
      node_labels: [selectedNewKey],
      source_labels: []
    };

    setConfig((prev) => ({
      ...prev,
      [selectedNewKey]: newConfig
    }));

    setActiveTabs((prev) => ({
      ...prev,
      [selectedNewKey]: {
        output: "inner_collection",
        label: "node_labels",
      },
    }));

    setSelectedNewKey("");
  };

   const deleteEntireConfig = (mainKey) => {
    if (!window.confirm(`Are you sure you want to delete config "${mainKey}"?`)) return;
    setConfig((prev) => {
      const updated = { ...prev };
      delete updated[mainKey];
      return updated;
    });
    setActiveTabs((prev) => {
      const updated = { ...prev };
      delete updated[mainKey];
      return updated;
    });
  };

    


  // ---- Styles ----
  const sectionStyle = {
    border: "1px solid #ccc",
    padding: "16px",
    borderRadius: "8px",
    marginBottom: "16px",
    background: "#fafafa"
  };

  const inputContainer = {
    display: "flex",
    alignItems: "center",
    marginBottom: "10px"
  };

  const inputStyle = {
    padding: "8px",
    marginTop: "4px",
    marginBottom: "12px",
    width: "90%",
    borderRadius: "4px",
    border: "1px solid #ccc"
  };

  const deleteBtnStyle = {
    marginLeft: "8px",
    background: "#dc3545",
    color: "white",
    border: "none",
    padding: "6px 10px",
    borderRadius: "4px",
    cursor: "pointer"
  };

  const buttonStyle = {
    background: "#007bff",
    color: "white",
    padding: "6px 12px",
    border: "none",
    borderRadius: "4px",
    cursor: "pointer",
    marginTop: "6px"
  };

  const tabButtonStyle = (tab, activeTab) => ({
    padding: "6px 12px",
    marginRight: "6px",
    border: "1px solid #ccc",
    borderBottom: activeTab === tab ? "2px solid #007bff" : "1px solid #ccc",
    background: activeTab === tab ? "#e8f0fe" : "#f9f9f9",
    cursor: "pointer",
    borderRadius: "4px 4px 0 0"
  });

  const configHeaderStyle = {
    display: "flex",
    justifyContent: "space-between",
    alignItems: "center",
    marginBottom: "12px"
  };


  // Add a new entry
  const addEntry = () => {
    setEntries([...entries, { partialfield: "", defaultvalue: "" }]);
  };

  // Remove an entry
  const removeEntry = (index) => {
    const newEntries = entries.filter((_, i) => i !== index);
    setEntries(newEntries);
  };

  useEffect(() => {
    if (selectedFieldForPartial.length == 0) {
      setFieldForPartialSubmit(fieldlist);
    }
  }, [fieldlist]);

  const handleAddConfig = () => {
    setConfigurations([
      ...configurations,
      {
        name: "",
        color: "#000",
        items: [{ dropdown1: "", operator: "", dropdown2: "" }],
      },
    ]);
  };

  const handleAddupdateConfig = () => {
    setconditional_update([
      ...conditional_update,
      {
        field: "",
        operator: "",
        condition_value: "",
        check_data_from: "",
        fields_to_update: [
          { field_name: "", field_value: "" }
        ]
      },
    ]);
  };

  const handleValueChange = (value) => {
    const parts = value.split('-');
    const number = parts[0];
    const type = parts[1]; // You might use this later

    setdisableedit(prevData => {
      if (type === '0') { // Remove logic
        return prevData.filter(item => item !== number);
      } else if (type === '1') { // Add/Update logic
        if (prevData.includes(number)) {
          return prevData; // If already present, do nothing or update if needed
        } else {
          return [...prevData, number];
        }
      } else {
        return prevData;
      }
    });
  };

  const handleRemoveConfig = (index) => {
    const newConfigurations = [...configurations];
    newConfigurations.splice(index, 1);
    setConfigurations(newConfigurations);
  };
  const handleRemoveupdateConfig = (index) => {
    const newConfigurations = [...conditional_update];
    newConfigurations.splice(index, 1);
    setconditional_update(newConfigurations);
  };

  const handleAddItem = (configIndex) => {
    const newConfigurations = [...configurations];
    newConfigurations[configIndex].items.push({
      dropdown1: "",
      operator: "",
      dropdown2: "",
    });
    setConfigurations(newConfigurations);
  };
  const handleAddupdateItem = (configIndex) => {
    const newConfigurations = [...conditional_update];
    newConfigurations[configIndex].fields_to_update.push({
      field_name: "",
      field_value: "",
    });
    setconditional_update(newConfigurations);
  };

  const handleRemoveItem = (configIndex, itemIndex) => {
    const newConfigurations = [...configurations];
    newConfigurations[configIndex].items.splice(itemIndex, 1);
    setConfigurations(newConfigurations);
  };
  const handleRemoveupdateItem = (configIndex, itemIndex) => {
    const newConfigurations = [...conditional_update];
    newConfigurations[configIndex].fields_to_update.splice(itemIndex, 1);
    setconditional_update(newConfigurations);
  };

  const handleInputChange = (configIndex, field, value) => {
    const newConfigurations = [...configurations];
    newConfigurations[configIndex][field] = value;
    setConfigurations(newConfigurations);
  };
  const handleInputupdateChange = (configIndex, field, value) => {
    const newConfigurations = [...conditional_update];
    newConfigurations[configIndex][field] = value;
    setconditional_update(newConfigurations);
  };

  const handleItemChange = (configIndex, itemIndex, field, value) => {
    const newConfigurations = [...configurations];
    newConfigurations[configIndex].items[itemIndex][field] = value;
    setConfigurations(newConfigurations);
  };
  const handleItemupdateChange = (configIndex, itemIndex, field, value) => {
    const newConfigurations = [...conditional_update];
    newConfigurations[configIndex].fields_to_update[itemIndex][field] = value;
    setconditional_update(newConfigurations);
  };
  const [status_control_async_flag, setStatus_control_async_flag] = useState();
  const api_input_type = [
    { option: "JSON", value: "json" },
    { option: "Date", value: "date" },
    { option: "Date Time", value: "datetime" },
    { option: "Text", value: "text" },
    { option: "INT", value: "int" },
  ];

  const [jsonFormBuild, setJsonFormBuild] = useState([]);
  const [payloadPathKeys, setPayloadPathKeys] = useState();
  const [openviewin, setOpenviewin] = useState("");
  const [branch_list, setbranch_list] = useState([]);
  const [branch_id, setbranch_id] = useState();
  const [conditionformbutton, setconditionformbutton] = useState("");
  const [fetchdatafrom, setfetchdatafrom] = useState("");
  const [pilotView, setPilotView] = useState("");
  const [pilotviewobjectid, setPilotviewobjectid] = useState("");
  const [pilotViewButtonName, setPilotViewButtonName] = useState("");

  useEffect(() => {
    console.log('form_view', view_list)
    let apitoken = localStorage.getItem("api_token");

    const view_id =
      props.location && props.location.state.view_id != ""
        ? props.location.state.view_id
        : agg_view;
    console.log("agg_view--", view_id);
    // if (agg_view != null) {
    //   if (!view_id) {
    //     setview_id(agg_view);
    //   }
    // }

    if (branch_list.length == 0) {
      sendRequest(
        {
          url: `${process.env.REACT_APP_BASE_URL}/get/data?flag=getallbranches`,
          method: "GET",
          headers: {
            "api-token": apitoken,
          },
        },
        (response) => {
          console.log("branch_list", response.data);
          setbranch_list(response.data);
        }
      );
    }
    if (!view_list) {
      sendRequest(
        {
          //At-2143||rohit chitampalle||api-restructuring-and-connection

          url: `${process.env.REACT_APP_BASE_URL}/get/webhook/configuration/data`,
          method: "GET",
          //data: inputdata,
          headers: {
            "api-token": apitoken,
          },
        },
        (response) => {
          console.log("setviewList", response);
          setview_list(response);
          //setjiraTicket(response);
        }
      );
    }
    if (!bucket_list) {
      sendRequest(
        {
          url: `${process.env.REACT_APP_BASE_URL}/payload/getcollections`,
          method: "POST",
          //data: inputdata,
          headers: {
            "Content-Type": "application/json",
            "api-token": apitoken,
          },
        },
        (response) => {
          setbucket_list(response);
          //setjiraTicket(response);
        }
      );
    }
    if (!effetive_designation_idList) {
      sendRequest(
        {
          url: `${process.env.REACT_APP_BASE_URL}/get/designation/list`,
          method: "GET",
          //data: inputdata,
          headers: {
            "api-token": apitoken,
          },
        },
        (response) => {
          seteffetive_designation_idList(response);
          //setjiraTicket(response);
        }
      );
    }
    if (!resondropdownlist) {
      // Ensure dropdownlistid is processed as an array
      const dropdownIds = Array.isArray(filteredservice_id) ? filteredservice_id : [filteredservice_id];

      //dropdownIds.forEach((id) => {
      sendRequest(
        {
          url: `${process.env.REACT_APP_BASE_URL}/get/dropdown/list`,
          method: "GET",
          //data: inputdata,
          headers: {
            "api-token": apitoken,
          },
        },
        (response) => {
          console.log("resondropdownlist", response);
          // if (filteredservice_id.length > 0) {
          //   const filteredData3 = response.filter((item) =>
          //     filteredservice_id.includes(item.dropdown_id)
          //   );
          //   setresondropdownlist((prev) => [...(prev || []), ...filteredData3]); // Merge responses for multiple dropdowns
          // } else {
          //   setresondropdownlist((prev) => [...(prev || []), ...response]); // Handle non-filtered data
          // }
          setresondropdownlist(response);
          //setjiraTicket(response);
        }
      )
      //})
    }

    // const { view_id } = (props.location && props.location.state) || agg_view;
    if (view_id && fieldlist.length == 1 && (jsonFormBuild && jsonFormBuild.length == 0)) {
      //Ankur Makavana | 04-08-2023 | Disable Bucket, Event and Designation id on edit

      setview_id(view_id);
      const formdata = new FormData();
      // formdata.append("id", view_id);
      sendRequest(
        {
          url:
            `${process.env.REACT_APP_BASE_URL}/get/webhook/configuration/data?id=` +
            view_id,
          method: "GET",
          headers: {
            "api-token": apitoken,
          },
        },
        (response) => {
          console.log("field_mappingg", response[0].field_mapping);
          setcomponent_mapping(response[0].component_mapping);
          response[0].field_mapping.map((item) => {
            // console.log(item.hasOwnProperty("showLabel"));
            if (!item.hasOwnProperty("showLabel")) {
              item.showLabel = "1";
            }
          });

          props.location.state.fieldslist = response[0].field_mapping;
          // console.log(props.location.state);
          let url = "";
          let form;
          let outputformat = "";
          if (response[0].payload_type == payloadTypeOptions.MongoDB || response[0].getpayloadfields) {
            outputformat = response[0].payloaddataoutputformat;
            const stateArray = [];
            const restArray = [];
            let originalArray = JSON.parse(
              response[0].getpayloadfields
                ? response[0].getpayloadfields
                : response[0].search_by_pair
            );
            originalArray.forEach((item) => {
              if (item[0] == "processed") {
                stateArray.push(item);
              } else {
                restArray.push(item);
              }
            });
            // console.log("restArray->", restArray);
            const convertedArray = originalArray.map((subArray) => {
              return [subArray[0], subArray[1], subArray[2]];
            });
            url = `${process.env.REACT_APP_BASE_URL}/mongo/get/${response[0].db_namegetpayload}/${response[0].collection_namegetpayload}?limit=1&offset=0`;
            form = convertedArray;
            console.log("form_convertedArray", form);
          } else if (response[0].payload_type == payloadTypeOptions.Bucket) {
            console.log("response[0].payload_type->", response[0].payload_type);
            url = `${process.env.REACT_APP_BASE_URL}/payload/get/${response[0].bucket_name}?limit=1`;

            form = JSON.stringify([
              [response[0].event_location, "==", response[0].event_name],
            ]);
            //}
          } else if (response[0].payload_type == payloadTypeOptions.API) {
            console.log("response[0].payload_type", response);
            if (response[0].payloadfields[0].url_type == select_url_type.Without_base_url) {
              url = `${process.env.REACT_APP_BASE_URL}/${response[0].payloadfields[0].api_url}`;
            } else {
              url = response[0].payloadfields[0].api_url;
            }
            outputformat = response[0].payloadfields[0].outputformat;
            const api = response[0].payloadfields[0];
            form = new FormData();

            api.formdata.forEach((item) => {
              form.append(item.formdatakey, item.formdatavalue);
            });
          }
          let apitoken = localStorage.getItem("api_token");
          sendRequest(
            {
              url: url,
              method: "POST",
              data: form,
              headers: {
                "Content-Type": "application/json",
                "api-token": apitoken,
              },
            },
            (json) => {
              if (json.length > 0) {
                let response;
                if (outputformat) {
                  response = getNestedValue(json, outputformat);
                  if (!Array.isArray(response)) {
                    response = [response];
                  }
                } else {
                  response = json;
                }
                //setgetfields(response);
                console.log("response", response);

                var jsonkey = Object.keys(response);

                const childKey = jsonkey[0];
                setfields_array(response[childKey]);
                setfields_array_payload(response[childKey]);

                setdefault_payload(response);
                const childData = response[childKey];
                if (childData) {
                  setapi_fields_list(Object.keys(childData));
                  setapi_fields_payload(Object.keys(childData));
                }
              }
            }
          );          
          updateresponsetostate(response);
        }
      );
      filteroutput();
      const form_data = JSON.stringify([["source_view_id", "==", view_id]]);
      sendRequest({
        method: "POST",
        data: form_data,
        url: `${process.env.REACT_APP_BASE_URL}/mongo/get/configuration_master/view_version_history`,
        headers: {
          "api-token": apitoken,
        },
      }).then((response) => {
        setVersionData(response);
        if (response.length == 0) {          
          setUpdateInCurrentVersion(0);
        }
      });
    }
    if (fieldlist) {
      //filterissearch();
      const filtersearch = fieldlist.filter((item) => item.isSearch === "1");
      const extractedDataArray = [];

      filtersearch.forEach((item) => {
        console.log("extractedDataArray_", item);
        const name = item.BucketField;
        const label = item.fieldname;
        const datatype = item.datatype;
        if (item.datatype == "dropdownlist") {
          setisDropdown(item.dropdownlist);
          const valueEditorType = "select";
          const values = dropdownResponse;
          extractedDataArray.push({ name, label, valueEditorType, values });
        } else if (item.BucketField == "service_id") {
          setisservice_id(true);
          const valueEditorType = "select";
          const values = service_idResponse;
          extractedDataArray.push({ name, label, valueEditorType, values });
        }
        // Push the extracted data as an object into the array
        else {
          let operators = datatype === 'date' ? dateOperators : Operators
          extractedDataArray.push({ name, label, datatype, operators });
        }
      });
      console.log("extractedDataArray", extractedDataArray);

      setsearch_fields(extractedDataArray);
    }
    // if (query) {
    //   const updatedData = [...fieldlist];
    //   let search_condition = [];
    //   updatedData.zz = query;
    //   //updatedData.push(search_condition);
    //   console.log("query-->", updatedData);

    //   //setfieldlist(updatedData);
    // }
    if (query) {
      let mongoquery = formatQuerybuild(query);
      console.log("mongoquery->", query);
    }
  }, [fieldlist, query, agg_view]);
  useEffect(() => {
    if (view_version && versionData.length>0) {
      const filtered = versionData.filter(i => i.version == view_version);
      if(filtered.length > 0){
        setNewVersionName(filtered[0].version_name);
        if (filtered[0].updated_by_name) {
          setupdated_by(filtered[0].updated_by_name);
        }
      }
      updateresponsetostate(filtered);
    }
  }, [view_version,versionData])
  const updateresponsetostate = (response) => {    setfetch_onload(response[0].fetch_onload);
          if (response[0].queue_flag !== undefined) {
            setqueue_flag(response[0].queue_flag);
          } else {
            setqueue_flag("false"); // Set default value if undefined
          }
          if (response[0].operation_type !== undefined) {
            setoperation_type(response[0].operation_type);

            if (response[0].insertion_collection !== undefined)
            {
              setinsertion_collection(response[0].insertion_collection);
            }
            else{
              setinsertion_collection("");
            }

              if (response[0].insertion_database !== undefined)
            {
              setinsertion_database(response[0].insertion_database);
            }
            else{
              setinsertion_database("");
            }

            if (response[0].isAtomic !== undefined)
            {
              setIsAtomic(response[0].isAtomic);
            }
            else{
              setIsAtomic("");
            }

            if (response[0].isAggregation !== undefined)
            {
              setIsAggregation(response[0].isAggregation);

              if (response[0].aggregation_db !== undefined)
              {
                setaggregation_db(response[0].aggregation_db);
              }

              if (response[0].aggregation_collection !== undefined)
              {
                setaggregation_collection(response[0].aggregation_collection);
              }
            }
            if (response[0].useOldTransactionsArray !== undefined)
            {
              setTransactionArrayFlag(response[0].useOldTransactionsArray.toString());
            }
            else{
              setTransactionArrayFlag("");
            }



            
          } else {
            setoperation_type(""); // Set default value if undefined
          }

          console.log("history_config", response[0].history_config);
          if(response[0].history_config)
          {
            setConfig(response[0].history_config);
            const tabs = {};
            const labelTabDefaults = {};
            Object.keys(response[0].history_config).forEach((key) => {
              tabs[key] = { output: "inner_collection", label: "node_labels" };
            });
            setActiveTabs(tabs);
            // const clickableKeys = response[0].field_mapping
            //   .filter((item) => item.isClickable === "1")
            //   .map((item) => item.BucketField);

            // setAvailableKeys(clickableKeys);

          }
    if (response[0].record_per_call) {
      setrecord_per_call(response[0].record_per_call);
    }
    if (response[0].hide_loadmore) {
      sethide_loadmore(response[0].hide_loadmore);
    }
          if (response[0].hide_pagination) {
            sethide_pagination(response[0].hide_pagination);
          }
    if (response[0].get_data_by) {
      setget_data_by(response[0].get_data_by);
    }
    if (response[0].hide_filter) {
      sethide_filter(response[0].hide_filter);
    }
    if (response[0].hide_exportBtn) {
      sethide_exportBtn(response[0].hide_exportBtn);
    }
    if (response[0].hide_filter) {
      sethide_filter(response[0].hide_filter);
    }
    if (response[0].branch_id) {
      setbranch_id(response[0].branch_id);
    }
    setpayloaddataoutputformat(response[0].payloaddataoutputformat);
    setsourcedataoutputformat(response[0].sourcedataoutputformat);
    setoutputfilter(response[0].outputfilter);
    if (response[0].setupdated_at) {
      setsetupdated_at(response[0].setupdated_at);
    }
          if (response[0].setcreated_at) {
            setsetcreated_at(response[0].setcreated_at);
          }
    if (response[0].reload_api_data) {
      setreload_api_data(response[0].reload_api_data);
    }
          if (response[0].show_action_column) {
            setshow_action_column(response[0].show_action_column);
          }
    if (response[0].updated_at) {
      setupdated_at_timestamp(response[0].updated_at);
    }
    setbucket_name(response[0].bucket_name);
    setevent_name(response[0].event_name);
    setevent_location(response[0].event_location);
    if (!view_name) {
      setview_name(response[0].view_name);
    }
    setview_version(response[0].version);
    setselect_payload(response[0].payload_type);
    if (!effetive_designation_id) {
      seteffetive_designation_id(response[0].effective_designation_id);
    }
    if (import_config_flag == 0) {
      setfieldlist(response[0].field_mapping);
          if (response[0].api_datapoints) {
            setApiExtraDatapoints(response[0].api_datapoints);
          }
    }
    if (response[0].api_datapoints) {
      setApiExtraDatapoints(response[0].api_datapoints);
    }
    if (response[0].selected_views) {
      const savedViews = JSON.parse(response[0].selected_views);
      setSelectedViews(savedViews.map(view => ({
        value: view.view_id,
        view_id: view.view_id,
        view_name: view.view_name
      })));
    }

    if (response[0].field_mapping[0].sum_config) {
      setConfigurations(response[0].field_mapping[0].sum_config);
    }
    if (response[0].field_mapping[0].conditional_update) {
      setconditional_update(response[0].field_mapping[0].conditional_update);
    }
    if (response[0].field_mapping[0].disableedit) {
      setdisableedit(response[0].field_mapping[0].disableedit);
    }
    if (response[0].field_mapping[0].entries) {
      setEntries(response[0].field_mapping[0].entries);
    }
    // if (response[0].action_mapping) {
    //   setJsonFormBuild(response[0].form_mapping || {});
          // setDivs(response[0].action_mapping);
    // }
          setJsonFormBuild(response[0].form_mapping);
    setdatasource(response[0].datasource);
    setpayloadfields(response[0].payloadfields);
    setapidata(response[0].get_api_mapping);
    setQuery(response[0].field_mapping[0].search_query);
    if (response[0].field_mapping[0].search_query) {
      const allRules = extractAllRules(
        response[0].field_mapping[0].search_query.rules
      );
      const groupedData = Object.values(groupData(allRules));
      console.log("ConfigFormRenderer", groupedData);
      setallRules(groupedData);
    }
    seteditsearchKey(response[0].getpayloadfields);
    setdb_name(response[0].db_name);
    if (response[0].db_namegetpayload) {
      setdb_namegetpayload(response[0].db_namegetpayload);
    } else {
      setdb_namegetpayload(response[0].db_name);
    }
    if (!view_type) {
      setview_type(response[0].view_type);
    }
    if (commit_type === "1" || "0") {
      setcommit_type(response[0].commit_type);
    }
    if (response[0].marquee_flag) {
      setmarquee_flag(response[0].marquee_flag);
    }
    if (response[0].marquee_message) {
      setmarquee_message(response[0].marquee_message);
    }
    if (response[0].marquee_message_color) {
      setmarquee_message_color(response[0].marquee_message_color);
    }
    if (response[0].agg_view) {
      setagg_view(response[0].agg_view);
    }
    if (response[0].isexpand) {
      setisexpand(response[0].isexpand);
    }
          if (response[0].form_view) {
            setform_view(response[0].form_view);
          }
          if (response[0].formview) {
            setformview(response[0].formview);
          }
          if (response[0].openviewin) {
            setOpenviewin(response[0].openviewin);
          }
          if (response[0].conditionformbutton) {
            setconditionformbutton(response[0].conditionformbutton);
          }
          // if (response[0].conditionSets) {
          //   const parsedArray = JSON.parse(response[0].conditionSets);
          //   setConditionSets(parsedArray);
          // }
          if (response[0].fieldDependencies) {
            const parsedArray = JSON.parse(response[0].fieldDependencies);
            setFieldDependencies(parsedArray);
          }
          if (response[0].dropdownList_hideConditions) {
            setDropdownListHideConditions(response[0].dropdownList_hideConditions);
          }
          if (response[0].fetchdatafrom) {
            setfetchdatafrom(response[0].fetchdatafrom);
          }
          setcollection_name(response[0].collection_name);
          if (response[0].collection_namegetpayload) {
            setcollection_namegetpayload(response[0].collection_namegetpayload);
          } else {
            setcollection_namegetpayload(response[0].collection_name);
          }
          if(response[0].status_control_async_flag) {
            setStatus_control_async_flag(response[0].status_control_async_flag);
          }
    if (response[0].getpayloadfields) {
      //if (response[0].payload_type == "M") {
      const stateArray = [];
      const restArray = [];
      let originalArray = JSON.parse(response[0].getpayloadfields);
      console.log("originalArray", originalArray);
      originalArray.forEach((item) => {
        if (item[0] == "processed") {
          stateArray.push(item);
        } else {
          restArray.push(item);
        }
      });
      const convertedArray = restArray.map((subArray) => {
        console.log("restArray->", subArray);
        return {
          searchKey: subArray[0],
          operator: subArray[1],
          searchValue: subArray[2],
          inputType: subArray[3],
        };
      });
      setsearchKeygetpayloadfields(convertedArray);
      // } else {
      //   setsearchKeygetpayloadfields(response[0].getpayloadfields);
      // }
    }
    if (response[0].search_by_pair) {
      if (response[0].payload_type == payloadTypeOptions.MongoDB) {
        const stateArray = [];
        const restArray = [];
        let originalArray = JSON.parse(response[0].search_by_pair);
        originalArray.forEach((item) => {
          if (item[0] == "processed" && item[1] == "exists") {
            stateArray.push(item);
          } else {
            restArray.push(item);
          }
        });
        const convertedArray = restArray.map((subArray) => {
          console.log("restArray->", subArray);
          return {
            searchKey: subArray[0],
            operator: subArray[1],
            searchValue: subArray[2],
            inputType: subArray[3],
          };
        });
        setsearchKey(convertedArray);
        stateArray &&
                stateArray.length > 0 &&
                setprocessedis(stateArray[0][2]);
        console.log("convertedArray-->", convertedArray);
      } else {
        const searchByPair = JSON.parse(response[0].search_by_pair);
        const hasValue = searchByPair.some((pair) =>
          pair.some((value) => value !== "")
        );

        if (hasValue) {
          setsearchKey(response[0].search_by_pair);
        } else {
          setsearchKey([]);
        }
      }
    }
          if(response[0].pilotView === "1") {
            setPilotView(response[0].pilotView);
            setPilotviewobjectid(response[0].pilotviewobjectid);
          }
          if(response[0].pilotView === "1") {
            setPilotView(response[0].pilotView);
            setPilotViewButtonName(response[0].pilotViewButtonName);
          }
  }

  useEffect(() => {
    if (isDropdown) {
      getDataFromApi(isDropdown);
    }
  }, [isDropdown]);

  useEffect(() => {
    if (isservice_id) {
      getDataFromisservice_idApi();
    }
  }, [isservice_id]);

  const getDataFromisservice_idApi = async () => {
    let apitoken = localStorage.getItem("api_token");
    const form = JSON.stringify([["processed", "exists", "false"]]);
    const url = `${process.env.REACT_APP_BASE_URL}/mongo/get/configuration_master/service_configuration`;
    sendRequest(
      {
        url: url,
        method: "POST",
        data: form,
        headers: {
          "Content-Type": "application/json",
          "api-token": apitoken,
        },
      },
      (json) => {
        const transformedData = json.map((item) => ({
          label: item.service,
          name: item.service,
          dropdown_id_from_mysql: item.dropdown_id_from_mysql,

        }));
        setservice_idResponse(transformedData);
      }
    );
  };

  const getDataFromApi = async (dropdownlistid) => {
    let apitoken = localStorage.getItem("api_token");
    const dropdownIds = Array.isArray(dropdownlistid) ? dropdownlistid : [dropdownlistid];
    dropdownIds.forEach((id) => {
      sendRequest(
        {
          url:
            `${process.env.REACT_APP_BASE_URL}/get/dropdown/item/list?dropdown_id=` +
            id,
          method: "GET",
          //data: inputdata,
          headers: {
            "Content-Type": "application/json",
            "api-token": apitoken,
          },
        },
        (response) => {
          //setndid(response[0].vendor_id);
          //setjiraTicket(response);
          const transformedData = response.map((item) => ({
            label: item.item_name,
            name: item.item_value,
          }));
          console.log("dropdownlist", transformedData);
          setdropdownResponse((prev) => [...(prev || []), ...transformedData]);
        }
      );
    });
  };

  // useEffect(() => {
  //   const shouldUpdateColors = Object.values(colorPickers).every((picker) => !picker.display);
  
  //   if (!shouldUpdateColors) {
  //     return;
  //   }
  
  //   const updatedColors = {};
  
  //   query.rules.forEach((rule, index) => {
  //     if (rule.rules) {
  //       rule.rules.forEach((innerRule, innerIndex) => {
  //         const key = `${index}-${innerIndex}`;
  //         updatedColors[key] = {
  //           color: innerRule.color || "#ffffff",
  //           display: (colorPickers[key] && colorPickers[key].display) || false,
  //         };
  //       });
  //     } else {
  //       updatedColors[index] = {
  //         color: rule.color || "#ffffff",
  //         display: (colorPickers[index] && colorPickers[index].display) || false,
  //       };
  //     }
  //   });
  
  //   setColorPickers(updatedColors);
  // }, [query]);    

  // const filterissearch = () => {
  useEffect(() => {
    if (db_name && db_list) {
      console.log("call db name");
      getcollection(db_name);
    }
    if (db_namegetpayload && db_list) {
      console.log("call db name");
      getpayloadfieldscollection(db_namegetpayload);
    }
  }, [db_name, db_list, db_namegetpayload]);
  useEffect(() => {
    let apitoken = localStorage.getItem("api_token");
    sendRequest(
      {
        url: `${process.env.REACT_APP_BASE_URL}/mongo/list`,
        method: "POST",
        headers: {
          "api-token": apitoken,
        },
      },
      (response) => {
        setdb_list(response);
      } 
    );
   
    if (document.readyState === "complete") {
      if (selectedviewOption) {
        copydata();
      }
      else {
window.addEventListener("load", copydata)
    }    }
   },[]);
const copydata = () => {
  if (checkboxcopyoption.configHeader ==true) {
    setview_name(selectedviewOption.view_name);
    seteffetive_designation_id(selectedviewOption.effective_designation_id);
    setselect_payload(selectedviewOption.payload_type);
    setrecord_per_call(selectedviewOption.record_per_call);
  }
  if (checkboxcopyoption.dataSource == true ) {
    setdb_name(selectedviewOption.db_name);
    setcollection_name(selectedviewOption.collection_name);
    setdatasource(selectedviewOption.datasource);
    setpayloadfields(selectedviewOption.payloadfields);
    setdb_namegetpayload(selectedviewOption.db_namegetpayload);
    setOperators(selectedviewOption.Operators);
    setsourcedataoutputformat(selectedviewOption.sourcedataoutputformat);
    setoutputfilter(selectedviewOption.outputfilter);
    setfieldlist(selectedviewOption.field_mapping);
    var validJsonStr = selectedviewOption && selectedviewOption.search_by_pair
    ? selectedviewOption.search_by_pair.replace(/'/g, '"') 
    : "[]";
    var array = [];
    if (typeof validJsonStr === "string"  && validJsonStr && validJsonStr.trim().length > 0)
    {
      array = JSON.parse(validJsonStr);
    }
    if (array) {
            if (selectedviewOption.payload_type == "M") {
              const stateArray = [];
              const restArray = [];
              let originalArray = JSON.parse(selectedviewOption.search_by_pair);
              originalArray.forEach((item) => {
                if (item[0] == "processed") {
                  stateArray.push(item);
                } else {
                  restArray.push(item);
                }
              });
              console.log("Rest123:", restArray);
              const convertedArray = restArray.map((subArray) => {
                return {
                  searchKey: subArray[0],
                  operator: subArray[1],
                  searchValue: subArray[2],
                  inputType: subArray[3],
                };
              });
              setsearchKey(convertedArray);
            } else {
              var searchByPair=[]
              if (typeof selectedviewOption === "string"  && selectedviewOption && selectedviewOption.trim().length > 0)
                {
                  searchByPair= JSON.parse(selectedviewOption.search_by_pair);
                }
              const hasValue = searchByPair.some((pair) =>
                pair.some((value) => value !== "")
              );
              if (hasValue) {
                setsearchKey(selectedviewOption.search_by_pair);
              } else {
                setsearchKey([]);
              }
            }
          }
    const validJsonPayloadField =selectedviewOption && selectedviewOption.search_by_pair
    ? selectedviewOption.search_by_pair.replace(/'/g, '"') 
    : "[]";
    let getarray=[]
    if (validJsonPayloadField && validJsonPayloadField.trim().length > 0)
    {
    getarray = JSON.parse(validJsonPayloadField);
    }
          let url = "";
          let form;
          let outputformat = "";
    if (selectedviewOption.payload_type == "M" || getarray) {
           outputformat = selectedviewOption.payloaddataoutputformat;
            const stateArray = [];
            const restArray = [];
            let originalArray= JSON.parse(
              validJsonPayloadField
                ? validJsonPayloadField
                : selectedviewOption.search_by_pair
            );
            originalArray.forEach((item) => {
              if (item[0] == "processed") {
                stateArray.push(item);
              } else {
                restArray.push(item);
              }
            });
            const convertedFeild = restArray.map((subArray) => {
              return {
                searchKey: subArray[0],
                operator: subArray[1],
                searchValue: subArray[2],
                inputType: subArray[3],
              };
            });
            setsearchKeygetpayloadfields(convertedFeild);
            const convertedArray = originalArray.map((subArray) => {
              return [subArray[0], subArray[1], subArray[2]]
            });
            url = `${process.env.REACT_APP_BASE_URL}/mongo/get/${selectedviewOption.db_namegetpayload}/${selectedviewOption.collection_namegetpayload}?limit=1&offset=0`;
            form = convertedArray;          
          } else if (selectedviewOption.payload_type == "B") {
            url = `${process.env.REACT_APP_BASE_URL}/payload/get/${selectedviewOption.bucket_name}?limit=1`;
            form = JSON.stringify([
              [selectedviewOption.event_location, "==", selectedviewOption.event_name],
            ]);
          } else if (selectedviewOption.payload_type == "A") {
            if (getarray[0].url_type == "N") {
              url = `${process.env.REACT_APP_BASE_URL}/${getarray[0].api_url}`;
                            console.log("url 5:", url)
            } else {
              url = getarray[0].api_url;
            }
            outputformat = getarray[0].outputformat;
            const api = getarray[0];
            form = new FormData();
            api.formdata.forEach((item) => {
            form.append(item.formdatakey, item.formdatavalue);
            });
          }          
        } 
  if (checkboxcopyoption.actionApi == true) {
    setDivs(selectedviewOption.action_mapping);
    setdatasource(selectedviewOption.datasource);
    setpayloadfields(selectedviewOption.payloadfields);
    setapidata(selectedviewOption.get_api_mapping);
    setfieldlist(selectedviewOption.field_mapping);
    setevent_name(selectedviewOption.event_name);
    setevent_location(selectedviewOption.event_location);
    setfetch_onload(selectedviewOption.fetch_onload);
  }
 if(checkboxcopyoption.getAPI){
  setpayloadfields(selectedviewOption.payloadfields);
}
}
  useEffect(() => {
    setQuerydata(query);
  }, [service_idResponse]);
  useEffect(() => {
    const updatedData = [...fieldlist];
    if (updatedData.length > 0) {
      updatedData[0].search_query = query;
      setfieldlist(updatedData);
    }
  }, [query]);
  // };
  useEffect(() => {
    const payload_PathKeys = getDotSeparatedKeys(default_payload[0])
    console.log('payloadPathKeys', payloadPathKeys)
    if (payloadPathKeys !== payload_PathKeys) {
      setPayloadPathKeys(payload_PathKeys)
    }
  }, [default_payload])


  useEffect(() => {
    getFormView();
  }, [view_id, view_list])

  const handleAddDiv = () => {
    const newId = divs.length + 1;
    setDivs([
      ...divs,
      {
        id: newId,
        action_name: "",
        api_url: "",
        output_path: "",
        formdata: [
          {
            id: 1,
            formdatakey: "",
            formdatavalue: "",
            inputtype: "text",
            defaultvalue: "",
          },
        ],
        inputType: "formdata",
        formrow: "",
        action_event: "",
        url_type: "",
      },
    ]);
  };
  const handleAddApidata = () => {
    const newId = apidata.length + 1;
    setapidata([
      ...apidata,
      {
        id: newId,
        action_name: "",
        api_url: "",
        output_path: "",
        formdata: [
          { id: 1, formdatakey: "", formdatavalue: "", defaultvalue: "" },
        ],
        outputdata: [{ id: 1, outputkey: "", outputvalue: "" }],
        tabledata: [{ id: 1, tablekey: "", tablevalue: "" }],
        inputType: "",
        formrow: "",
        getoutputdata: "",
        output_path: "",
      },
    ]);
  };

  const handleAddsearch = () => {
    setsearchKey([
      ...searchKey,
      { searchKey: "", operator: "", searchValue: "", inputType: "string" },
    ]);
  };
  const handleAddpayloadfieldssearch = () => {
    setsearchKeygetpayloadfields([
      ...searchKeygetpayloadfields,
      { searchKey: "", operator: "", searchValue: "", inputType: "string" },
    ]);
  };

  const handleFormBuilderPost = (data) => {
    console.log('handleFormBuilderPost', data)
    setJsonFormBuild((prev) => {
      return data.task_data;
    });
  }

  function getDotSeparatedKeys(obj, prefix = '') {
    const keys = [];
    for (const key in obj) {
      const fullKey = prefix ? `${prefix}.${key}` : key;
      if (Array.isArray(obj[key])) {
        keys.push(fullKey);
        // If you want dot-separated keys inside array elements, iterate them
        obj[key].forEach((item, index) => {
          if (typeof item === 'object' && item !== null) {
            keys.push(...getDotSeparatedKeys(item, `${fullKey}.${index}`));
          }
        });
      } else if (typeof obj[key] === 'object' && obj[key] !== null) {
        keys.push(...getDotSeparatedKeys(obj[key], fullKey));
      } else {
        keys.push(fullKey);
      }
    }
    return keys;
  }

  const handleAddfield = () => {
    // setfieldlist([
    //   ...fieldlist,
    //   {
    //     fieldname: "",
    //     BucketField: [{ id: 1, BuckeSubtField: [{ id: 0, value: "" }] }],
    //   },
    // ]);
    setfieldlist([
      ...fieldlist,
      {
        fieldname: "",
        BucketField: "",
        isEdit: "0",
        isRequired: "0",
        isVisible: "1",
        defaultfilter: "",
        addapi: "0",
        datatype: "textbox",
        showLabel: "1",
        dropdownlist: "",
        Downloadfile: "",
        isSearch: "0",
        productlist: "",
        tenure: "",
        productid: "",
        massupdate: "0",
        isConfirm: "0",
        isEditDisable: "0",
        isRedirect: "0",
        RedirectData: "path:'',requiredata:[]",
        RedirectCondition: "",
        //DisableOnField: "",
        DisableOnFieldValue: "",
        FieldLength: "",
        FieldLengthErrorMessage: "",
        FileType: "",
        FileSize: "",
        FilePath: "",
        FileName: "",
      },
    ]);

    var jsonkey = Object.keys(default_payload);

    const childKey = jsonkey[0];
    const childData = default_payload[childKey];
    setfields_array(childData);
    setapi_fields_list(Object.keys(childData));

    props.location.state &&
      props.location.state.fieldslist.push({
        fieldname: "",
        BucketField: "",
        isEdit: "0",
        isRequired: "0",
        isVisible: "1",
        defaultfilter: "",
        addapi: "0",
        datatype: "textbox",
        showLabel: "1",
        massupdate: "0",
        isConfirm: "0",
        isEditDisable: "0",
        isRedirect: "0",
        RedirectData: "path:'',requiredata:[]",
        RedirectCondition: "",
        //DisableOnField: "",
        DisableOnFieldValue: "",
        FieldLength: "",
        FieldLengthErrorMessage: "",
      });
  };
  //  let api_header = 2;
  const handleAddheaderfield = (api_index) => {
    // const api = divs[api_index];
    // const newFormID = api.formdata.length + 1;
    // const newForm = { id: newFormID, formdatakey: "", formdatavalue: "" };
    // const newFormdata = [...api.formdata, newForm];
    // const updatedApi = { ...api, formdata: newFormdata };
    // setDivs([
    //   ...divs.slice(0, api_index),
    //   updatedApi,
    //   ...divs.slice(api_index + 1),
    // ]);

    const api = divs[api_index];
    const newFormID = api.formdata.length + 1;
    const newForm = { id: newFormID, formdatakey: "", formdatavalue: "" };
    const newFormdata = [...api.formdata, newForm];
    const updatedApi = { ...api, formdata: newFormdata };
    setDivs([
      ...divs.slice(0, api_index),
      updatedApi,
      ...divs.slice(api_index + 1),
    ]);

    var jsonkey = Object.keys(default_payload);

    const childKey = jsonkey[0];
    const childData = default_payload[childKey];
    setfields_array_payload(childData);
    setapi_fields_payload(Object.keys(childData));
  };
  const handleAddSourcefield = (api_index) => {
    const api = datasource[api_index];
    const newFormID = api.formdata.length + 1;
    const newForm = { id: newFormID, formdatakey: "", formdatavalue: "" };
    const newFormdata = [...api.formdata, newForm];
    const updatedApi = { ...api, formdata: newFormdata };
    setdatasource([
      ...datasource.slice(0, api_index),
      updatedApi,
      ...datasource.slice(api_index + 1),
    ]);

    console.log("datasource", updatedApi);
    // var jsonkey = Object.keys(default_payload);

    // const childKey = jsonkey[0];
    // const childData = default_payload[childKey];
    // setfields_array_payload(childData);
    // setapi_fields_payload(Object.keys(childData));
  };
  const handleAddpayloadfields = (api_index) => {
    const api = payloadfields[api_index];
    const newFormID = api.formdata.length + 1;
    const newForm = { id: newFormID, formdatakey: "", formdatavalue: "" };
    const newFormdata = [...api.formdata, newForm];
    const updatedApi = { ...api, formdata: newFormdata };

    // Create a new array with the updated API object at the correct index
    const updatedPayloadfields = [
      ...payloadfields.slice(0, api_index),
      updatedApi,
      ...payloadfields.slice(api_index + 1),
    ];

    // Update the state with the new array
    setpayloadfields(updatedPayloadfields);

    console.log("payloadfields", updatedPayloadfields);
  };

  const handleAddapiheaderfield = (api_index) => {
    const api = apidata[api_index];
    const newFormID = api.formdata.length + 1;
    const newForm = { id: newFormID, formdatakey: "", formdatavalue: "" };
    const newFormdata = [...api.formdata, newForm];
    const updatedApi = { ...api, formdata: newFormdata };
    setapidata([
      ...apidata.slice(0, api_index),
      updatedApi,
      ...apidata.slice(api_index + 1),
    ]);

    var jsonkey = Object.keys(default_payload);

    const childKey = jsonkey[0];
    const childData = default_payload[childKey];
    setfields_array_payload(childData);
    setapi_fields_payload(Object.keys(childData));
  };

  const handleAddapioutputheaderfield = (api_index) => {
    const api = apidata[api_index];
    const newFormID = api.outputdata.length + 1;
    const newForm = { id: newFormID, outputkey: "", outputvalue: "" };
    const newFormdata = [...api.outputdata, newForm];
    const updatedApi = { ...api, outputdata: newFormdata };
    setapidata([
      ...apidata.slice(0, api_index),
      updatedApi,
      ...apidata.slice(api_index + 1),
    ]);

    var jsonkey = Object.keys(default_payload);

    const childKey = jsonkey[0];
    const childData = default_payload[childKey];
    setfields_array_payload(childData);
    setapi_fields_payload(Object.keys(childData));
  };

  const removeApiFormdata = (apiid, headerId) => {
    const updatedFieldList = apidata.map((field) => {
      if (field.id === apiid) {
        field.formdata = field.formdata.filter(
          (formData) => formData.id !== headerId
        );
      }
      return field;
    });
    setapidata(updatedFieldList);
  };

  const removeApioutputFormdata = (apiid, headerId) => {
    const updatedFieldList = apidata.map((field) => {
      if (field.id === apiid) {
        field.outputdata = field.outputdata.filter(
          (formData) => formData.id !== headerId
        );
      }
      return field;
    });
    setapidata(updatedFieldList);
  };

  const removeFormdata = (divId, headerId) => {
    // const updatedDivs = divs.map((div) => {
    //   if (div.id === divId) {
    //     const updatedFormdata = div.formdata.filter(
    //       (header) => header.id !== headerId
    //     );

    //     return { ...div, formdata: updatedFormdata };
    //   }
    //   return div;
    // });
    // setDivs(updatedDivs);

    const updatedDivs = divs.map((div) => {
      if (div.id === divId) {
        const updatedFormdata = div.formdata.filter(
          (header) => header.id !== headerId
        );

        return { ...div, formdata: updatedFormdata };
      }
      return div;
    });
    console.log("updatedDivs", updatedDivs);
    setDivs(updatedDivs);
  };
  const removesoueceFormdata = (divId, headerId) => {
    const updatedDivs = datasource.map((div) => {
      if (div.id === divId) {
        const updatedFormdata = div.formdata.filter(
          (header) => header.id !== headerId
        );

        return { ...div, formdata: updatedFormdata };
      }
      return div;
    });
    console.log("updatedDivs", updatedDivs);
    setdatasource(updatedDivs);
  };
  const removepayloadfieldsFormdata = (divId, headerId) => {
    const updatedDivs = payloadfields.map((div) => {
      if (div.id === divId) {
        const updatedFormdata = div.formdata.filter(
          (header) => header.id !== headerId
        );

        return { ...div, formdata: updatedFormdata };
      }
      return div;
    });
    console.log("updatedDivs", updatedDivs);
    setpayloadfields(updatedDivs);
  };

  const handleInputAPI = (e, api_index = null, index) => {
    const { name, value } = e.target;
    const api = divs[api_index];
    if (name === "inputType") {
      let updatedApi;
      if (value === "formrow") {
        updatedApi = {
          ...api,
          inputType: value,
          formdata: [],
          formrow: ""  // Reset formrow to empty string
        };
      } else if (value === "formdata") {
        updatedApi = {
          ...api,
          inputType: value,
          formdata: [{ 
            id: 1, 
            formdatakey: "", 
            formdatavalue: "", 
            inputtype: "text", 
            defaultvalue: "" 
          }],
          formrow: ""
        };
      }
      
      const newDivs = [...divs];
      newDivs[api_index] = updatedApi;
      setDivs(newDivs);
      return; // Exit early after handling inputType change
    }
    if (name === "api_url") {
      const updatedApi = { ...api, api_url: value };
      setDivs([
        ...divs.slice(0, api_index),
        updatedApi,
        ...divs.slice(api_index + 1),
      ]);
    } else if (name === "action_name") {
      const updatedApi = { ...api, action_name: value };
      setDivs([
        ...divs.slice(0, api_index),
        updatedApi,
        ...divs.slice(api_index + 1),
      ]);
    } else if (name === "output_path") {
      const updatedApi = { ...api, output_path: value };
      setDivs([
        ...divs.slice(0, api_index),
        updatedApi,
        ...divs.slice(api_index + 1),
      ]);
    } else if (name === "action_event") {
      const updatedApi = { ...api, action_event: value };
      setDivs([
        ...divs.slice(0, api_index),
        updatedApi,
        ...divs.slice(api_index + 1),
      ]);
    } else if (name === "url_type") {
      const updatedApi = { ...api, url_type: value };
      setDivs([
        ...divs.slice(0, api_index),
        updatedApi,
        ...divs.slice(api_index + 1),
      ]);
    } else if (name === "inputType") {
      const updatedApi = { ...api, inputType: value };
      setDivs([
        ...divs.slice(0, api_index),
        updatedApi,
        ...divs.slice(api_index + 1),
      ]);
    } else if (name === "formrow") {
      const updatedApi = { ...api, formrow: value };
      setDivs([
        ...divs.slice(0, api_index),
        updatedApi,
        ...divs.slice(api_index + 1),
      ]);
    } else if (name === "getoutputdata") {
      const updatedApi = { ...api, getoutputdata: value };
      console.log("updatedApi", updatedApi);
      setDivs([
        ...divs.slice(0, api_index),
        updatedApi,
        ...divs.slice(api_index + 1),
      ]);
    } else if (name === "condition_value") {
      const updatedApi = { ...api, condition_value: value };
      setDivs([
        ...divs.slice(0, api_index),
        updatedApi,
        ...divs.slice(api_index + 1),
      ]);
    } else if (name === "select_field"){
      const updatedApi = { ...api, select_field: value };
      setDivs([
        ...divs.slice(0, api_index),
        updatedApi,
        ...divs.slice(api_index + 1),
      ]);
    } else if (name === "output_path") {
      const updatedApi = { ...api, output_path: value };
      setDivs([
        ...divs.slice(0, api_index),
        updatedApi,
        ...divs.slice(api_index + 1),
      ]);
    } else if (name === "hide_conditions") {
      const updatedApi = { ...api, hide_conditions: value };
      setDivs([
        ...divs.slice(0, api_index),
        updatedApi,
        ...divs.slice(api_index + 1),
      ]);
    } else {
      const formdata = [...api.formdata];
      const headerIndex = formdata.findIndex((header) => header.id === index);
      let result;
      // if (name === "formdatavalue") {
      //   let prevdata = formdata[headerIndex][name];
      //   console.log("prevdata", prevdata);
      //   if (prevdata) {
      //     result = prevdata.concat(".", value);
      //   } else {
      //     result = value;
      //   }
      //   const childData = fields_array_payload[e.target.value];
      //   if (Object.keys(childData).length > 0) {
      //     setfields_array_payload(childData);
      //     setapi_fields_payload(Object.keys(childData));
      //   }
      // } else {
      //   result = value;
      // }
      // list[fieldindex]["BucketField"] = result;
      // setfieldlist(list);

      formdata[headerIndex][name] = value;
      const updatedApi = { ...api, formdata: formdata };
      //console.log("updatedApi", updatedApi);
      setDivs([
        ...divs.slice(0, api_index),
        updatedApi,
        ...divs.slice(api_index + 1),
      ]);
    }

    //console.log("childData", fields_array_payload);
  };
  const handlesourceInputAPI = (e, api_index = null, index) => {
    const { name, value } = e.target;
    const api = datasource[api_index];
    if (name === "api_url") {
      const updatedApi = { ...api, api_url: value };
      setdatasource([
        ...datasource.slice(0, api_index),
        updatedApi,
        ...datasource.slice(api_index + 1),
      ]);
    } else if (name === "action_name") {
      const updatedApi = { ...api, action_name: value };
      setdatasource([
        ...datasource.slice(0, api_index),
        updatedApi,
        ...datasource.slice(api_index + 1),
      ]);
    } else if (name === "output_path") {
      const updatedApi = { ...api, output_path: value };
      setpayloadfields([
        ...payloadfields.slice(0, api_index),
        updatedApi,
        ...payloadfields.slice(api_index + 1),
      ]);
    } else if (name === "action_event") {
      const updatedApi = { ...api, action_event: value };
      setdatasource([
        ...datasource.slice(0, api_index),
        updatedApi,
        ...datasource.slice(api_index + 1),
      ]);
    } else if (name === "url_type") {
      const updatedApi = { ...api, url_type: value };
      setdatasource([
        ...datasource.slice(0, api_index),
        updatedApi,
        ...datasource.slice(api_index + 1),
      ]);
    } else if (name === "inputType") {
      const updatedApi = { ...api, inputType: value };
      setdatasource([
        ...datasource.slice(0, api_index),
        updatedApi,
        ...datasource.slice(api_index + 1),
      ]);
    } else if (name === "formrow") {
      const updatedApi = { ...api, formrow: value };
      setdatasource([
        ...datasource.slice(0, api_index),
        updatedApi,
        ...datasource.slice(api_index + 1),
      ]);
    } else if (name === "outputformat") {
      const updatedApi = { ...api, outputformat: value };
      setdatasource([
        ...datasource.slice(0, api_index),
        updatedApi,
        ...datasource.slice(api_index + 1),
      ]);
    } else if (name === "outputfilter") {
      const updatedApi = { ...api, outputfilter: value };
      setdatasource([
        ...datasource.slice(0, api_index),
        updatedApi,
        ...datasource.slice(api_index + 1),
      ]);
    } else {
      const formdata = [...api.formdata];
      const headerIndex = formdata.findIndex((header) => header.id === index);
      let result;
      // if (name === "formdatavalue") {
      //   let prevdata = formdata[headerIndex][name];
      //   console.log("prevdata", prevdata);
      //   if (prevdata) {
      //     result = prevdata.concat(".", value);
      //   } else {
      //     result = value;
      //   }
      //   const childData = fields_array_payload[e.target.value];
      //   if (Object.keys(childData).length > 0) {
      //     setfields_array_payload(childData);
      //     setapi_fields_payload(Object.keys(childData));
      //   }
      // } else {
      //   result = value;
      // }
      // list[fieldindex]["BucketField"] = result;
      // setfieldlist(list);

      formdata[headerIndex][name] = value;
      const updatedApi = { ...api, formdata: formdata };
      //console.log("updatedApi", updatedApi);
      setdatasource([
        ...datasource.slice(0, api_index),
        updatedApi,
        ...datasource.slice(api_index + 1),
      ]);
    }

    //console.log("childData", fields_array_payload);
  };
  const handlepayloadfieldsInputAPI = (e, api_index = null, index) => {
    const { name, value } = e.target;
    const api = payloadfields[api_index];
    if (name === "api_url") {
      const updatedApi = { ...api, api_url: value };
      setpayloadfields([
        ...payloadfields.slice(0, api_index),
        updatedApi,
        ...payloadfields.slice(api_index + 1),
      ]);
    } else if (name === "action_name") {
      const updatedApi = { ...api, action_name: value };
      setpayloadfields([
        ...payloadfields.slice(0, api_index),
        updatedApi,
        ...payloadfields.slice(api_index + 1),
      ]);
    } else if (name === "output_path") {
      const updatedApi = { ...api, output_path: value };
      setpayloadfields([
        ...payloadfields.slice(0, api_index),
        updatedApi,
        ...payloadfields.slice(api_index + 1),
      ]);
    } else if (name === "action_event") {
      const updatedApi = { ...api, action_event: value };
      setpayloadfields([
        ...payloadfields.slice(0, api_index),
        updatedApi,
        ...payloadfields.slice(api_index + 1),
      ]);
    } else if (name === "url_type") {
      const updatedApi = { ...api, url_type: value };
      setpayloadfields([
        ...payloadfields.slice(0, api_index),
        updatedApi,
        ...payloadfields.slice(api_index + 1),
      ]);
    } else if (name === "inputType") {
      const updatedApi = { ...api, inputType: value };
      setpayloadfields([
        ...payloadfields.slice(0, api_index),
        updatedApi,
        ...payloadfields.slice(api_index + 1),
      ]);
    } else if (name === "formrow") {
      const updatedApi = { ...api, formrow: value };
      setpayloadfields([
        ...payloadfields.slice(0, api_index),
        updatedApi,
        ...payloadfields.slice(api_index + 1),
      ]);
    } else if (name === "outputformat") {
      const updatedApi = { ...api, outputformat: value };
      setpayloadfields([
        ...payloadfields.slice(0, api_index),
        updatedApi,
        ...payloadfields.slice(api_index + 1),
      ]);
    } else {
      const formdata = [...api.formdata];
      const headerIndex = formdata.findIndex((header) => header.id === index);
      let result;
      // if (name === "formdatavalue") {
      //   let prevdata = formdata[headerIndex][name];
      //   console.log("prevdata", prevdata);
      //   if (prevdata) {
      //     result = prevdata.concat(".", value);
      //   } else {
      //     result = value;
      //   }
      //   const childData = fields_array_payload[e.target.value];
      //   if (Object.keys(childData).length > 0) {
      //     setfields_array_payload(childData);
      //     setapi_fields_payload(Object.keys(childData));
      //   }
      // } else {
      //   result = value;
      // }
      // list[fieldindex]["BucketField"] = result;
      // setfieldlist(list);

      formdata[headerIndex][name] = value;
      const updatedApi = { ...api, formdata: formdata };
      //console.log("updatedApi", updatedApi);
      setpayloadfields([
        ...payloadfields.slice(0, api_index),
        updatedApi,
        ...payloadfields.slice(api_index + 1),
      ]);
    }

    //console.log("childData", fields_array_payload);
  };

  const handleApiInput = (e, api_index = null, index) => {
    const { name, value } = e.target;
    const api = apidata[api_index];
    if (name === "inputType") {
      let updatedApi;
      if (value === "formrow") {
        updatedApi = {
          ...api,
          inputType: value,
          formdata: [],
          formrow: ""  // Reset formrow to empty string
        };
      } else if (value === "formdata") {
        updatedApi = {
          ...api,
          inputType: value,
          formdata: [{ 
            id: 1, 
            formdatakey: "", 
            formdatavalue: "", 
            inputtype: "text", 
            defaultvalue: "" 
          }],
          formrow: ""
        };
      }
      
      const newDivs = [...apidata];
      newDivs[api_index] = updatedApi;
      setapidata(newDivs);
      return; // Exit early after handling inputType change
    }
    if (name === "outputvalue" || name === "outputkey") {
      const formdata = [...api.outputdata];
      const headerIndex = formdata.findIndex((header) => header.id === index);
      let result;
      formdata[headerIndex][name] = value;
      const updatedApi = { ...api, outputdata: formdata };
      //console.log("updatedApi", updatedApi);
      setapidata([
        ...apidata.slice(0, api_index),
        updatedApi,
        ...apidata.slice(api_index + 1),
      ]);
    } else if (name === "api_url") {
      const updatedApi = { ...api, api_url: value };
      setapidata([
        ...apidata.slice(0, api_index),
        updatedApi,
        ...apidata.slice(api_index + 1),
      ]);
    } else if (name === "action_name") {
      const updatedApi = { ...api, action_name: value };
      setapidata([
        ...apidata.slice(0, api_index),
        updatedApi,
        ...apidata.slice(api_index + 1),
      ]);
    } else if (name === "output_path") {
      const updatedApi = { ...api, output_path: value };
      setapidata([
        ...apidata.slice(0, api_index),
        updatedApi,
        ...apidata.slice(api_index + 1),
      ]);
    } else if (name === "inputType") {
      const updatedApi = { ...api, inputType: value };
      setapidata([
        ...apidata.slice(0, api_index),
        updatedApi,
        ...apidata.slice(api_index + 1),
      ]);
    } else if (name === "formrow") {
      const updatedApi = { ...api, formrow: value };
      setapidata([
        ...apidata.slice(0, api_index),
        updatedApi,
        ...apidata.slice(api_index + 1),
      ]);
    } else if (name === "getoutputdata") {
      const updatedApi = { ...api, getoutputdata: value };
      setapidata([
        ...apidata.slice(0, api_index),
        updatedApi,
        ...apidata.slice(api_index + 1),
      ]);
    } else if (name === "output_path") {
      const updatedApi = { ...api, output_path: value };
      setDivs([
        ...divs.slice(0, api_index),
        updatedApi,
        ...divs.slice(api_index + 1),
      ]);
    } else if (name === "priority") {
      const updatedApi = { ...api, priority: parseInt(value) };
      setapidata([
        ...apidata.slice(0, api_index),
        updatedApi,
        ...apidata.slice(api_index + 1),
      ]);
    } else {
      const formdata = [...api.formdata];
      const headerIndex = formdata.findIndex((header) => header.id === index);
      let result;
      formdata[headerIndex][name] = value;
      const updatedApi = { ...api, formdata: formdata };
      //console.log("updatedApi", updatedApi);
      setapidata([
        ...apidata.slice(0, api_index),
        updatedApi,
        ...apidata.slice(api_index + 1),
      ]);
    }

    //console.log("childData", fields_array_payload);
  };
  // const handleInputChange = (e, index, api_index = null) => {
  //   const { name, value } = e.target;
  //   if (api_index === null) {
  //     const list = [...fieldlist];
  //     list[index][name] = value;
  //     setfieldlist(list);

  //     // console.log(fieldlist);
  //     props.location.state &&
  //       props.location.state.fieldslist.map((item) => {
  //         // if(item.BucketField == )
  //         fieldlist.map((fl) => {
  //           if (item.BucketField === fl.BucketField) {
  //             item.fieldname = fl.fieldname;
  //           }
  //         });
  //       });

      if (props.location.state) {
        props.location.state.view_name = view_name;
      }
      // console.log(effetive_designation_id);
      // console.log(props.location.state);
    // }
  // };
  const handleInputfieldChange = (e, index, api_index = null) => { };
  // handle click event of the Remove button
  const handleRemoveClick = (index) => {
    const list = [...fieldlist];
    list.splice(index, 1);
    setfieldlist(list);

    props.location.state && props.location.state.fieldslist.splice(index, 1);
  };

  const handleRemoveSearch = (index) => {
    const list = [...searchKey];
    list.splice(index, 1);
    setsearchKey(list);
  };
  const handleRemovepayloadfieldsSearch = (index) => {
    const list = [...searchKeygetpayloadfields];
    list.splice(index, 1);
    setsearchKeygetpayloadfields(list);
  };

  const handleRemoveTable = (fieldIndex, tableDataId) => {
    const updatedFieldList = apidata.map((field, index) => {
      if (index === fieldIndex) {
        field.tabledata = field.tabledata.filter(
          (tableData) => tableData.id !== tableDataId
        );
      }
      return field;
    });
    setapidata(updatedFieldList);
  };

  const handleAddTableData = (fieldIndex) => {
    let length = apidata[fieldIndex].tabledata.length + 1;
    const updatedFieldList = apidata.map((field, index) => {
      if (index === fieldIndex) {
        field.tabledata.push({ id: length, tablekey: "", tablevalue: "" });
      }
      return field;
    });
    setapidata(updatedFieldList);
  };

  const getData = (finalArray) => {
    // console.log(finalArray);
    // console.log(finalArray.length);
    // if(finalArray.length > 0){
    // save_design_flag = false;
    // setsave_design_flag(false);
    // setfinalArray(finalArray);
    // }
    // console.log(save_design_flag);
  };
  const querycheckValues = (data) => {
    if (!data || typeof data !== "object") return false;

    let select = hasSelectOperator(data)
    console.log('select', select)
    if (!select) {
      return false;
    }

    // If the rules array is empty, return true
    if (Array.isArray(data.rules) && data.rules.length === 0) {
      return true;
    }

    // Check if the current level has a 'value' field and if it is not null or empty
    if (data.value !== undefined && data.value !== "") {
      return true;
    }

    // If there are nested rules, check them recursively
    if (Array.isArray(data.rules)) {
      for (const rule of data.rules) {
        if (querycheckValues(rule)) {
          return true;
        }
      }
    }

    return false;
  };

  const hasSelectOperator = (data) => {
    // Recursive function to search for "operator" === "select" in "rules"
    const searchRules = (rules) => {
      for (let rule of rules) {
        // Check if 'operator' is 'select'
        if (rule.operator === 'select') {
          return false;
        }
        // If 'rules' field exists, recursively search in it
        if (rule.rules) {
          if (!searchRules(rule.rules)) {
            return false;
          }
        }
      }
      return true;
    };

    // Start searching from the 'rules' field
    return searchRules(data.rules || []);
  };

  const saveConfig = (versionCreationDetails) => {
    const queryval = querycheckValues(query);
    // setfieldlist((prevState) => ({
    //   ...prevState,
    //   sum_config: configurations, // Save configurations to fieldlist["sum_config"]
    // }));
    fieldlist[0]["sum_config"] = configurations;
    fieldlist[0]["conditional_update"] = conditional_update;
    fieldlist[0]["entries"] = entries;
    fieldlist[0]["disableedit"] = disableedit;
    fieldlist[0]["search_query"] = query;
    
    
    // Check if any field in field_mapping has getfromapi set to 1
    const hasGetFromApi = fieldlist.some(field => field.getfromapi === "1");
    
    // If getfromapi is 1, validate that record_per_call is 10 or less
    if (hasGetFromApi && parseInt(record_per_call) > 10 && view_type == "NV") {
      alert("When using 'Get From API', Record Per Call must be 10 or less. Please adjust the value.");
      //return;
    }
    
    if (hide_filter == 1 && queryval == false) {
      alert("please fill value in condition");
    } else {
      let apitoken = localStorage.getItem("api_token");
      const form = new FormData();

      // fieldlist[0]["api_datapoints"] = apiExtraDatapoints;
      // console.log(finalArray);
      // return;

      // console.log(JSON.stringify(fieldlist));
      // return;
      let search_by_pairdata;
      if (searchKey) {
        search_by_pairdata = searchKey.map((item) => [
          item.searchKey,
          item.operator,
          item.searchValue,
        ]);
      }
      let versions = view_version || 1;
      if(updateInCurrentVersion==0){
        versions = versionData.length+1;
      }
      form.append("version_name", newVersionName || "");
      form.append("version",parseInt(versions));
      form.append("versionCreationDetails",JSON.stringify(versionCreationDetails));   console.log("operationn", operation_type);
      if(operation_type)
              {
              form.append("operation_type", operation_type);
              if(insertion_collection){
              form.append("insertion_collection", insertion_collection);
              }
              if(insertion_database){
              form.append("insertion_database", insertion_database);
              }
              if(transactionArrayFlag){
                form.append("useOldTransactionsArray", transactionArrayFlag && transactionArrayFlag == "true")
              }
              if(isAtomic && isAtomic == "true"){
              form.append("isAtomic", isAtomic);      
            }

              else if(isAtomic && isAtomic == "false"){
              form.append("isAtomic", isAtomic); 
              if(isAggregation && isAggregation == "true"){
              form.append("isAggregation", isAggregation);

                    if(aggregation_db){
              form.append("aggregation_db", aggregation_db);
              }
              if(aggregation_collection){
              form.append("aggregation_collection", aggregation_collection);
              }
              }
              }
              }
      form.append("queue_flag", queue_flag);
      form.append("updated_by", localStorage.getItem("in_userid"));
      form.append("updated_by_name", localStorage.getItem("employee_name"));
      form.append("updated_at", Date.now());
      form.append("bucket_name", bucket_name);
      form.append("event_name", event_name);
      form.append("view_name", view_name);
      form.append("field_mapping", JSON.stringify(fieldlist));
      form.append("form_mapping", jsonFormBuild ? JSON.stringify(jsonFormBuild) : null);
      form.append("action_mapping", JSON.stringify(divs));
      form.append("status", status);
      form.append("get_api_mapping", JSON.stringify(apidata));
      form.append(
        "effective_designation_id",
        JSON.stringify(effetive_designation_id)
      );
      form.append("branch_id", JSON.stringify(branch_id));
      form.append("event_location", event_location);
      form.append("payload_type", select_payload);
      form.append("fetch_onload", fetch_onload);
      form.append("selectedFieldForPartial", selectedFieldForPartial);
      form.append("api_datapoints", JSON.stringify(apiExtraDatapoints));
      form.append("history_config", JSON.stringify(config));

      if (record_per_call) {
        form.append("record_per_call", parseInt(record_per_call));
      }
      if (hide_loadmore) {
        form.append("hide_loadmore", hide_loadmore);
      }
      if (hide_pagination) {
        form.append("hide_pagination", hide_pagination);
      }
      if (get_data_by) {
        form.append("get_data_by", get_data_by);
      }
      if (hide_filter) {
        form.append("hide_filter", hide_filter);
      }
      if (hide_exportBtn) {
        form.append("hide_exportBtn", hide_exportBtn);
      }
      if (hide_filter) {
        form.append("hide_filter", hide_filter);
      }
      if (setupdated_at) {
        form.append("setupdated_at", setupdated_at);
      }

      if (reload_api_data) {
        form.append("reload_api_data", reload_api_data);
      }

      if (setcreated_at) {
        form.append("setcreated_at", setcreated_at);
      }
      if (agg_view) {
        form.append("agg_view", agg_view);
      }
      if (isexpand) {
        form.append("isexpand", isexpand);
      }
      if (form_view) {
        form.append("form_view", form_view);
      }
      if (formview) {
        form.append("formview", formview);
      }
      if (openviewin) {
        form.append("openviewin", openviewin);
      }
      if (conditionformbutton) {
        form.append("conditionformbutton", conditionformbutton);
      }
      // if (conditionSets) {
      //   form.append("conditionSets", JSON.stringify(conditionSets));
      // }
      if (fieldDependencies) {
        form.append("fieldDependencies", JSON.stringify(fieldDependencies));
      }
      if (dropdownList_hideConditions) {
        form.append("dropdownList_hideConditions", JSON.stringify(dropdownList_hideConditions));
      }
      if (fetchdatafrom) {
        form.append("fetchdatafrom", fetchdatafrom);
      }
      if (view_id != agg_view) {
        form.append("view_id", view_id);
        if (editsearchKey) {
          form.append("getpayloadfields", editsearchKey);
        }
      } else {
        if (mongo_combinesearch) {
          form.append("getpayloadfields", JSON.stringify(mongo_combinesearch));
        } else {
          form.append("getpayloadfields", "");
        }
      }
      if (search_by_pairdata) {
        form.append("search_by_pair", JSON.stringify(search_by_pairdata));
      } else {
        form.append("search_by_pair", []);
      }
      if (db_name) {
        form.append("db_name", db_name);
      }
      if (collection_name) {
        form.append("collection_name", collection_name);
      }
      if (db_namegetpayload) {
        form.append("db_namegetpayload", db_namegetpayload);
      }
      if (collection_namegetpayload) {
        form.append("collection_namegetpayload", collection_namegetpayload);
      }
      if (datasource) {
        form.append("datasource", JSON.stringify(datasource));
      }
      if (payloadfields) {
        form.append("payloadfields", JSON.stringify(payloadfields));
      }
      if (outputfilter) {
        form.append("outputfilter", outputfilter);
      }
      if (payloaddataoutputformat) {
        form.append("payloaddataoutputformat", payloaddataoutputformat);
      }
      if (sourcedataoutputformat) {
        form.append("sourcedataoutputformat", sourcedataoutputformat);
      }
      if (pilotView) {
        form.append("pilotView", pilotView);
      }
      if (pilotviewobjectid) {
        form.append("pilotviewobjectid", pilotviewobjectid);
      }
      if (pilotViewButtonName) {
        form.append("pilotViewButtonName", pilotViewButtonName);
      }

      if (view_type) {
        form.append("view_type", view_type);
      }
      if (commit_type) {
        form.append("commit_type", commit_type);
      }
      form.append("alert_config", JSON.stringify([]));
      form.append("marquee_flag", marquee_flag);
      form.append("marquee_message", marquee_message);
      form.append("marquee_message_color", marquee_message_color);
      form.append("selected_views", JSON.stringify(selectedViews))
      if(status_control_async_flag) {
        form.append("status_control_async_flag", status_control_async_flag);
      }
      sendRequest(
        {
          url: `${process.env.REACT_APP_BASE_URL}/store/webhook/configuration`,
          method: "POST",
          data: form,
          headers: {
            "Content-Type": "multipart/form-data",
            "api-token": apitoken,
          },
        },
        (response) => {
          // props.location.state.component_mapping = finalArray;
          setsave_design_flag(true);
          console.log(props.location.state);
          setisErrOpen(true);
          setapi_error_message(response[0].message);
        }
      );
      console.log("Saved Query:", query);
      const updatedData = [...fieldlist];
      updatedData[0].search_query = query;
      setfieldlist(updatedData);
      console.log("Checking some test",fieldlist)
    }
  };
  const removeDiv = (i) => {
    const list = [...divs];
    list.splice(i, 1);
    setDivs(list);
  };
  const removeGetApi = (i) => {
    const list = [...apidata];
    list.splice(i, 1);
    setapidata(list);
  };

  {/*adding save query in save config*/}
  

  // const getEventList = (e) => {
  //   setbucket_name(e.target.value);
  //   setevent_name("");
  //   let apitoken = localStorage.getItem("api_token");
  //   //    const form = new FormData();
  //   sendRequest(
  //     {
  //       url: `${process.env.REACT_APP_BASE_URL}/payload/getfields/${e.target.value}`,
  //       method: "POST",
  //       //data: inputdata,
  //       headers: {
  //         "Content-Type": "application/json",
  //         "api-token": apitoken,
  //       },
  //     },
  //     (response) => {
  //       //setgetfields(response);

  //       var jsonkey = Object.keys(response);

  //       setfields_list(jsonkey);
  //     }
  //   );
  // };
  const getFieldList = (istempsearch = 0) => {
    let url = "";
    let form;
    console.log("select_payload", select_payload);
    // if (select_payload == "B") {
    //   url = `${process.env.REACT_APP_BASE_URL}/payload/get/${bucket_name}?limit=1`;
    //   // if (searchKey && searchValue) {
    //   //   form = JSON.stringify([
    //   //     [event_location, "==", event_name, searchKey, "==", searchValue],
    //   //   ]);
    //   // } else {
    //   //   form = JSON.stringify([[event_location, "==", event_name]]);
    //   // }

    //   let searchinput;
    //   let formattedSearchKey;
    //   if (istempsearch == 1) {
    //     searchinput = tempsearchKey;
    //     formattedSearchKey = searchinput.map((item) => [
    //       item.searchKey,
    //       item.operator,
    //       convertToInputType(item.searchValue, item.inputType),
    //     ]);
    //   } else {
    //     searchinput = searchKey;
    //     formattedSearchKey = searchinput.map((item) => [
    //       item.searchKey,
    //       item.operator,
    //       convertToInputType(item.searchValue, item.inputType),
    //     ]);
    //   }
    //   console.log("searchinput->", formattedSearchKey);
    //   form = JSON.stringify(formattedSearchKey);
    //   if (formattedSearchKey[0][0] != "") {
    //     setmongo_combinesearch(formattedSearchKey);
    //   } else {
    //     setmongo_combinesearch("");
    //   }
    // }
    // if (select_payload == "M") {
    if (select_payload == selectPayloadValues.API_Selection) {
      if (payloadfields[0].url_type == select_url_type.Without_base_url) {
        url = `${process.env.REACT_APP_BASE_URL}/${payloadfields[0].api_url}`;
      } else {
        url = payloadfields[0].api_url;
      }

      const api = payloadfields[0];
      form = new FormData();

      api.formdata.forEach((item) => {
        form.append(item.formdatakey, item.formdatavalue);
      });

      for (let pair of form.entries()) {
        console.log(pair[0] + ": " + pair[1]);
      }
    } else {
      url = `${process.env.REACT_APP_BASE_URL}/mongo/get/${db_namegetpayload}/${collection_namegetpayload}?limit=1&offset=0`;
      let searchinput;
      console.log("istempsearch->", istempsearch);
      let formattedSearchKey;
      if (istempsearch == 1) {
        searchinput = tempsearchKey;
        formattedSearchKey = searchinput.map((item) => [
          item.searchKey,
          item.operator,
          item.searchValue,
        ]);
      } else {
        searchinput = searchKeygetpayloadfields;
        formattedSearchKey = searchinput.map((item) => [
          item.searchKey,
          item.operator,
          item.searchValue,
        ]);
      }
      let finalArray;
      if (istempsearch == 1) {
        finalArray = formattedSearchKey;
      } else {
        if (formattedSearchKey[0][0] != "") {
          finalArray = [
            ["processed", "exists", processedis],
            ...formattedSearchKey,
          ];
        } else {
          finalArray = [["processed", "exists", processedis]];
        }
      }
      console.log("finalArray->", finalArray);
      setmongo_combinesearch(finalArray);
      form = JSON.stringify(finalArray);
    }
    let apitoken = localStorage.getItem("api_token");

    console.log("FormData entries:", form);
    sendRequest(
      {
        url: url,
        method: "POST",
        data: form,
        headers: {
          "Content-Type": "application/json",
          "api-token": apitoken,
        },
      },
      (json) => {
        let response;
        if (
          // (payloadfields && payloadfields[0].outputformat != undefined) ||
          (payloaddataoutputformat && payloaddataoutputformat != undefined)
        ) {
          console.log(
            "payloadfields[0].outputformat",
            json[payloadfields[0].outputformat]
          );
          const outputFormatPath =
            payloadfields[0].outputformat || payloaddataoutputformat;
          response = getNestedValue(json, outputFormatPath);
          if (!Array.isArray(response)) {
            response = [response];
          }
        } else {
          response = json;
        }
        response = json;
        console.log("response--", response);
        setget_bucketfield(false);
        //setgetfields(response);
        var jsonkey = Object.keys(response);

        const childKey = jsonkey[0];
        setfields_array(response[childKey]);
        setfields_array_payload(response[childKey]);

        setdefault_payload(response);
        const childData = response[childKey];
        if(childData) {
          setapi_fields_list(Object.keys(childData));
          setapi_fields_payload(Object.keys(childData));
        }

        if (!view_id) {
          console.log(view_name);
          console.log('props.location.state', props.location.state)
          {
            /* AT-2072 | Vaibhav Sawant | 06-09-2023 | Setting props value for PayloadTile */
          }
          props.location.state.fieldslist = fieldlist;
          // props.location.state.payloadTile = true;
          props.location.state.bucket_name = bucket_name;
          props.location.state.event_name = event_name;
          // props.location.state.view_name = view_name;
          props.location.state.field_mapping = JSON.stringify(fieldlist);
          props.location.state.action_mapping = JSON.stringify(divs);
          props.location.state.status = status;
          props.location.state.get_api_mapping = JSON.stringify(apidata);
          // props.location.state.effective_designation_id = effetive_designation_id;
          // form.append("bucket_name", bucket_name);
          // form.append("event_namefield_mapping", event_name);
          // form.append("view_name", view_name);
          // form.append("field_mapping", JSON.stringify(fieldlist));
          // form.append("action_mapping", JSON.stringify(divs));
          // form.append("status", status);
          // form.append("get_api_mapping", JSON.stringify(apidata));
          // form.append("effective_designation_id", effetive_designation_id);
          // handleFieldListForPayloadTile(Object.keys(childData));
          //   // console.log(fieldlist);
          //   // console.log(Object.keys(childData));
          //   // console.log(localStorage);
        }
      }
    );
  };

  const getNestedValue = (obj, path) => {
    return path
      .split(/[\[\]\.]+/)
      .filter(Boolean)
      .reduce((acc, part) => acc && acc[part], obj);
  };
  const handleStructureImport = (event) => {
    const file = event.target.files[0];
    if (file) {
      const reader = new FileReader();
      reader.onload = (e) => {
        try {
          const jsonData = JSON.parse(e.target.result);
          setdefault_payload(jsonData); // Update default_payload state
          event.target.value = ''; // Reset file input
        } catch (error) {
          alert("Invalid JSON file for structure import");
          event.target.value = '';
        }
      };
      reader.readAsText(file);
    }
  };

  const handleConfigImport = (event) => {
    setimport_config_flag(1);
    const file = event.target.files[0];
    if (file) {
      const reader = new FileReader();
      reader.onload = (e) => {
        try {
          const jsonData = JSON.parse(e.target.result);
          setfieldlist(jsonData); // Update fieldlist state
          event.target.value = ''; // Reset file input
        } catch (error) {
          alert("Invalid JSON file for config import");
          event.target.value = '';
        }
      };
      reader.readAsText(file);
    }
  };

  const extractValues = (data, fieldName) => {
    let results = [];

    // Check if the data contains rules
    if (data.rules) {
      data.rules.forEach((rule) => {
        if (rule.field === fieldName) {
          results.push(rule.value);
        } else if (rule.rules) {
          // Recursively call the function for nested rules
          results = results.concat(extractValues(rule, fieldName));
        }
      });
    }

    return results;
  };

  const setQuerydata = (q) => {
    console.log("Query", q);
    const serviceIds = extractValues(q, "service_id");
    if (serviceIds) {
      const filteredDropdownIds = service_idResponse
        .filter((item) => serviceIds.includes(item.name)) // Filter by matching services
        .map((item) => item.dropdown_id_from_mysql); // Extract dropdown_id_from_mysql

      setfilteredservice_id(filteredDropdownIds);
    }

    setQuery(q);
    const updatedData = [...fieldlist];
    if (updatedData.length > 0) {
      updatedData[0].search_query = q;
      setfieldlist(updatedData);
    }
  };
  const groupData = (data) => {
    return data.reduce((acc, item) => {
      const field = item.field;
      if (!acc[field]) {
        acc[field] = { field, values: [] };
      }
      acc[field].values.push(item.value);
      return acc;
    }, {});
  };
  const formatQuerybuild = (query) => {
    if (!query) return {};
    const mongoQuery = {};
    if (query.combinator === "and") {
      if (query.rules && query.rules.length > 0) {
        mongoQuery.$and = query.rules.map(formatQuerybuild);
      }
    } else if (query.combinator === "or") {
      if (query.rules && query.rules.length > 0) {
        mongoQuery.$or = query.rules.map(formatQuerybuild);
      }
    }

    if (query.field && query.operator) {
      const field = query.field;
      const operator = query.operator;
      const value = query.value;

      if (operator === "=") {
        mongoQuery[field] = value;
      } else if (operator === "!=") {
        mongoQuery[field] = { $ne: value };
      } else if (operator === ">") {
        mongoQuery[field] = { $gt: value };
      } else if (operator === "<") {
        mongoQuery[field] = { $lt: value };
      } else if (operator === ">=") {
        mongoQuery[field] = { $gte: value };
      } else if (operator === "<=") {
        mongoQuery[field] = { $lte: value };
      }

      if (operator === "exists") {
        mongoQuery[field] = {
          $exists: value.toLowerCase() == "true" ? true : false,
        };
      }
    }

    return mongoQuery;
  };

  // const formatRule = (rule) => {
  //   const field = rule.field;
  //   const operator = rule.operator;
  //   const value = rule.value;

  //   switch (operator) {
  //     case "exists":
  //       return {
  //         [field]: { $exists: value },
  //       };
  //     case "=":
  //       return {
  //         [field]: value,
  //       };
  //     case "!=":
  //       return {
  //         [field]: { $ne: value },
  //       };
  //     case ">":
  //       return {
  //         [field]: { $gt: value },
  //       };
  //     case "<":
  //       return {
  //         [field]: { $lt: value },
  //       };
  //     case ">=":
  //       return {
  //         [field]: { $gte: value },
  //       };
  //     case "<=":
  //       return {
  //         [field]: { $lte: value },
  //       };
  //     default:
  //       return {}; // Handle other operators as needed
  //   }
  // };

  const customOperators = {
    exists: {
      label: "Exists",
      type: "unary",
      compile: (field, operator, value) => {
        return { [field]: { $exists: true } };
      },
    },
  };

  const convertToInputType = (value, inputType) => {
    switch (inputType) {
      case "string":
        return String(value);
      case "float":
        return parseFloat(value);
      case "int":
        return parseInt(value, 10) | 0;
      case "boolean":
        if (value === 'true') return true;
        if (value === 'false') return false;
        return value;
      default:
        return value;
    }
  };

  const setsearchKeydata = (e, i) => {
    const list = [...searchKey];
    let value;
    if (list[i]["inputType"]) {
      value = convertToInputType(e.target.value, list[i]["inputType"]);
    } else {
      value = convertToInputType(e.target.value, "string");
    }

    list[i][e.target.name] = value;
    setsearchKey(list);
    console.log("searchKey", searchKey);
  };

  const setsearchKeypayloadfieldsdata = (e, i) => {
    const list = [...searchKeygetpayloadfields];
    let value;
    if (list[i]["inputType"]) {
      value = convertToInputType(e.target.value, list[i]["inputType"]);
    } else {
      value = convertToInputType(e.target.value, "string");
    }

    list[i][e.target.name] = value;
    setsearchKeygetpayloadfields(list);
  };

  const settemp_searchKey = (e) => {
    console.log("settempsearchKey->", e);
    const list = [...tempsearchKey];

    let value;
    if (list[0]["inputType"]) {
      value = convertToInputType(e.target.value, list[0]["inputType"]);
    } else {
      value = convertToInputType(e.target.value, "string");
    }

    list[0][e.target.name] = value;
    settempsearchKey(list);
  };
  const getcollection = (dbName) => {
    setdb_name(dbName);
    const filtered = db_list.filter((item) => item.db_name === dbName);
    setcollection_list(filtered[0].collections);
  };
  const getpayloadfieldscollection = (dbName) => {
    setdb_namegetpayload(dbName);
    const filtered = db_list.filter((item) => item.db_name === dbName);
    setcollection_listgetpayloadfields(filtered[0].collections);
  };
  console.log("searchKeygetpayloadfields", divs);
      
  //const { search_fields, query, setQuerydata, Operators } = props;
  /*
  const CustomValueEditor = ({ handleOnChange, value }) => {
    const buttonRef = useRef(null);
    const [showPicker, setShowPicker] = useState(false);

    // Ensure color is correctly stored inside QueryBuilder and doesn't reset
    useEffect(() => {
        if (!value || !value.startsWith("#")) {
            handleOnChange("#000000"); // Store default color in QueryBuilder only if it's empty
        }
    }, [value, handleOnChange]); // Ensures this runs only when necessary

    return (
      <div style={{ display: "flex", alignItems: "center", gap: "8px", position: "relative" }}>
        <input
          type="text"
          value={!value || value.startsWith("#") ? "" : value} // Ensures color does not appear in the input box
          onChange={(e) => handleOnChange(e.target.value)}
          placeholder="Enter value"
        />
        <button
          ref={buttonRef}
          onClick={() => setShowPicker(!showPicker)}
          style={{
            backgroundColor: "blue",
            color: "white",
            border: "none",
            padding: "8px 12px",
            cursor: "pointer",
            borderRadius: "4px",
          }}
        >
          {showPicker ? "Close" : "Pick Color"}
        </button>
        {showPicker && buttonRef.current && (
          <div 
            style={{
              position: "absolute",
              top: `${buttonRef.current.offsetTop}px`,
              left: `${buttonRef.current.offsetLeft + buttonRef.current.offsetWidth + 10}px`,
              zIndex: 1000,
              background: "white",
              boxShadow: "0px 4px 10px rgba(0,0,0,0.2)",
              borderRadius: "5px",
              padding: "10px"
            }}
          >
            <SketchPicker
              color={value && value.startsWith("#") ? value : "#000000"} // Use QueryBuilder's stored value
              onChangeComplete={(updatedColor) => {
                handleOnChange(updatedColor.hex); // Persist color inside QueryBuilder
              }}
            />
          </div>
        )}
        <div 
          style={{
            width: "24px",
            height: "24px",
            backgroundColor: value && value.startsWith("#") ? value : "#000000", // Show stored color
            border: "1px solid #ccc",
            borderRadius: "4px"
          }}
        ></div>
      </div>
    );
};
*/

  const handleQueryChange = (newQuery) => {
    const updatedQuery = {
      ...newQuery,
      rules: newQuery.rules.map((rule, index) => {
        if (rule.rules) {
          return {
            ...rule,
            rules: rule.rules.map((innerRule, innerIndex) => ({
              ...innerRule,
              color:
                innerRule.color ||
                (colorPickers[`${index}-${innerIndex}`] &&
                  colorPickers[`${index}-${innerIndex}`].color) ||
                "#ffffff",
            })),
          };
        }
        return {
          ...rule,
          color:
            rule.color ||
            (colorPickers[index] && colorPickers[index].color) ||
            "#ffffff",
        };
      }),
    };
    setQuery(updatedQuery);
    // --- FIX: Use an object, not an array ---
    let updatedColors = {};
    updatedQuery.rules.forEach((rule, index) => {
      if (rule.rules) {
        rule.rules.forEach((innerRule, innerIndex) => {
          const key = `${index}-${innerIndex}`;
          updatedColors[key] =
            colorPickers[key] || {
              type: "rule",
              color: innerRule.color || "#ffffff",
              display: false,
            };
        });
      } else {
        updatedColors[`${index}`] =
          colorPickers[`${index}`] || {
            type: "rule",
            color: rule.color || "#ffffff",
            display: false,
          };
      }
    });
    setColorPickers(updatedColors);
    const updatedData = [...fieldlist];
    if (
      updatedData.length > 0 &&
      JSON.stringify(updatedData[0].search_query) !== JSON.stringify(updatedQuery)
    ) {
      updatedData[0] = { ...updatedData[0], search_query: updatedQuery };
      setfieldlist(updatedData);
    }
  };
  const toggleColorPicker = (index) => {
    setColorPickers(prev => {
      const newPickers = { ...prev };
      const isClosing = newPickers[index] ? newPickers[index].display : false;

      newPickers[index] = {
        color: newPickers[index] ? newPickers[index].color : "#ffffff",
        display: !isClosing
      };
      return newPickers;
    });
  };
  const handleColorChange = (key, color) => {
    const selectedColor = color.hex.toLowerCase();
    // Update colorPickers state
    setColorPickers(prev => ({
      ...prev,
      [key]: {
        color: selectedColor,
        display: true
      }
    }));
    // Helper to update color in nested rules by path
    function updateRuleColorByPath(rules, pathArr, color) {
      if (!pathArr.length) return rules;
      const [head, ...rest] = pathArr;
      return rules.map((rule, idx) => {
        if (idx !== head) return rule;
        if (rest.length === 0) {
          return { ...rule, color };
        }
        if (rule.rules) {
          return { ...rule, rules: updateRuleColorByPath(rule.rules, rest, color) };
        }
        return rule;
      });
    }
    // Parse the key into a path array (e.g. "0-1" or "0.1.2")
    const pathArr = key.split(/[-.]/).map(Number);
    // Update query state (and thus fieldlist)
    setQuery(prevQuery => {
      const updatedRules = updateRuleColorByPath(prevQuery.rules, pathArr, selectedColor);
      
      return {
        ...prevQuery,
        rules: updatedRules
      };
    });
    // setfieldlist(prev => {
    //   if (!prev || !prev[0] || !prev[0].search_query) return prev;
    //   const newFieldlist = [...prev];
    //   newFieldlist[0] = { ...newFieldlist[0] };
    //   newFieldlist[0].search_query = { ...newFieldlist[0].search_query };
    //   newFieldlist[0].search_query.rules = updateRuleColorByPath(
    //     newFieldlist[0].search_query.rules,
    //     pathArr,
    //     selectedColor
    //   );
    //   return newFieldlist;
    // });
  };
  //const saveQuery = () => {
  //console.log("Saved Query:", query);
  //const updatedData = [...fieldlist];
  //updatedData[0].search_query = query;
  //setfieldlist(updatedData);
  //console.log("Checking some test",fieldlist)
  //};
  const checkIfAllRulesAreWhite = (rules) => {
    if (!rules || rules.length === 0) return false; // Prevent errors if rules are missing
    return rules.every((rule) => {
      if (rule.rules && rule.rules.length > 0) {
        return checkIfAllRulesAreWhite(rule.rules); // ✅ Recursively check nested rules
      }
      // ✅ If rule has no color property, ignore it
      if (!rule.color) {
        return true;
      }
      // ✅ If rule has a color, ensure it's #FFFFFF
      return rule.color.toUpperCase() === "#FFFFFF";
    });
  };
  const handleClearColor = (key) => {
    // Helper to update color in nested rules by path
    function updateRuleColorByPath(rules, pathArr) {
      if (!pathArr.length) return rules;
      const [head, ...rest] = pathArr;
      return rules.map((rule, idx) => {
        if (idx !== head) return rule;
        if (rest.length === 0) {
          return { ...rule, color: "#ffffff" };
        }
        if (rule.rules) {
          return { ...rule, rules: updateRuleColorByPath(rule.rules, rest) };
        }
        return rule;
      });
    }
    // Parse the key into a path array (e.g. "0-1" or "0.1.2")
    const pathArr = key.split(/[-.]/).map(Number);
    // Update query state
    setQuery(prevQuery => {
      const updatedRules = updateRuleColorByPath(prevQuery.rules, pathArr);
      // Check if all colors are white after update
      if (checkIfAllRulesAreWhite(updatedRules)) {
        setvalidDateCondition(true);
      }
      return {
        ...prevQuery,
        rules: updatedRules
      };
    });
    // Update color pickers
    setColorPickers(prev => ({
      ...prev,
      [key]: {
        color: "#ffffff",
        display: false
      }
    }));
    // Update fieldlist
    setfieldlist(prev => {
      if (!prev || !prev[0] || !prev[0].search_query) return prev;
      const newFieldlist = [...prev];
      newFieldlist[0] = { ...newFieldlist[0] };
      newFieldlist[0].search_query = { ...newFieldlist[0].search_query };
      newFieldlist[0].search_query.rules = updateRuleColorByPath(
        newFieldlist[0].search_query.rules,
        pathArr
      );
      return newFieldlist;
    });
    
    // Optionally update cleared rules tracking if needed
    setClearedRules(prev => {
      const alreadyExists = prev.some(item => item.id === key);
      return alreadyExists ? prev : [...prev, { id: key }];
    });
  };

  function getAllRuleColors(rules, path = "") {
    let pickers = {};
    rules.forEach((rule, idx) => {
      const key = path ? `${path}-${idx}` : `${idx}`;
      if (rule.rules) {
        pickers = { ...pickers, ...getAllRuleColors(rule.rules, key) };
      } else {
        pickers[key] = {
          color: rule.color || "#ffffff",
          display: false
        };
      }
    });
    return pickers;
  }

useEffect(() => {
  if(validDateCondition === true) return;
  if (initialRender === false) {
    if (fieldlist && fieldlist.length > 0) {
      const isValid = fieldlist.some(item => {
        const isDateField = item.datatype === "date";
        const hasConditionArray = Array.isArray(item.datecondition);
        const hasConditions = hasConditionArray && item.datecondition.length > 0;
        return isDateField && hasConditionArray && hasConditions;
      });
      setvalidDateCondition(isValid);
    }
   
  }
  if (fieldlist.length > 1) {
      setInitialRender(true);
    }
}, [fieldlist,initialRender]);

   
  useEffect(()=>{
    if(validDateCondition === true){
      setClearedRules([]);
    }
  }, [validDateCondition])
  useEffect(() => {
    if (parentFieldCount > 0) {
      setInitialReset((prev) => {
        return false;
      });
    }
  }, [parentFieldCount]);
  useEffect(() => {
    if (parentFieldCount === 0) {
      setInitialReset(false);
    }
  }, [parentFieldCount])
  useEffect(() => {
    const rules = (
      Array.isArray(fieldlist) &&
      fieldlist[0] &&
      typeof fieldlist[0] === 'object' &&
      fieldlist[0].search_query && 
      Array.isArray(fieldlist[0].search_query.rules)
    ) ? fieldlist[0].search_query.rules : [];
  })

  const extractAllRules = (rules) => {
    let result = [];
    rules.forEach((rule) => {
      if (rule.rules) {
        // Recursively handle nested rules
        result = result.concat(extractAllRules(rule.rules));
      } else {
        result.push({
          field: rule.field,
          operator: rule.operator,
          value: rule.value,
        });
      }
    });

    return result;
  };

  const filteroutput = () => {
    let apitoken = localStorage.getItem("api_token");
    const selecteddata = fieldlist.filter(
      (item) => {
        const result =
          item.datatype === "dropdownlist";
        return result;
      }
    );
    const uniqueDropdownList = [...new Set(selecteddata.map(item => item.dropdownlist))];
    // Ensure dropdownlistid is processed as an array
    const dropdownIds = Array.isArray(uniqueDropdownList) ? uniqueDropdownList : [uniqueDropdownList];

    dropdownIds.forEach((id) => {
      sendRequest(
        {
          url: `${process.env.REACT_APP_BASE_URL}/get/dropdown/item/list?dropdown_id=${id}`,
          method: "GET",
          headers: {
            "Content-Type": "application/json",
            "api-token": apitoken,
          },
        },
        (response) => {
          console.log("dropdownlist", response);
          setdropdownResponsebasedata((prev) => [...(prev || []), ...response]); // Handle non-filtered data          
        }
      );
    });
  };
  console.log("configurations", configurations);
  // Recursive function to update a rule in the entire query structure
  const updateRuleInTree = (rules, ruleId, property) => {
    return rules.map((rule) => {
      // If it's a combinator (group), recursively check its children
      if (rule.rules) {
        return { ...rule, rules: updateRuleInTree(rule.rules, ruleId, property) };
      }
      // If it's the rule to update, ensure `hidden` and `editable` exist
      if (rule.id === ruleId) {
        return {
          ...rule,
          hidden: typeof rule.hidden !== "undefined" ? rule.hidden : false,
          editable: typeof rule.editable !== "undefined" ? !rule.editable : false,
          [property]: !rule[property],
        };
      }
      return rule;
    });
  };

  // Function to toggle visibility
  const toggleRuleVisibility = (ruleId) => {
    setQuery((prevQuery) => ({
      ...prevQuery,
      rules: updateRuleInTree(prevQuery.rules, ruleId, "hidden"),
    }));
  };

  // Function to toggle editability
  const toggleRuleEditability = (ruleId) => {
    setQuery((prevQuery) => ({
      ...prevQuery,
      rules: updateRuleInTree(prevQuery.rules, ruleId, "editable"),
    }));
  };

const CustomRule = (props) => {
  const { rule, ...rest } = props;
  const pathArr = props.path || [];  // Use a unique key for each rule
   const key = pathArr.join("-");
  const color = (colorPickers[key] && colorPickers[key].color) || rule.color || "#ffffff";
  const display = (colorPickers[key] && colorPickers[key].display) || false;
  const isHidden = typeof rule.hidden !== "undefined" ? rule.hidden : false;
  const isEditable = typeof rule.editable !== "undefined" ? rule.editable : true;

  return (
    <div style={{ display: "flex", alignItems: "center" }}>
      {/* Hide rule content if hidden */}
      <div>
        <Rule {...props} disabled={!isEditable} />
      </div>

      {/* Toggle Visibility Button */}
      <button onClick={() => toggleRuleVisibility(rule.id)} className="ruleGroup-addRule">
        {isHidden ? <FaEyeSlash /> : <FaEye />}
      </button>

      {/* Toggle Editability Button (Only if rule is visible) */}
      {!isHidden && (
        <button onClick={() => toggleRuleEditability(rule.id)} className="ruleGroup-addRule">
          {isEditable ? <FaLockOpen /> : <FaLock />}
        </button>
      )}
      <button
        className="btn btn-primary"
        onClick={() => toggleColorPicker(key)}
        style={{ marginLeft: 8 }}
        disabled={validDateCondition}
      >
        {display ? "Close Picker" : "Pick Color"}
      </button>

      {/* Reset Color Button */}
      <button
        className="btn btn-secondary"
        onClick={() => handleClearColor(key)}
        disabled={validDateCondition}
        style={{
          backgroundColor: "red",
          color: "white",
          border: "none",
          width: "30px",
          height: "30px",
          marginLeft: 4,
          borderRadius: "5px",
          cursor: "pointer",
        }}
      >
        <RedoOutlined style={{ fontSize: "16px", color: "white" }} />
      </button>

      {/* Color Picker */}
      {display && (
        <div style={{ position: "relative", marginLeft: 8 }}>
          <div
            style={{
              position: "fixed",
              top: 0,
              right: 0,
              bottom: 0,
              left: 0,
            }}
            onClick={() => toggleColorPicker(key)}
          />
          <ChromePicker
            color={color}
            onChangeComplete={(color) => handleColorChange(key, color)}
          />
        </div>
      )}
    </div>
  );
};
  const getFormView = () => {
    const viewFormdata = Array.isArray(view_list) && view_list.filter((item, index) => {
      if (item.view_id === view_id) {
        return item;
      }
    })
    setFilteredViewList(viewFormdata);
  }
  useEffect(() => {
    if (!hasInitialized && query && query.rules.length > 0) {
      const initialColors = getAllRuleColors(query.rules); // <-- recursive for all rules
      setColorPickers(initialColors);
      setHasInitialized(true);
    }
  }, [query, hasInitialized]);

  const handleApiConfigChange = (index, field, rawValue) => {
    setApiExtraDatapoints(prev => {
      const updatedConfig = [...prev];
      const currentConfig = { ...updatedConfig[index] };
      let value = rawValue;

      if (field === 'value_datatype') {
        const oldValue = currentConfig.value;
        const newType = rawValue;
        let convertedValue = oldValue;

        if (oldValue !== undefined && oldValue !== '') {
          switch (newType) {
            case 'int': {
              const n = Number(oldValue);
              convertedValue = Number.isNaN(n) ? '' : parseInt(n, 10);
              break;
            }
            case 'float': {
              const n = Number(oldValue);
              convertedValue = Number.isNaN(n) ? '' : parseFloat(n);
              break;
            }
            case 'boolean': {
              if (typeof oldValue === 'string') {
                const s = oldValue.toLowerCase();
                if (s === 'true') convertedValue = true;
                else if (s === 'false') convertedValue = false;
                else convertedValue = '';
              } else if (typeof oldValue === 'number') {
                convertedValue = oldValue !== 0;
              } else if (typeof oldValue === 'boolean') {
                convertedValue = oldValue;
              } else {
                convertedValue = '';
              }
              break;
            }
            case 'string':
            default:
              convertedValue =
                oldValue === null || oldValue === undefined
                  ? ''
                  : String(oldValue);
              break;
          }
        }

        currentConfig.value_datatype = newType;
        currentConfig.value = convertedValue;
      } else if (field === 'value') {
        const type = currentConfig.value_datatype;

        switch (type) {
          case 'int': {
            // Allow empty while typing
            if (value === '') {
              // keep as empty string
            } else if (!Number.isNaN(Number(value))) {
              value = parseInt(value, 10);
            }
            break;
          }
          case 'float': {
            if (value === '') {
              // keep as empty string
            } else if (!Number.isNaN(Number(value))) {
              value = parseFloat(value);
            }
            break;
          }
          case 'boolean': {
            // Only convert when the full word is entered
            if (value === true || value === false) {
              // already boolean, do nothing
            } else if (typeof value === 'string') {
              const s = value.toLowerCase();
              if (s === 'true') value = true;
              else if (s === 'false') value = false;
              // else: keep the raw string while the user is typing (e.g. "t", "tr")
            }
            break;
          }
          default:
            // string or undefined type: keep as-is
            break;
        }

        currentConfig[field] = value;
      } else {
        currentConfig[field] = value;
      }

      updatedConfig[index] = currentConfig;
      return updatedConfig;
    });
  };

  const handleAddApiConfig = () => {
    setApiExtraDatapoints([...apiExtraDatapoints, {
      flag: "",
      key: "",
      value: "",
      api_endpoints: []
    }]);
  };

  const handleRemoveApiConfig = (index) => {
    if (apiExtraDatapoints.length > 1) {
      const updatedConfig = [...apiExtraDatapoints];
      updatedConfig.splice(index, 1);
      setApiExtraDatapoints(updatedConfig);
    }
  };
  const handleSaveConfigPopup = () => {
    // Validate: If creating new version, version name is mandatory
    if (updateInCurrentVersion === 0 && (!newVersionName || newVersionName.trim() === "")) {
      alert("Please enter a version name to create a new version");
      return;
    }

    // Find _id and currentVersion from versionData and view_version
    let _id = "";
    let currentVersion = 1;
    if (view_version && versionData) {
      const found = versionData.find(v => v.version === view_version);
      if (found && found._id && found._id.$oid) {
        _id = found._id.$oid;
        currentVersion = found.version || view_version;
      }
    } else if (view_version) {
      currentVersion = view_version;
    }

    // Compose versionCreationDetails
    const versionCreationDetails = {
      updateInCurrentVersion:updateInCurrentVersion,
      _id:_id,
      currentVersion:currentVersion,
      version_name: newVersionName
    };
    setVersionCreationDetails(versionCreationDetails);
    // Call saveConfig with appended field
    setSaveConfigModalVisible(false);
    setNewVersionName("");
    saveConfig(versionCreationDetails);
  };
  return (
    <div className="container">
      <Commonheader pagetitle={"Create View"} props={props} />
      {loading && (
        <div className="load-4">
          <div className="ring-1"></div>
        </div>
      )}
      <Modal
        title="Save Configuration"
        visible={saveConfigModalVisible}
        onCancel={() => setSaveConfigModalVisible(false)}
        footer={[
          <Button key="cancel" onClick={() => setSaveConfigModalVisible(false)}>
            Cancel
          </Button>,
          <Button 
            key="save" 
            type="primary" 
            onClick={handleSaveConfigPopup}
            disabled={updateInCurrentVersion === 0 && (!newVersionName || newVersionName.trim() === "")}
          >
            Save
          </Button>
        ]}
      >
        <div>
          <label>Choose Action:</label>
          <select
            value={updateInCurrentVersion}
            onChange={e => {
              setUpdateInCurrentVersion(Number(e.target.value));
              if (Number(e.target.value) === 0) {
                setNewVersionName("");
              }
            }}
            className="form-control"
          >
            <option value="">Select</option>
            <option value={1} disabled={versionData.length === 0}>Update Current Version</option>
            <option value={0}>Create New Version</option>
          </select>
          {updateInCurrentVersion === 0 && (
            <div>
              <label>New Version Name: <span style={{ color: 'red' }}>*</span></label>
              <input
                type="text"
                value={newVersionName}
                onChange={e => setNewVersionName(e.target.value)}
                className="form-control"
              />
              {newVersionName.trim() === "" && (
                <div style={{ color: 'red', marginTop: '5px', fontSize: '12px' }}>
                  This field is required
                </div>
              )}
            </div>
          )}
        </div>
      </Modal>
      <div
        className={
          isErrOpen
            ? "modal fade show d-block mymodal"
            : "modal fade bd-example-modal-sm"
        }
        tabIndex="-1"
        role="dialog"
        aria-labelledby="myLargeModalLabel"

        id="confirm-box"
      >
        <div className="modal-dialog modal-lg">
          <div className="modal-content cdb-confirm-box col-sm-12">
            <button
              type="button"
              className="close text-right"
              data-dismiss="modal"
              aria-label="Close"
              onClick={() => {
                setisErrOpen(false);
                window.location.reload();
              }}
            >
              <span >&times;</span>
            </button>
            <p className="popuperrtext">{api_error_message}</p>
          </div>
        </div>
      </div>
      <div
        className={
          isMobileview
            ? "modal fade show d-block mymodal"
            : "modal fade bd-example-modal-sm"
        }
        tabIndex="-1"
        role="dialog"
        aria-labelledby="myLargeModalLabel"
        id="confirm-box"
        style={{ zIndex: 2 }}
      >
        <div className="modal-dialog modal-lg">
          <div className="modal-content cdb-confirm-box col-sm-12">
            <button
              type="button"
              className="close text-right"
              data-dismiss="modal"
              aria-label="Close"
              onClick={() => {
                setisMobileview(false);
              }}
            >
              <span >&times;</span>
            </button>
            {isMobileview && (
              <PayloadTile
                data={props.location.state}
                component_mapping={component_mapping}
                create_view={getData}
                sendRequest={sendRequest}
              />
            )}
          </div>
        </div>
      </div>
      <div
        className={
          get_bucketfield
            ? "modal fade show d-block mymodal"
            : "modal fade bd-example-modal-sm"
        }
        tabIndex="-1"
        role="dialog"
        aria-labelledby="myLargeModalLabel"

        id="confirm-box"
      >
        <div className="modal-dialog modal-lg">
          <div className="modal-content cdb-confirm-box col-sm-12">
            <button
              type="button"
              className="close text-right"
              data-dismiss="modal"
              aria-label="Close"
              onClick={() => {
                setget_bucketfield(false);
              }}
            >
              <span >&times;</span>
            </button>
            <p className="popuperrtext">
              <div className="row">
                <div className="form-group col-md-3">
                  <label htmlFor="inputEmail4">Key</label>
                  <input
                    element_id="create_view_searchkey"
                    className="form-control"
                    name="searchKey"
                    //Ankur Makavana | 18-09-2023 | To add filters & sorting of fields on the payload screen
                    value={tempsearchKey.searchKey}
                    onChange={(e) => settemp_searchKey(e)}
                  />
                </div>
                <div
                  element_id="create_view_operator"
                  className="form-group col-md-2"
                >
                  <label htmlFor="inputEmail4">Operator</label>
                  <select
                    className="form-control"
                    name="operator"
                    value={tempsearchKey.operator}
                    onChange={(e) => settemp_searchKey(e)}
                  >
                    <option value="">select</option>
                    <option value="==">==</option>
                    <option value="exists">exists</option>
                    <option value=">">&#62;</option>
                    <option value="<">&#60;</option>
                    <option value="!=">!=</option>
                  </select>
                </div>
                <div
                  element_id="create_view_inputtype"
                  className="form-group col-md-2"
                >
                  <label htmlFor="inputEmail4">Input Type</label>
                  <select
                    className="form-control"
                    name="inputType"
                    value={tempsearchKey.inputType}
                    onChange={(e) => settemp_searchKey(e)}
                  >
                    <option value="string">String</option>
                    <option value="int">Int</option>
                    <option value="float">Float</option>
                    <option value="boolean">Boolean</option>
                  </select>
                </div>
                <div
                  element_id="create_view_value"
                  className="form-group col-md-3"
                >
                  <label htmlFor="inputEmail4">Value</label>
                  <input
                    className="form-control"
                    name="searchValue"
                    //Ankur Makavana | 18-09-2023 | To add filters & sorting of fields on the payload screen
                    value={tempsearchKey.searchValue}
                    onChange={(e) => settemp_searchKey(e)}
                  //onBlur={() => getFieldList()}
                  />
                </div>
                <div
                  element_id="create_view_search"
                  className="form-group  col-md-2"
                >
                  <button
                    className="btn btn-primary"
                    onClick={() => {
                      getFieldList("1");
                    }}
                  >
                    search
                  </button>
                </div>
              </div>
            </p>
          </div>
        </div>
      </div>

      <div className="mt-4">
        <div className="viewname-holder">
          <div className="row">            
            <div
              element_id="create_view_viewname"
              className="form-group col-md-3"
            >
              <label htmlFor="inputEmail4">View Version</label>
              {versionData && versionData.length > 0 ?
              <Select
                placeholder="View Version"
                name="view_version"
                value={view_version}
                className="form-control"
                showSearch
                onChange={(e) => { setview_version(e); setimport_config_flag(1); }}
              >
                {versionData && versionData.map((e) => (
                  <>
                    <option value={e.version} title={"Changed Fields: "+Object.keys(e.updateDescription.updatedFields).join(",")}>{e.version_name + " - " + e.version}</option>
                  </>
                ))}
              </Select>:"Current Version"}
            </div>            
            <div
              element_id="create_view_viewname"
              className="form-group col-md-3"
            >
              <label htmlFor="inputEmail4">View Name</label>
              <input
                className="form-control"
                id="inputEmail4"
                placeholder="View Name"
                name="view_name"
                value={view_name}
                onChange={(e) => setview_name(e.target.value)}
              />
            </div>
            <div
              element_id="create_view_designationid"
              className="form-group col-md-3"
            >
              <label htmlFor="inputEmail4">Designation ID</label>
              {/* <select
                className="form-control"
                name="effetive_designation_id"
                //Ankur Makavana | 04-08-2023 | Disable Bucket, Event and Designation id on edit
                //disabled={view_id}
                value={effetive_designation_id}
                onChange={(e) => seteffetive_designation_id(e.target.value)}
              >
                <option value="">Select Designation ID</option>
                {Array.isArray(effetive_designation_idList) &&
                {Array.isArray(effetive_designation_idList) &&
                  effetive_designation_idList.map((eid) => (
                    <>
                      <option value={eid.effective_designation_id} key={eid.effective_designation_id}>
                        {eid.designation_name}
                      </option>
                    </>
                  ))}
              </select> */}
              <Select
                placeholder="Designation ID"
                mode="multiple"
                className="form-control"
                name="effetive_designation_id"
                // style={{
                //   maxHeight: 100,
                //   overflowY: "scroll",
                // }}
                value={effetive_designation_id}
                options={
                  effetive_designation_idList &&
                  effetive_designation_idList.map((eid) => {
                    return {
                      label: eid.designation_name,
                      value: eid.effective_designation_id,
                    };
                  })
                }
                onChange={(e) => seteffetive_designation_id(e)}
              />
            </div>
            <div
              element_id="create_view_payloadform"
              className="form-group col-md-3"
            >
              <label htmlFor="inputEmail4">Select Payload From</label>
              <select
                className="form-control"
                name="select_payload"
                //Ankur Makavana | 02-09-2023 | select payload from bucket or mongo
                disabled={view_id}
                value={select_payload}
                onChange={(e) => setselect_payload(e.target.value)}
              >
                <option value="">Select</option>
                <>
                  <option value="B">Bucket</option>
                  <option value="M">Mongo</option>
                  <option value="A">API</option>
                </>
              </select>
            </div>
            <div
              element_id="create_view_defaultsearch"
              className="form-group col-md-3"
            >
              <label>Default Search</label>
              <select
                className="form-control"
                name="fetch_onload"
                //Ankur Makavana | 02-09-2023 | select payload from bucket or mongo
                value={fetch_onload}
                onChange={(e) => setfetch_onload(e.target.value)}
              >
                <option value="">Select</option>
                <>
                  <option value="false">False</option>
                  <option value="true">True</option>
                </>
              </select>
            </div>
            <div
              element_id="create_view_queueflag"
              className="form-group col-md-3"
            >
              <label>Queue Flag</label>
              <select
                className="form-control"
                name="queue_flag"
                value={queue_flag}
                onChange={(e) => setqueue_flag(e.target.value)}
              >
                <option value="">Select</option>
                <>
                  <option value="true">Enable</option>
                  <option value="false">Disable</option>
                </>
              </select>
            </div>
            <div className="form-group col-md-3">
              <label>Max Record per request</label>
              <input
                className="form-control"
                type="number"
                name="record_per_call"
                value={record_per_call}
                onChange={(e) => setrecord_per_call(e.target.value)}
              />
            </div>
            <div className="form-group col-md-3">
              <label>Hide Load More</label>
              <select
                className="form-control"
                name="hide_loadmore"
                value={hide_loadmore}
                onChange={(e) => sethide_loadmore(e.target.value)}
              >
                <option value="">Select</option>
                <>
                  <option value="1">Yes</option>
                  <option value="0">No</option>
                </>
              </select>
            </div>
            <div className="form-group col-md-3">
              <label>Hide Pagination</label>
              <select
                className="form-control"
                name="hide_pagination"
                value={hide_pagination}
                onChange={(e) => sethide_pagination(e.target.value)}
              >
                <option value="">Select</option>
                <>
                  <option value="1">Yes</option>
                  <option value="0">No</option>
                </>
              </select>
            </div>
            <div className="form-group col-md-3">
              <label>Get Data Response</label>
              <select
                className="form-control"
                name="get_data_by"
                value={get_data_by}
                onChange={(e) => setget_data_by(e.target.value)}
              >
                <option value="">Select</option>
                <option value="P">Payload</option>
                <option value="C">Column</option>
              </select>
            </div>
            <div className="form-group col-md-3">
              <label>Data From Different View</label>
              <Select
                mode="multiple"
                allowClear
                placeholder="Select Views"
                className="form-control"
                value={selectedViews}
                onChange={(values) => {
                  setSelectedViews(
                    values.map(v => ({
                      value: v.value,
                      view_name: v.label,
                      view_id: v.value
                    }))
                  );
                }}
                labelInValue
                options={
                  Array.isArray(view_list)
                    ? view_list
                      .filter((view) => view.view_id !== view_id)
                      .map((view) => ({
                        label: view.view_name,
                        value: view.view_id,
                      }))
                    : []
                }
                filterOption={(input, option) =>
                  option.label.toLowerCase().includes(input.toLowerCase())
                }
              />
            </div>
            <div className="form-group col-md-3">
              <label>Hide Filter</label>
              <select
                className="form-control"
                name="hide_filter"
                value={hide_filter}
                onChange={(e) => sethide_filter(e.target.value)}
              >
                <option value="">Select</option>
                <option value="1">Web</option>
                <option value="2">Mobile</option>
                <option value="3">Both</option>
              </select>
            </div>
            <div className="form-group col-md-3">
              <label>Hide Expot Button</label>
              <select
                className="form-control"
                name="hide_exportBtn"
                value={hide_exportBtn}
                onChange={(e) => sethide_exportBtn(e.target.value)}
              >
                <option value="">Select</option>
                <option value="1">Web</option>
                <option value="2">Mobile</option>
                <option value="3">Both</option>
              </select>
            </div>
            {/* <div className="form-group col-md-3">
              <label>Hide Filter</label>
              <select
                className="form-control"
                name="hide_filter"
                value={hide_filter}
                onChange={(e) => sethide_filter(e.target.value)}
              >
                <option value="">Select</option>
                <option value="1">Yes</option>
                <option value="0">No</option>
              </select>
            </div> */}
            <div className="form-group col-md-3">
              <label>Select Branch</label>
              <Select
                placeholder="Designation ID"
                mode="multiple"
                className="form-control"
                name="branch_id"
                value={branch_id}
                options={
                  branch_list &&
                  branch_list.map((action) => {
                    return {
                      label: action.branch_name,
                      value: action.branch_id,
                    };
                  })
                }
                onChange={(e) => setbranch_id(e)}
              />
            </div>
            <div className="form-group col-md-3">
              <label>Store UpdatedAt</label>
              <select
                className="form-control"
                name="setupdated_at"
                value={setupdated_at}
                onChange={(e) => setsetupdated_at(e.target.value)}
              >
                <option value="">Select</option>
                <option value="1">Yes</option>
                <option value="0">No</option>
              </select>
            </div>
            <div className="form-group col-md-3">
              <label>Updated At</label>
              <Input
                className="form-control"
                type="text"
                name="updated_at"
                value={updated_at ? new Date(parseInt(updated_at)).toLocaleString() : ""}
                disabled
                placeholder="Updated At"
              />
            </div>
            <div className="form-group col-md-3">
              <label>Updated By</label>
              <Input
                className="form-control"
                type="text"
                name="updated_by"
                value={updated_by || ""}
                disabled
                placeholder="Updated By"
                title={updated_by || ""}
              />
            </div>
            <div className="form-group col-md-3">
              <label>Reload Api Data</label>
              <select
                className="form-control"
                name="reload_api_data"
                value={reload_api_data}
                onChange={(e) => setreload_api_data(e.target.value)}
              >
                <option value="">Select</option>
                <option value="1">Yes</option>
                <option value="0">No</option>
              </select>
            </div>
          <div className="form-group col-md-3">
              <label>Store CreatedAt</label>
              <select
                className="form-control"
                name="setcreated_at"
                value={setcreated_at}
                onChange={(e) => setsetcreated_at(e.target.value)}
              >
                <option value="">Select</option>
                <option value="1">Yes</option>
                <option value="0">No</option>
              </select>
            </div>
            <div className="form-group col-md-3">
              <label>show action column</label>
              <select
                className="form-control"
                name="show_action_column"
                value={show_action_column || "1"}
                onChange={(e) => setshow_action_column(e.target.value)}
              >
                <option value="">Select</option>
                <option value="1">Yes</option>
                <option value="0">No</option>
              </select>
            </div>          
            <div className="form-group col-md-3">
              <label htmlFor="inputEmail4">View Type</label>
              <select
                name="viewtype"
                className="form-control"
                value={view_type}
                onChange={(e) => setview_type(e.target.value)}
              >
                <option value="">Select Type</option>
                <option value="NV">Normal View</option>
                <option value="CV">Child View</option>
                <option value="AV">Aggregate View</option>
                <option value="FV">Form View</option>
              </select>
            </div>
          {/* </div> */}
            {(view_type === "NV" || view_type === "CV" || view_type === "AV") && (
              <>
                <div className="form-group col-md-3">
                  <label>Show Form</label>
                  <select
                    name="show_form"
                    className="form-control"
                    value={form_view}
                    onChange={(e) => setform_view(e.target.value)}
                  >
                    <option value="">Select View</option>
                    <option value="1">Yes</option>
                    <option value="0">No</option>
                  </select>
                </div>
              </>
            )}
            {form_view === "1" && (
              <>
                <div className="form-group col-md-3">
                  <label>Select Form View</label>
                  <select
                    name="formview"
                    className="form-control"
                    value={formview}
                    onChange={(e) => setformview(e.target.value)}
                  >
                    <option value="">Select Form View</option>
                    {view_list && view_list.map(({ view_id, view_name, field_mapping, form_mapping }) => {
                      if (form_mapping) {
                        return (
                          <option key={view_id} value={view_id}>
                            {view_name}
                          </option>
                        );
                      } else {
                        return;
                      }
                    })}
                  </select>
                </div>
              </>
            )}
            {form_view === "1" && (
              <>
                <div className="form-group col-md-3">
                  <label>Open Form View in</label>
                  <select
                    name="openviewin"
                    className="form-control"
                    value={openviewin}
                    onChange={(e) => setOpenviewin(e.target.value)}
                  >
                    <option value="">Open Form View in</option>
                    <option value="NT">New Tab</option>
                    <option value="SW">Same Window</option>
                    <option value="NW">New Window</option>
                    <option value="POP">Popup</option>
                  </select>
                </div>
              </>
            )}
            {view_type == "AV" && (
              <>                
                <div className="form-group col-md-3">
                  <label>Expand Data</label>
                  <select
                    name="isexpand"
                    className="form-control"
                    value={isexpand}
                    onChange={(e) => setisexpand(e.target.value)}
                  >
                    <option value="">Select</option>
                    <>
                      <option value="1">Yes</option>
                      <option value="0">No</option>
                    </>
                  </select>
                </div>
                <div className="form-group col-md-3">
                  <label>Select View</label>
                  <select
                    name="agg_view"
                    className="form-control"
                    value={agg_view}
                    onChange={(e) => setagg_view(e.target.value)}
                  >
                    <option value="">Select View</option>
                    {view_list &&
                      view_list.map((view) => (
                        <option value={view.view_id}>{view.view_name}</option>
                      ))}
                  </select>
                </div>
              </>
            )}
          <div className="form-group col-md-3">
            <label htmlFor="commit_type">Commit Type</label>
            <select
              name="viewtype"
              className="form-control"
              value={commit_type}
              onChange={(e) => setcommit_type(e.target.value)}
            >
              <option value="">Select Type</option>
              <option value="1">Full Commit</option>
              <option value="0">Partial Commit</option>
            </select>
            </div>
          <div className="form-group col-md-3">
              <label htmlFor="inputEmail4">Pilot View</label>
              <select
                className="form-control"
                name="pilot_view"
                value={pilotView}
                onChange={(e) => setPilotView(e.target.value)}
              >
                <option value="">Select</option>
                <>
                  <option value="1">Yes</option>
                  <option value="0">No</option>
                </>
              </select>
            </div>
            {pilotView === "1" && <div className="form-group col-md-3">
              <label htmlFor="inputEmail4">ObjectId of Pilot View</label>
              <input
                className="form-control"
                id="pilotviewobjectid"
                placeholder="Pilot View ObjectId"
                name="pilotviewobjectid"
                value={pilotviewobjectid}
                onChange={(e) => setPilotviewobjectid(e.target.value)}
                />
            </div>}
            <div className="form-group col-md-3">
              <label htmlFor="inputEmail4">Status Async Flag</label>
              <select
                className="form-control"
                name="status_control_async_flag"
                value={status_control_async_flag}
                onChange={(e) => setStatus_control_async_flag(e.target.value)}
              >
                <option value="">Select</option>
                <option value="1">Yes</option>
                <option value="0">No</option>
              </select>
            </div>
                  <div className="form-group col-md-3">
                  <label htmlFor="operation_type">Operation</label>
                  <select
                    name="viewtype"
                    className="form-control"
                    value={operation_type}
                    onChange={(e) => setoperation_type(e.target.value)}
                  >
                    <option value="">Select Type</option>
                    <option value="insert">Insert</option>
                    <option value="update">Updateone</option>
                  </select>
                </div>
                    {operation_type === "insert" && (
                      <>
          {/* Insertion Database */}

          <div className="form-group col-md-3">
            <label htmlFor="insertion_database">Insertion Database</label>
            <input
              type="text"
              className="form-control"
              name="insertion_database"
              value={insertion_database}
              onChange={(e) => setinsertion_database(e.target.value)}
            />
          </div>
          {/* Insertion Collection */}
          <div className="form-group col-md-3">
            <label htmlFor="insertion_collection">Insertion Collection</label>
            <input
              type="text"
              className="form-control"
              name="insertion_collection"
              value={insertion_collection}
              onChange={(e) => setinsertion_collection(e.target.value)}
            />
          </div>
          <div className="form-group col-md-3">
            <label htmlFor="insertion_collection">Use Aggregation from Transactions Array?</label>
            <select
              name="useOldTransactionsArray"
              className="form-control"
              value={transactionArrayFlag}
              onChange={(e) => setTransactionArrayFlag(e.target.value)}
            >
              <option value="">Select</option>
              <option value="true">Yes</option>
              <option value="false">No</option>
            </select>
          </div>
                          {/* Is Atomic */}
                          <div className="form-group col-md-3">
                            <label htmlFor="isAtomic">Is Atomic</label>
                            <select
                              name="isAtomic"
                              className="form-control"
                              value={isAtomic}
                              onChange={(e) => setIsAtomic(e.target.value)}
                            >
                  <option value="">Select</option>
                  <option value="true">True</option>
                  <option value="false">False</option>
                </select>
              </div>

            {/* Show Is Aggregation ONLY if Is Atomic = false */}
            {isAtomic === "false" && (
              <div className="form-group col-md-3">
                <label htmlFor="isAggregation">Is Aggregation</label>
                <select
                  name="isAggregation"
                  className="form-control"
                  value={isAggregation}
                  onChange={(e) => setIsAggregation(e.target.value)}
                >
                  <option value="">Select</option>
                  <option value="true">True</option>
                  <option value="false">False</option>
                </select>
              </div>
            )}

            {/* Show DB + Collection ONLY if Is Aggregation = true */}
            {isAtomic === "false" && isAggregation === "true" && (
              <>
                <div className="form-group col-md-3">
                  <label htmlFor="aggregation_db">DB Name</label>
                  <input
                    type="text"
                    className="form-control"
                    name="aggregation_db"
                    value={aggregation_db}
                    onChange={(e) => setaggregation_db(e.target.value)}
                  />
                </div>

                <div className="form-group col-md-3">
                  <label htmlFor="aggregation_collection">Collection Name</label>
                  <input
                    type="text"
                    className="form-control"
                    name="aggregation_collection"
                    value={aggregation_collection}
                    onChange={(e) => setaggregation_collection(e.target.value)}
                  />
                </div>
              </>
            )}
          </>
        )}
          </div>
            {pilotView === "1" && <div className="form-group col-md-3">
              <label htmlFor="inputEmail4">Pilot View Button Name</label>
              <input
                className="form-control"
                id="pilotViewButtonName"
                placeholder="Pilot View Button Name"
                name="pilotViewButtonName"
                value={pilotViewButtonName}
                onChange={(e) => setPilotViewButtonName(e.target.value)}
                />
            </div>}
          </div>
          {select_payload && (
            <div className="block-shadow">
              <h3 className="text-center">Data Source</h3>
              {select_payload == selectPayloadValues.MongoDB_Selection && (
                <div className="row">
                  <div
                    element_id="create_view_processed"
                    className="form-group col-md-3"
                  >
                    <label>Processed is</label>
                    <select
                      className="form-control"
                      name="processedis"
                      //Ankur Makavana | 02-09-2023 | select payload from bucket or mongo
                      disabled={view_id}
                      value={processedis}
                      onChange={(e) => setprocessedis(e.target.value)}
                    >
                      <option value="">Select</option>
                      <>
                        <option value="false">False</option>
                        <option value="true">True</option>
                      </>
                    </select>
                  </div>
                  <div
                    element_id="create_view_dbname"
                    className="form-group col-md-3"
                  >
                    <label>DB Name</label>
                    <select
                      className="form-control"
                      name="db_name"
                      value={db_name}
                      disabled={view_id}
                      onChange={(e) => getcollection(e.target.value)}
                    >
                      <option value="">Select DB</option>
                      {db_list &&
                        db_list.map((dbdata) => (
                          <option value={dbdata.db_name}>
                            {dbdata.db_name}
                          </option>
                        ))}
                    </select>
                  </div>
                  <div
                    element_id="create_view_collection"
                    className="form-group col-md-3"
                  >
                    <label>Collection Name</label>
                    {/* <input
                    className="form-control"
                    name="collection_name"
                    onChange={(e) => setcollection_name(e.target.value)}
                   /> */}
                    <select
                      className="form-control"
                      name="db_name"
                      value={collection_name}
                      disabled={view_id}
                      onChange={(e) => setcollection_name(e.target.value)}
                    >
                      <option value="">Select Collection</option>
                      {collection_list &&
                        collection_list.map((colnm) => (
                          <option value={colnm}>{colnm}</option>
                        ))}
                    </select>
                  </div>
                </div>
              )}
              {select_payload == selectPayloadValues.Base_url && (
                <>
                  <div className="row">
                    <div
                      element_id="create_view_bucket"
                      className="form-group col-md-3"
                    >
                      <label htmlFor="inputEmail4">Bucket</label>
                      <select
                        className="form-control"
                        name="bucket_name"
                        value={bucket_name}
                        //Ankur Makavana | 04-08-2023 | Disable Bucket, Event and Designation id on edit
                        disabled={view_id}
                        onChange={(e) => {
                          setbucket_name(e.target.value);
                          setevent_name("");
                          setevent_location("");
                        }}
                      >
                        <option value="">Select Bucket</option>
                        {bucket_list &&
                          bucket_list.map((bucket, index) => (
                            <option value={bucket}>{bucket}</option>
                          ))}
                      </select>
                    </div>
                    <div
                      element_id="create_view_eventlocation"
                      className="form-group col-md-3"
                    >
                      <label htmlFor="inputEmail4">Event Location</label>

                      <input
                        className="form-control"
                        name="event_location"
                        //Ankur Makavana | 04-08-2023 | Disable Bucket, Event and Designation id on edit
                        disabled={view_id}
                        value={event_location}
                        onChange={(e) => setevent_location(e.target.value)}
                      />
                    </div>
                    <div
                      element_id="create_view_event"
                      className="form-group col-md-3"
                    >
                      <label htmlFor="inputEmail4">Event</label>

                      <input
                        className="form-control"
                        name="event_name"
                        //Ankur Makavana | 04-08-2023 | Disable Bucket, Event and Designation id on edit
                        disabled={view_id}
                        value={event_name}
                        onChange={(e) => setevent_name(e.target.value)}
                      //onBlur={() => getFieldList()}
                      />
                    </div>
                  </div>
                  <div
                    element_id="create_view_specificpay"
                    className="row justify-content-center"
                  >
                    <strong>OR Search Specific Payload</strong>
                  </div>
                </>
              )}
              {select_payload != selectPayloadValues.API_Selection && (
                <>
                  <div className="row justify-content-center">
                    {searchKey &&
                      searchKey.map((searchdata, i) => (
                        <>
                          <div
                            element_id="create_view_key"
                            className="form-group col-md-3"
                          >
                            <label htmlFor="inputEmail4">Key</label>
                            <input
                              className="form-control"
                              name="searchKey"
                              //Ankur Makavana | 18-09-2023 | To add filters & sorting of fields on the payload screen
                              disabled={view_id}
                              value={searchdata.searchKey}
                              onChange={(e) => setsearchKeydata(e, i)}
                            />
                          </div>
                          <div
                            element_id="create_view_operator"
                            className="form-group col-md-2"
                          >
                            <label htmlFor="inputEmail4">Operator</label>
                            <select
                              className="form-control"
                              name="operator"
                              disabled={view_id}
                              onChange={(e) => setsearchKeydata(e, i)}
                              value={searchdata.operator}
                            >
                              <option value="">select</option>
                              <option value="==">==</option>
                              <option value="exists">exists</option>
                              <option value=">">&#62;</option>
                              <option value="<">&#60;</option>
                              <option value="!=">!=</option>
                            </select>
                          </div>
                          <div
                            element_id="create_view_iptype"
                            className="form-group col-md-2"
                          >
                            <label htmlFor="inputEmail4">Input Type</label>
                            <select
                              className="form-control"
                              name="inputType"
                              disabled={view_id}
                              value={searchdata.inputType}
                              onChange={(e) => setsearchKeydata(e, i)}
                            >
                              <option value="string">String</option>
                              <option value="int">Int</option>
                              <option value="float">Float</option>
                              <option value="boolean">Boolean</option>
                            </select>
                          </div>
                          <div
                            element_id="create_view_value"
                            className="form-group col-md-3"
                          >
                            <label htmlFor="inputEmail4">Value</label>
                            <input
                              className="form-control"
                              name="searchValue"
                              //Ankur Makavana | 18-09-2023 | To add filters & sorting of fields on the payload screen
                              disabled={view_id}
                              value={searchdata.searchValue}
                              onChange={(e) => setsearchKeydata(e, i)}
                            //onBlur={() => getFieldList()}
                            />
                          </div>

                          {!view_id && (
                            <div className="btn-box">
                              <div className="form-group col-md-2">
                                {searchKey.length !== 1 && (
                                  <button
                                    className="btn btn-danger"
                                    onClick={() => handleRemoveSearch(i)}
                                  >
                                    -
                                  </button>
                                )}
                                {searchKey.length - 1 === i && (
                                  <button
                                    className="btn btn-primary"
                                    onClick={handleAddsearch}
                                  >
                                    +
                                  </button>
                                )}
                              </div>
                            </div>
                          )}
                          <div className="col-md-12">
                            <label htmlFor="inputEmail4">Output Format</label>
                            <input
                              className="form-control"
                              name="sourcedataoutputformat"
                              onChange={(e) =>
                                setsourcedataoutputformat(e.target.value)
                              }
                              placeholder="payload[0].hhdata"
                              value={sourcedataoutputformat}
                            />
                          </div>
                          <div className="col-md-12">
                            <label htmlFor="inputEmail4">Output Filter</label>
                            <input
                              className="form-control"
                              name="outputfilter"
                              onChange={(e) => setoutputfilter(e.target.value)}
                              placeholder="payload[0].hhdata!='',payload[0].hhdata!=''"
                              value={outputfilter}
                            />
                          </div>
                        </>
                      ))}
                  </div>
                </>
              )}
              {select_payload == selectPayloadValues.API_Selection && (
                <>
                  {datasource.map((x, i) => {
                    return (
                      <div key={i} className="row">
                        <div className="form-group col-md-6">
                          <label>Url Type</label>
                          <select
                            className="form-control"
                            name="url_type"
                            value={x.url_type}
                            onChange={(e) => handlesourceInputAPI(e, i)}
                          >
                            <option value="">select</option>
                            <option value="B">With Base URL</option>
                            <option value="N">Without Base URL</option>
                          </select>
                        </div>
                        <div className="form-group col-md-6">
                          <label htmlFor="inputEmail4">API URL</label>
                          <input
                            name="api_url"
                            className="form-control"
                            placeholder="Enter API URL"
                            value={x.api_url}
                            onChange={(e) => handlesourceInputAPI(e, i)}
                          />
                        </div>
                        <div className="form-group col-md-12">
                          <label>Input Type</label>
                          <select
                            className="form-control"
                            name="inputType"
                            value={x.inputType}
                            onChange={(e) => handlesourceInputAPI(e, i)}
                          >
                            <option value="formdata">Form Data</option>
                            <option value="formrow">Row Data</option>
                          </select>
                        </div>

                        {x.inputType == "formdata" &&
                          x.formdata.map((head, index) => (
                            <div className="row col-md-12">
                              <div className="form-group col-md-3" key={index}>
                                <label htmlFor="inputEmail4">
                                  Formdata Field
                                </label>
                                <input
                                  className="form-control"
                                  name="formdatakey"
                                  placeholder="Enter Header Field"
                                  value={head.formdatakey}
                                  onChange={(e) =>
                                    handlesourceInputAPI(e, i, head.id)
                                  }
                                />
                              </div>
                              <div className="form-group col-md-3">
                                <label htmlFor="inputEmail4">
                                  Formdata Value
                                </label>
                                <input
                                  className="form-control"
                                  name="formdatavalue"
                                  onChange={(e) =>
                                    handlesourceInputAPI(e, i, head.id)
                                  }
                                  placeholder="Enter Header Field"
                                  value={head.formdatavalue}
                                />
                              </div>
                              <div className="form-group col-md-3">
                                <label htmlFor="inputEmail4">
                                  Manual Input
                                </label>
                                <select
                                  className="form-control"
                                  name="manual_input"
                                  value={head.manual_input}
                                  onChange={(e) => handlesourceInputAPI(e, i, head.id)}
                                >
                                  <option value="">Select</option>
                                  <>
                                    <option value="1">Yes</option>
                                    <option value="0">No</option>
                                  </>
                                </select>
                              </div>                              
                              <div className="form-group col-md-3">
                                <label htmlFor="inputEmail4">
                                  Get From API
                                </label>
                                <select
                                  className="form-control"
                                  name="getdata_from"
                                  value={head.getdata_from}
                                  onChange={(e) => handlesourceInputAPI(e, i, head.id)}
                                >
                                  <option value="">Select</option>
                                  {apidata && apidata.map(({action_name}) => (
                                    <option value={action_name}>{action_name}</option>
                                  ))}
                                </select>
                              </div>
                              <div className="form-group col-md-3">
                                <label htmlFor="inputEmail4">
                                  Use As Input
                                </label>
                                <select
                                  className="form-control"
                                  name="useasinput"
                                  value={head.useasinput}
                                  onChange={(e) => handlesourceInputAPI(e, i, head.id)}
                                >
                                  <option value="">Select</option>
                                  <>
                                    <option value="1">Yes</option>
                                    <option value="0">No</option>
                                  </>
                                </select>
                              </div>
                              {head.useasinput == "1" &&
                                <div className="form-group col-md-3">
                                  <label htmlFor="inputEmail4">
                                    Select API
                                  </label>
                                  <select
                                    className="form-control"
                                    name="inputapi"
                                    value={head.inputapi}
                                    onChange={(e) => handlesourceInputAPI(e, i, head.id)}
                                  >
                                    <option value="">Select</option>
                                    {apidata && apidata.map(({action_name}) => (
                                      <option value={action_name}>{action_name}</option>
                                    ))}
                                  </select>
                                </div>
                              }
                              <div className="form-group col-md-2">
                                {x.formdata.length !== 1 && (
                                  <button
                                    className="btn btn-danger"
                                    onClick={() =>
                                      removesoueceFormdata(x.id, head.id)
                                    }
                                  >
                                    -
                                  </button>
                                )}
                                {x.formdata.length - 1 === index && (
                                  <button
                                    className="btn btn-primary"
                                    onClick={() => handleAddSourcefield(i)}
                                  >
                                    +
                                  </button>
                                )}
                              </div>
                            </div>
                          ))}
                        {x.inputType == "formrow" && (
                          <div className="form-group col-md-12">
                            <label>
                              Use {"{{ user_id }}"} for user id and for other
                              fields use {"{{ fieldname }}"}
                            </label>
                            <textarea
                              name="formrow"
                              className="form-control"
                              placeholder="Enter Action Name"
                              onChange={(e) => handlesourceInputAPI(e, i)}
                              rows="10"
                            >
                              {x.formrow}
                            </textarea>
                          </div>
                        )}
                        <div className="col-md-12">
                          <label htmlFor="inputEmail4">Output Format</label>
                          <input
                            className="form-control"
                            name="outputformat"
                            onChange={(e) => handlesourceInputAPI(e, i)}
                            placeholder="payload[0].hhdata"
                            value={x.outputformat}
                          />
                        </div>
                        <div className="col-md-12">
                          <label htmlFor="inputEmail4">Output Filter</label>
                          <input
                            className="form-control"
                            name="outputfilter"
                            onChange={(e) => handlesourceInputAPI(e, i)}
                            placeholder="payload[0].hhdata!='',payload[0].hhdata!=''"
                            value={x.outputfilter}
                          />
                        </div>
                      </div>
                    );
                  })}
                  <hr />
                  <h3 className="text-center">Get Payload Fields</h3>
                  {payloadfields.map((x, i) => {
                    return (
                      <div key={i} className="row">
                        <div className="form-group col-md-6">
                          <label>Url Type</label>
                          <select
                            className="form-control"
                            name="url_type"
                            value={x.url_type}
                            onChange={(e) => handlepayloadfieldsInputAPI(e, i)}
                          >
                            <option value="">select</option>
                            <option value="B">With Base URL</option>
                            <option value="N">Without Base URL</option>
                          </select>
                        </div>
                        <div className="form-group col-md-6">
                          <label htmlFor="inputEmail4">API URL</label>
                          <input
                            name="api_url"
                            className="form-control"
                            placeholder="Enter API URL"
                            value={x.api_url}
                            onChange={(e) => handlepayloadfieldsInputAPI(e, i)}
                          />
                        </div>
                        <div className="form-group col-md-12">
                          <label>Input Type</label>
                          <select
                            className="form-control"
                            name="inputType"
                            value={x.inputType}
                            onChange={(e) => handlepayloadfieldsInputAPI(e, i)}
                          >
                            <option value="formdata">Form Data</option>
                            <option value="formrow">Row Data</option>
                          </select>
                        </div>

                        {x.inputType == "formdata" &&
                          x.formdata.map((head, index) => (
                            <>
                              <div className="form-group col-md-4" key={index}>
                                <label htmlFor="inputEmail4">
                                  Formdata Field
                                </label>
                                <input
                                  className="form-control"
                                  name="formdatakey"
                                  placeholder="Enter Header Field"
                                  value={head.formdatakey}
                                  onChange={(e) =>
                                    handlepayloadfieldsInputAPI(e, i, head.id)
                                  }
                                />
                              </div>
                              <div className="form-group col-md-4">
                                <label htmlFor="inputEmail4">
                                  Formdata Value
                                </label>
                                <input
                                  className="form-control"
                                  name="formdatavalue"
                                  onChange={(e) =>
                                    handlepayloadfieldsInputAPI(e, i, head.id)
                                  }
                                  placeholder="Enter Header Field"
                                  value={head.formdatavalue}
                                />
                              </div>
                              <div className="form-group col-md-2">
                                {x.formdata.length !== 1 && (
                                  <button
                                    className="btn btn-danger"
                                    onClick={() =>
                                      removepayloadfieldsFormdata(x.id, head.id)
                                    }
                                  >
                                    -
                                  </button>
                                )}
                                {x.formdata.length - 1 === index && (
                                  <button
                                    className="btn btn-primary"
                                    onClick={() => handleAddpayloadfields(i)}
                                  >
                                    +
                                  </button>
                                )}
                              </div>
                            </>
                          ))}
                        {x.inputType == "formrow" && (
                          <div className="form-group col-md-12">
                            <label>
                              Use {"{{ user_id }}"} for user id and for other
                              fields use {"{{ fieldname }}"}
                            </label>
                            <textarea
                              name="formrow"
                              className="form-control"
                              placeholder="Enter Action Name"
                              onChange={(e) =>
                                handlepayloadfieldsInputAPI(e, i)
                              }
                              rows="10"
                            >
                              {x.formrow}
                            </textarea>
                          </div>
                        )}
                        <div className="col-md-12">
                          <label htmlFor="inputEmail4">Output Format</label>
                          <input
                            className="form-control"
                            name="outputformat"
                            onChange={(e) => handlepayloadfieldsInputAPI(e, i)}
                            placeholder="payload[0].hhdata"
                            value={x.outputformat}
                          />
                        </div>
                      </div>
                    );
                  })}
                </>
              )}
            </div>
          )}
          {select_payload && select_payload != selectPayloadValues.API_Selection && (
            <div element_id="create_view_getpayload" className="block-shadow">
              <h3 className="text-center">Get Payload Fields</h3>
              <div className="row">
                <div
                  element_id="create_view_getp_db"
                  className="form-group col-md-3"
                >
                  <label>DB Name</label>
                  <select
                    className="form-control"
                    name="db_name"
                    value={db_namegetpayload}
                    disabled={view_id}
                    onChange={(e) => getpayloadfieldscollection(e.target.value)}
                  >
                    <option value="">Select DB</option>
                    {db_list &&
                      db_list.map((dbdata) => (
                        <option value={dbdata.db_name}>{dbdata.db_name}</option>
                      ))}
                  </select>
                </div>
                <div
                  element_id="create_view_getp_coll"
                  className="form-group col-md-3"
                >
                  <label>Collection Name</label>
                  {/* <input
                    className="form-control"
                    name="collection_name"
                    onChange={(e) => setcollection_name(e.target.value)}
                  /> */}
                  <select
                    className="form-control"
                    name="db_name"
                    value={collection_namegetpayload}
                    disabled={view_id}
                    onChange={(e) =>
                      setcollection_namegetpayload(e.target.value)
                    }
                  >
                    <option value="">Select Collection</option>
                    {collection_listgetpayloadfields &&
                      collection_listgetpayloadfields.map((colnm) => (
                        <option value={colnm}>{colnm}</option>
                      ))}
                  </select>
                </div>
              </div>
              <div className="row justify-content-center">
                {searchKeygetpayloadfields.map((searchdata, i) => (
                  <>
                    <div className="form-group col-md-3">
                      <label htmlFor="inputEmail4">Key</label>
                      <input
                        className="form-control"
                        name="searchKey"
                        //Ankur Makavana | 18-09-2023 | To add filters & sorting of fields on the payload screen
                        disabled={view_id}
                        value={searchdata.searchKey}
                        onChange={(e) => setsearchKeypayloadfieldsdata(e, i)}
                      />
                    </div>
                    <div
                      element_id="create_view_getp_operator"
                      className="form-group col-md-2"
                    >
                      <label htmlFor="inputEmail4">Operator</label>
                      <select
                        className="form-control"
                        name="operator"
                        disabled={view_id}
                        onChange={(e) => setsearchKeypayloadfieldsdata(e, i)}
                        value={searchdata.operator}
                      >
                        <option value="">select</option>
                        <option value="==">==</option>
                        <option value="exists">exists</option>
                        <option value=">">&#62;</option>
                        <option value="<">&#60;</option>
                        <option value="!=">!=</option>
                      </select>
                    </div>
                    <div
                      element_id="create_view_getp_input"
                      className="form-group col-md-2"
                    >
                      <label htmlFor="inputEmail4">Input Type</label>
                      <select
                        className="form-control"
                        name="inputType"
                        disabled={view_id}
                        value={searchdata.inputType}
                        onChange={(e) => setsearchKeypayloadfieldsdata(e, i)}
                      >
                        <option value="string">String</option>
                        <option value="int">Int</option>
                        <option value="float">Float</option>
                        <option value="boolean">Boolean</option>
                      </select>
                    </div>
                    <div
                      element_id="create_view_getp_val"
                      className="form-group col-md-3"
                    >
                      <label htmlFor="inputEmail4">Value</label>
                      <input
                        className="form-control"
                        name="searchValue"
                        //Ankur Makavana | 18-09-2023 | To add filters & sorting of fields on the payload screen
                        disabled={view_id}
                        value={searchdata.searchValue}
                        onChange={(e) => setsearchKeypayloadfieldsdata(e, i)}
                      //onBlur={() => getFieldList()}
                      />
                    </div>

                    {!view_id && (
                      <div className="btn-box">
                        <div className="form-group col-md-2">
                          {searchKey.length !== 1 && (
                            <button
                              element_id="create_view_removepayload"
                              className="btn btn-danger"
                              onClick={() => handleRemovepayloadfieldsSearch(i)}
                            >
                              -
                            </button>
                          )}
                          {searchKey.length - 1 === i && (
                            <button
                              element_id="create_view_addpayload"
                              className="btn btn-primary"
                              onClick={handleAddpayloadfieldssearch}
                            >
                              +
                            </button>
                          )}
                        </div>
                      </div>
                    )}
                    <div className="col-md-12">
                      <label htmlFor="inputEmail4">Output Format</label>
                      <input
                        className="form-control"
                        name="payloaddataoutputformat"
                        onChange={(e) =>
                          setpayloaddataoutputformat(e.target.value)
                        }
                        placeholder="payload[0].hhdata"
                        value={payloaddataoutputformat}
                      />
                    </div>
                  </>
                ))}
              </div>
            </div>
          )}
          {/* {!view_id && (
            <button className="btn btn-primary" onClick={() => getFieldList()}>
              Get Bucket Field
            </button>
          )} */}
          {view_id && select_payload != selectPayloadValues.API_Selection ? (
            <div className="row">
              <button
                element_id="create_view_getbucket"
                className="btn btn-primary"
                onClick={() => setget_bucketfield(true)}
              >
                Get Bucket Field
              </button>
            </div>
          ) : (
            <button
              element_id="create_view_getfield"
              className="btn btn-primary"
              onClick={() => getFieldList()}
            >
              Get Bucket Field
            </button>
          )}

          <div className="form-group">
            <div
              element_id="create_view_create"
              className="create-label"
            //onClick={handleAddfield}
            >
              Create Fields
            </div>
            <div className="row">
              <div className="col-md-3">
                <button className="btn btn-outline-success btn-sm form-control" onClick={() => {
                  const dataStr = JSON.stringify(JSON.parse(JSON.stringify(default_payload).replace(/"\[.*?\]"/g, '""').replace(/:"\[]"/g, '""')), null, 2);
                  const dataUri = 'data:application/json;charset=utf-8,' + encodeURIComponent(dataStr);
                  const exportFileDefaultName = `${(view_name || 'data') + '_structure'}.json`;

                  const linkElement = document.createElement('a');
                  linkElement.setAttribute('href', dataUri);
                  linkElement.setAttribute('download', exportFileDefaultName);
                  linkElement.click();
                }}>Structure Download <DownloadOutlined /></button>
              </div>
              <div className="col-md-3">
                <button className="btn btn-outline-success btn-sm form-control" onClick={() => {
                  const dataStr = JSON.stringify(fieldlist, null, 2);
                  const dataUri = 'data:application/json;charset=utf-8,' + encodeURIComponent(dataStr);
                  const exportFileDefaultName = `${(view_name || 'data') + '_config'}.json`;

                  const linkElement = document.createElement('a');
                  linkElement.setAttribute('href', dataUri);
                  linkElement.setAttribute('download', exportFileDefaultName);
                  linkElement.click();
                }}>Config Download <DownloadOutlined /></button>
              </div>
              {/* Add these two import buttons */}
              <div className="col-md-3">
                <input
                  type="file"
                  id="structureImport"
                  accept=".json"
                  style={{ display: 'none' }}
                  onChange={(e) => handleStructureImport(e)}
                />
                <button
                  className="btn btn-outline-primary btn-sm form-control"
                  onClick={() => document.getElementById('structureImport').click()}
                >
                  Structure Import <UploadOutlined />
                </button>
              </div>

              <div className="col-md-3">
                <input
                  type="file"
                  id="configImport"
                  accept=".json"
                  style={{ display: 'none' }}
                  onChange={(e) => handleConfigImport(e)}
                />
                <button
                  className="btn btn-outline-primary btn-sm form-control"
                  onClick={() => document.getElementById('configImport').click()}
                >
                  Config Import <UploadOutlined />
                </button>
              </div>
            </div>
            {view_type !== "FV" && <div>
            {console.log("fieldlist--", fieldlist)}
              <FieldMappingEditor
                field_mapping={fieldlist.filter((item) => Array.isArray(item) ? '' : item)}
                referenceJson={default_payload[0]}
                apidata={apidata}
                dropdowndata={resondropdownlist}
                viewlist={view_list}
                view_type={view_type}
                filteredservice_id={filteredservice_id}
                validDate={validDateCondition} // ✅ Pass current value
                setvalidDateCondition={setvalidDateCondition} // ✅ Pass update function
                parentFieldCount={parentFieldCount}
                setParentFieldCount={setParentFieldCount}
                onChange={(new_field_mapping) => {
                  // you can handle it your own way, but this is the recommended approach to check if there is a difference in initial vs new value.
                  // if (
                    //   new_field_mapping.length != 0 &&
                    //   getObjectDifference(new_field_mapping, fieldlist)
                    // ) {
                  //   console.log(new_field_mapping);
                  // }
                  console.log("new_field_mapping", new_field_mapping);
                  console.log("new_field_mapping", fieldlist.filter((item, index, self) => {
                    // Check if the item has a BucketField property and is not an array
                    if (item && item.BucketField && !Array.isArray(item)) {
                      // Find the first occurrence index of this BucketField in the list
                      return self.findIndex(obj => obj.BucketField === item.BucketField) === index;
                    }
                    return false; // Filter out any items that don't meet the criteria
                  }));
                  setfieldlist(new_field_mapping);
                }}
                />
            </div>}
            {/* </div> */}
          <div>
            {view_type === "FV" && fileteredViewList && <ReactFormBuilder
              data={fileteredViewList && fileteredViewList[0] && fileteredViewList[0].form_mapping ? fileteredViewList[0].form_mapping : jsonFormBuild}
              onPost={handleFormBuilderPost}
              payloadkeys={payloadPathKeys}
              getapilist={apidata}
            />}
          </div>
          {/* <div className="form-group">
            <div
              className="create-label"
              //onClick={handleAddfield}
            >
              Create Action API Mapping
            </div>
          </div> */}
          {/* Color-picker for QueryBuilder */}
          <div className="form-group">
            <QueryBuilder
              fields={search_fields}
              query={query}
              onQueryChange={handleQueryChange}
              operators={Operators}
              addRuleToNewGroups
              showCombinatorsBetweenRules
              controlClassnames={{ queryBuilder: "queryBuilder-branches" }}
              controlElements={{ rule: CustomRule }}
            />
            {/* <div
              className="create-label"
              //onClick={handleAddfield}
            >
              Expand Row
            </div>
            <button>Add Row</button>
            {exprow.map((rowdata, i) => (
              <>
                <div className="form-group col-md-2">
                  <label htmlFor="inputEmail4">Field Name</label>
                  <input
                    name="fieldname"
                    className="form-control"
                    placeholder="Enter Field Name"
                    value={rowdata.fieldname}
                    onChange={(e) => handleInputChange(e, i)}
                  />
                </div>
                <div className="form-group col-md-2">
                  <label htmlFor="inputEmail4">Bucket Field Name</label>
                  <select
                    className="form-control"
                    name="BucketField"
                    onChange={(e) => handlechangebucketfield(e, i)}
                    value="" // always use null do not add any value here
                  >
                    <option value="">Select API Field</option>
                    {api_fields_list &&
                      api_fields_list.map((field) => (
                        <option value={field}>{field}</option>
                      ))}
                  </select>
                  {rowdata.BucketField}
                </div>
              </>
            ))} */}    

            {validDateCondition ? (
              <Card style={{ width: 400, marginTop: "5px", textAlign: "center", border: "1px solid black", borderRadius: "4px" }}>
                <p style={{ fontWeight: "bold", color: "#28a745" }}>
                  Colors already configured for "Date"
                </p>
              </Card>
            ) : (
              <div
                style={{
                  display: "flex",
                  flexWrap: "wrap",
                  gap: "20px",
                  marginTop: "20px",
                }}
              >
                {(() => {
                  let groupCount = 0;
                  return query && query.rules.map((rule, index) => {
                    if (rule.rules) {
                      groupCount++;
                      let ruleInGroupCount = 0;
                      return (
                        <div key={index} style={{ marginBottom: "10px" }}>
                          <strong>Group - {groupCount}</strong>
                          {rule.rules.map((innerRule, innerIndex) => {
                            ruleInGroupCount++;
                            return (
                              <div
                                key={`${index}-${innerIndex}`}
                                style={{
                                  display: "flex",
                                  alignItems: "center",
                                  justifyContent: "flex-start",
                                  marginBottom: "5px",
                                }}
                              >
                                <span style={{ marginRight: "10px" }}>
                                  Rule in Group - {groupCount}.{ruleInGroupCount}
                                </span>
                                <Col span={6}>
                                  <div style={{ display: "flex", alignItems: "center", gap: "10px" }}>
                                    {/* Pick Color Button */}
                                    <button
                                      className="btn btn-primary"
                                      onClick={() => toggleColorPicker(`${index}-${innerIndex}`)}
                                    >
                                      {colorPickers[`${index}-${innerIndex}`] &&
                                        colorPickers[`${index}-${innerIndex}`].display
                                        ? "Close Picker"
                                        : "Pick Color"}
                                    </button>
                                    {/* "-" Remove Button */}
                                    <button
                                      className="btn btn-secondary"
                                      onClick={() => handleClearColor(`${index}-${innerIndex}`)}
                                      style={{
                                        backgroundColor: "red",
                                        color: "white",
                                        border: "none",
                                        width: "30px",
                                        height: "30px",
                                        display: "flex",
                                        alignItems: "center",
                                        justifyContent: "center",
                                        fontSize: "20px",
                                        borderRadius: "5px",
                                        cursor: "pointer",
                                      }}
                                    >
                                      <RedoOutlined style={{ fontSize: "16px", color: "white" }} />
                                    </button>
                                  </div>
                                  {/* Color Picker */}
                                  {colorPickers[`${index}-${innerIndex}`] &&
                                    colorPickers[`${index}-${innerIndex}`].display && (
                                      <div style={{ position: "relative", marginTop: "10px" }}>
                                        <div
                                          style={{
                                            position: "fixed",
                                            top: 0,
                                            right: 0,
                                            bottom: 0,
                                            left: 0,
                                          }}
                                          onClick={() => toggleColorPicker(`${index}-${innerIndex}`)}
                                        />
                                        <ChromePicker
                                          color={
                                            (colorPickers[`${index}-${innerIndex}`] && colorPickers[`${index}-${innerIndex}`].color) ||
                                            innerRule.color ||
                                            "#ffffff"
                                          }
                                          onChangeComplete={(color) => handleColorChange(`${index}-${innerIndex}`, color)}
                                        />
                                      </div>
                                    )}
                                </Col>
                              </div>
                            );
                          })}
                        </div>
                      );
                    } else {
                      // For top-level rules (not in a group)
                      return (
                        <div
                          key={index}
                          style={{
                            display: "flex",
                            alignItems: "center",
                            justifyContent: "flex-start",
                            marginBottom: "10px",
                          }}
                        >
                          <span style={{ marginRight: "10px" }}>Rule - {index + 1}</span>
                          <Col span={6}>
                            <div style={{ display: "flex", alignItems: "center", gap: "10px" }}>
                              <button
                                className="btn btn-primary"
                                onClick={() => toggleColorPicker(`${index}`)} // <-- use template string
                              >
                                {colorPickers[`${index}`] && colorPickers[`${index}`].display
                                  ? "Close Picker"
                                  : "Pick Color"}
                              </button>
                              <button
                                className="btn btn-secondary"
                                onClick={() => handleClearColor(`${index}`)}
                                style={{
                                  backgroundColor: "red",
                                  color: "white",
                                  border: "none",
                                  width: "30px",
                                  height: "30px",
                                  display: "flex",
                                  alignItems: "center",
                                  justifyContent: "center",
                                  fontSize: "20px",
                                  borderRadius: "5px",
                                  cursor: "pointer",
                                }}
                              >
                                <RedoOutlined style={{ fontSize: "16px", color: "white" }} />
                              </button>
                            </div>
                            {colorPickers[`${index}`] && colorPickers[`${index}`].display && (
                              <div style={{ position: "relative", marginTop: "10px" }}>
                                <div
                                  style={{
                                    position: "fixed",
                                    top: 0,
                                    right: 0,
                                    bottom: 0,
                                    left: 0,
                                  }}
                                  onClick={() => toggleColorPicker(`${index}`)}
                                />
                                <ChromePicker
                                  color={(colorPickers[`${index}`] && colorPickers[`${index}`].color) ||
                                    (rule.color || "#ffffff")}
                                  onChangeComplete={(color) => handleColorChange(`${index}`, color)}
                                />
                              </div>
                            )}
                          </Col>
                        </div>
                      );
                    }
                  });
                })()}
              </div>
            )}

            <div className="card mt-4 p-2">
              {
                fieldlist.filter(
                  (item) => {
                    const result =
                      item.datatype === "dropdownlist";
                    return result;
                  }
                ) &&
                <div className="col-md-3">
                  <button
                    className="btn btn-primary"
                    onClick={() =>
                      filteroutput()
                    }
                  >
                    Disable Action
                  </button></div>
              }
              {dropdownResponsebasedata.length > 0 &&
                <>
                  <table className="table">
                    <thead>
                      <th>#</th>
                      <th>Disable Action</th>
                    </thead>
                    <tbody>

                      {
                        dropdownResponsebasedata.map((showdata) => {
                          const dropdowncondition = disableedit || [];
                          const existingSelection = dropdowncondition.some(item => item == showdata.item_value);
                          const selected_data = existingSelection ? `${showdata.item_value}-1`
                            : showdata.item_value
                          console.log("existingSelection", existingSelection + "-" + selected_data);
                          return (
                            <tr key={showdata.item_id}>
                              <td>
                                {/* <Checkbox
                              value={showdata.item_value}
                              // checked={!!existingSelection}
                              // onChange={(e) =>
                              //   handleCheckboxChange(e, showdata.item_value)
                              // }
                            >
                              {showdata.item_name + " - " + showdata.item_value}
                            </Checkbox> */}
                                {showdata.item_name + " - " + showdata.item_value}
                              </td>
                              <td>
                                <select
                                  className="form-control"
                                  name="hide_loadmore"
                                  value={selected_data}
                                  select={selected_data}
                                  onChange={(e) => handleValueChange(e.target.value)}
                                >
                                  <option value="" selected>Select</option>
                                  <>
                                    <option value={showdata.item_value + "-1"}>Yes</option>
                                    <option value={showdata.item_value + "-0"}>No</option>
                                  </>
                                </select>
                              </td>
                            </tr>
                          )
                        })
                      }
                    </tbody>
                  </table></>
              }
            </div>
            <div className="card mt-4 p-2">
              <center>Marquee Message</center>
              <div>
                <Row gutter={16} style={{ marginBottom: 10 }}>
                  <Col span={5}>
                    <label>Add Message</label>
                    <Select
                      value={marquee_flag}
                      onChange={(value) =>
                        setmarquee_flag(value)
                      }
                      placeholder="Add Message"
                    >
                      {<>
                        <Option value={1}>
                          Yes
                        </Option>
                        <Option value={0}>
                          No
                        </Option>
                      </>
                      }
                    </Select>
                  </Col>
                  {
                    marquee_flag == 1 &&
                    <><Col span={12}>
                      <label>Message</label>
                      <Input
                        value={marquee_message}
                        onChange={(e) =>
                          setmarquee_message(e.target.value)
                        }
                      />
                    </Col>
                      <Col span={6}>
                        <label>Color</label>
                        <button
                          className="btn btn-primary"
                          onClick={() =>
                            setmarqueeColorPicker(!marqueeColorPicker)
                          }
                        >
                          {marqueeColorPicker ? "Close" : "Pick Color"}
                        </button>
                        {marqueeColorPicker ? (
                          <div>
                            <div onClick={() => setmarqueeColorPicker(false)} />
                            <ChromePicker
                              color={marquee_message_color}
                              onChangeComplete={(color) =>
                                setmarquee_message_color(color.hex)
                              }
                            />
                          </div>
                        ) : null}
                      </Col></>
                  }
                </Row>
              </div>
            </div>
            <div className="card mt-4 p-2">
              <center>Conditional Update</center>
              {
                conditional_update && conditional_update.map((upd_config, updindex) => (
                  <div key={updindex}>
                    <Row key={updindex} gutter={16} style={{ marginBottom: 10 }}>
                      <Col span={6}>
                        <label>condition field</label>
                        <select
                          className="form-control"
                          name="field"
                          onChange={(e) =>
                            handleInputupdateChange(updindex, "field", e.target.value)
                          }
                          value={upd_config.field}
                        >
                          <option value="">Select API Field</option>
                          {fieldlist &&
                            fieldlist.map((field) => (
                              <option value={field.fieldname}>
                                {field.fieldname}
                              </option>
                            ))}
                        </select>
                      </Col>
                      <Col span={4}>
                        <label>Operators</label>
                        <select
                          className="form-control"
                          name="operator"
                          onChange={(e) =>
                            handleInputupdateChange(updindex, "operator", e.target.value)
                          }
                          value={upd_config.operator}
                        >
                          {Operators &&
                            Operators.map((field) => (
                              <option value={field.name}>
                                {field.label}
                              </option>
                            ))}
                        </select>
                      </Col>
                      <Col span={5}>
                        <label>condition value</label>
                        <input className="form-control"
                          name="condition_value"
                          onChange={(e) =>
                            handleInputupdateChange(updindex, "condition_value", e.target.value)
                          }
                          value={upd_config.condition_value} />
                      </Col>
                      <Col span={5}>
                        <label>Check data with</label>
                        <select
                          className="form-control"
                          name="check_data_from"
                          onChange={(e) =>
                            handleInputupdateChange(updindex, "check_data_from", e.target.value)
                          }
                          value={upd_config.check_data_from}
                        >
                          <option value="">Select API Field</option>
                          <option value="CD">Current Data</option>
                          <option value="UD">Update Data</option>
                        </select>
                      </Col>
                      <Col span={1}>
                        <Button className="btn btn-primary" onClick={() => handleAddupdateConfig()}>+</Button>
                      </Col>
                      {conditional_update.length > 1 && <Col span={1}>
                        <Button
                          onClick={() => handleRemoveupdateConfig(updindex)}
                          danger
                          style={{ marginLeft: 10 }}
                        >
                          -
                        </Button>
                      </Col>}
                    </Row>
                    {upd_config.fields_to_update.map((updfields, itemIndex) => (
                      <Row key={updindex} gutter={16} style={{ marginBottom: 10 }}>
                        <Col span={6}>
                          <label>Field</label>
                          <select
                            className="form-control"
                            name="field"
                            onChange={(e) =>
                              handleItemupdateChange(
                                updindex,
                                itemIndex,
                                "field_name",
                                e.target.value
                              )
                            }
                            value={updfields.field_name}
                          >
                            <option value="">Select Field</option>
                            {fieldlist &&
                              fieldlist.map((field) => (
                                <option value={field.BucketField}>
                                  {field.fieldname}
                                </option>
                              ))}
                          </select>
                        </Col>
                        <Col span={6}>
                          <label>value</label>
                          <input className="form-control"
                            name="field_value"
                            onChange={(e) =>
                              handleItemupdateChange(
                                updindex,
                                itemIndex,
                                "field_value",
                                e.target.value
                              )
                            }
                            value={updfields.field_value} />
                        </Col>
                        <Col span={1}>
                          <Button onClick={() => handleAddupdateItem(updindex)} primary>
                            +
                          </Button>
                        </Col>
                        {upd_config.fields_to_update.length > 1 && <Col span={1}>
                          <Button
                            onClick={() =>
                              handleRemoveupdateItem(updindex, itemIndex)
                            }
                            danger
                          >
                            -
                          </Button>
                        </Col>}
                      </Row>
                    ))}

                  </div>
                ))
              }
            </div>
            <div className="card mt-4 p-2">
              <center>CONFIGURE API FIELDS</center>
              <hr />

              {apiExtraDatapoints && apiExtraDatapoints.map((config, index) => (
                <div key={index}>
                  <Row gutter={16} style={{ marginBottom: 10 }}>
                    {/* Passing Flag Dropdown */}
                    <Col span={6}>
                      <label>API Fields Passing Flag</label>
                      <select
                        className="form-control"
                        value={config.flag || ""}
                        onChange={(e) => handleApiConfigChange(index, "flag", e.target.value)}
                      >
                        <option value="">Select Flag</option>
                        <option value="S">Static</option>
                        <option value="D">Dynamic</option>
                      </select>
                    </Col>

                    {/* Variable Name Input */}
                    <Col span={5}>
                      <label>Variable Name</label>
                      <input
                        className="form-control"
                        value={config.key || ""}
                        onChange={(e) => handleApiConfigChange(index, "key", e.target.value)}
                        placeholder="Enter variable name"
                      />
                    </Col>

                    {/* Value Datatype Dropdown */}
                    <Col span={5}>
                      <label>Value Datatype</label>
                      <select
                        className="form-control"
                        value={config.value_datatype || ""}
                        onChange={(e) => handleApiConfigChange(index, "value_datatype", e.target.value)}
                      >
                        <option value="">Select Datatype</option>
                        <option value="int">Int</option>
                        <option value="string">String</option>
                        <option value="float">Float</option>
                        <option value="boolean">Boolean</option>
                      </select>
                    </Col>

                    {/* Variable Value Field */}
                    <Col span={5}>
                      <label>Variable Value</label>
                      {config.flag === "S" ? (
                        config.value_datatype && config.value_datatype === 'boolean' ? (
                          <select
                            className="form-control"
                            value={
                              typeof config.value === 'boolean'
                                ? String(config.value)
                                : (config.value !== null && config.value !== undefined ? config.value : '')
                            }
                            onChange={(e) =>
                              handleApiConfigChange(index, "value", e.target.value)
                            }
                          >
                            <option value="">Select boolean</option>
                            <option value="true">true</option>
                            <option value="false">false</option>
                          </select>
                        ) : (
                          <input
                            className="form-control"
                            value={config.value !== null && config.value !== undefined ? config.value : ""}
                            onChange={(e) => handleApiConfigChange(index, "value", e.target.value)}
                            placeholder="Enter static value"
                          />
                        )
                      ) : config.flag === "D" ? (
                        <select
                          className="form-control"
                          value={config.value !== null && config.value !== undefined ? config.value : ""}
                          onChange={(e) => handleApiConfigChange(index, "value", e.target.value)}
                        >
                          <option value="">Select Value</option>
                          <option value="date_time">Date & Time</option>
                          <option value="transaction_no">Transaction No</option>
                          <option value="logged_in_user">Logged in UserID</option>
                          <option value="logged_in_username">Logged in Username</option>
                          <option value="logged_in_employee_name">Logged in Employee Name</option>
                          {fieldlist && fieldlist.map((field) => (
                            <option key={field.BucketField} value={field.BucketField}>
                              {field.fieldname}
                            </option>
                          ))}
                        </select>
                      ) : (
                        <input
                          className="form-control"
                          placeholder="Select flag first"
                          disabled
                        />
                      )}
                    </Col>

                    {/* Regular Expression Field - Only show when Transaction No is selected */}
                    {config.flag === "D" && config.value === "transaction_no" && (
                      <Col span={6}>
                        <label>Regular Expression</label>
                        <input
                          className="form-control"
                          value={config.regularExpression || ""}
                          onChange={(e) => handleApiConfigChange(index, "regularExpression", e.target.value)}
                          placeholder="Enter regex pattern"
                        />
                      </Col>
                    )}

                    {/* API Endpoints Multi-select Dropdown */}
                    <Col span={6}>
                      <label>API Endpoints</label>
                      <Select
                        mode="multiple"
                        placeholder="Select API endpoints"
                        value={config.api_endpoints || []}
                        onChange={(value) => handleApiConfigChange(index, "api_endpoints", value)}
                        style={{ width: '100%' }}
                      >
                        <Option value="/updateone">Updateone</Option>
                        <Option value="/insert">Insert</Option>
                        {apidata && apidata.map((api) => (
                          <Option key={api.action_name} value={api.action_name}>
                            {api.action_name}
                          </Option>
                        ))}
                      </Select>
                    </Col>

                    <Col span={6} style={{ display: 'flex', alignItems: 'center' }}>
                      <Checkbox
                        checked={config.get_from_api}
                        onChange={(e) => {
                          const value = e.target.checked;
                          handleApiConfigChange(index, "get_from_api", value);

                          // When enabling get_from_api, force use_old_data to false
                          if (value === true) {
                            handleApiConfigChange(index, "use_old_data", false);
                          }
                        }}
                      >
                        Get from API?
                      </Checkbox>
                    </Col>

                    <Col span={6} style={{ display: 'flex', alignItems: 'center' }}>
                      <Checkbox
                        checked={config.use_old_data}
                        onChange={(e) =>
                          handleApiConfigChange(index, "use_old_data", e.target.checked)
                        }
                        disabled={config.get_from_api} // disable when API is chosen
                      >
                        Use Old Data?
                      </Checkbox>
                    </Col>

                    {/* Condition Group Builder */}
                    <Col span={24}>
                      <label>Condition Group</label>
                      <ConditionBuilder
                        group={config.rules || {}}
                        fieldlist={fieldlist}
                        onChange={(updatedGroup) => handleApiConfigChange(index, "rules", updatedGroup)}
                      />
                    </Col>

                    {/* Add/Remove Buttons */}
                    <Col span={2}>
                      <div style={{ paddingTop: '25px' }}>
                        <Button 
                          className="btn btn-primary" 
                          onClick={() => handleAddApiConfig()}
                          style={{ marginRight: '5px' }}
                        >
                          +
                        </Button>
                        {apiExtraDatapoints.length > 1 && (
                          <Button
                            onClick={() => handleRemoveApiConfig(index)}
                            danger
                          >
                            -
                          </Button>
                        )}
                      </div>
                    </Col>
                  </Row>
                </div>
              ))}
            </div>
            
<div style={{ maxWidth: "900px", margin: "20px auto", fontFamily: "sans-serif" }}>
      <h3>History Configuration</h3>

      {/* 🔹 Add New Config Section with Dropdown */}
      <div style={{ ...sectionStyle, background: "#eef5ff" }}>
        <h4>Add New Config</h4>
        <select
          style={inputStyle}
          value={selectedNewKey}
          onChange={(e) => setSelectedNewKey(e.target.value)}
        >
          <option value="">Select Key...</option>
          {/* {availableKeys.map((k) => (
            <option key={k} value={k}>
              {k}
            </option>
          ))} */}
          {fieldlist && fieldlist
              .filter((item) => item.isClickable === "1")
              .map((field) => (
                <option key={field.BucketField} value={field.BucketField}>
                  {field.fieldname}
                </option>
          ))}
        </select>
        <button style={buttonStyle} onClick={addNewConfig}>
          + Add Config
        </button>
      </div>

      {/* 🔹 Iterate through all configs */}
      {Object.entries(config).map(([mainKey, cfg]) => (
        <div key={mainKey} style={sectionStyle}>
        <div style={configHeaderStyle}>
          <h3>{mainKey}</h3>
          <button style={deleteBtnStyle} onClick={() => deleteEntireConfig(mainKey)}>
              🗑 Delete Config
            </button>
            </div>

          {["key_to_serach_in_mongo"].map((field) => (
            <div key={field}>
              <label>{field}:</label>
              <input
                style={inputStyle}
                type="text"
                value={cfg[field] || ""}
                onChange={(e) => handleFieldChange(mainKey, field, e.target.value)}
                placeholder={`Enter ${field}`}
              />
              {/* <button
                style={deleteBtnStyle}
                onClick={() => handleFieldChange(mainKey, field, "")}
              >
                🗑
              </button> */}
            </div>
          ))}

          {/* Output Projection Section */}
          <div style={sectionStyle}>
            <h4>Output Projection</h4>
            <div style={{ marginBottom: "10px" }}>
              {["inner_collection", "source_collection"].map((tab) => (
                <button
                  key={tab}
                  onClick={() => handleTabChange(mainKey, "output", tab)}
                  style={tabButtonStyle(tab, activeTabs[mainKey] && activeTabs[mainKey].output)}
                >
                  {tab}
                </button>
              ))}
            </div>

            {cfg.output_projection &&
              cfg.output_projection[activeTabs[mainKey] && activeTabs[mainKey].output].map((item, i) => (
                // <div key={i}>
                //   <input
                //     style={inputStyle}
                //     value={item}
                //     onChange={(e) =>
                //       handleListChange(mainKey, "output_projection", i, e.target.value, activeTabs[mainKey])
                //     }
                //   />
                <div key={i} style={inputContainer}>
                  <select
                    style={inputStyle}
                    value={item}
                    onChange={(e) =>
                      handleListChange(mainKey, "output_projection", i, e.target.value, activeTabs[mainKey] && activeTabs[mainKey].output)
                    }
                  >
                    <option value="">Select Field...</option>
                    {/* {availableKeys.map((k) => (
                      <option key={k} value={k}>
                        {k}
                      </option>
                    ))} */}
                    {fieldlist && fieldlist
                        .map((field) => (
                          <option key={field.BucketField} value={field.BucketField}>
                            {field.fieldname}
                          </option>
                    ))}
                  </select>
                  <button
                    style={deleteBtnStyle}
                    onClick={() => deleteListItem(mainKey, "output_projection", i, activeTabs[mainKey] && activeTabs[mainKey].output)}
                  >
                    🗑
                  </button>
                </div>
              ))}
            <button
              style={buttonStyle}
              onClick={() => addListItem(mainKey, "output_projection", activeTabs[mainKey] && activeTabs[mainKey].output)}
            >
              + Add Field
            </button>
          </div>

          {/* Label Section */}
          <div style={sectionStyle}>
            <h4>Labels</h4>
            <div style={{ marginBottom: "10px" }}>
              {["node_labels", "source_labels"].map((tab) => (
                <button
                  key={tab}
                  onClick={() => handleTabChange(mainKey, "label", tab)}
                  style={tabButtonStyle(tab, activeTabs[mainKey] && activeTabs[mainKey].label || "node_labels")}
                >
                  {tab}
                </button>
              ))}
            </div>

            {/* NODE LABELS (Default open, 3 fixed dropdowns) */}
            {(!activeTabs[mainKey] && activeTabs[mainKey].label ||
              activeTabs[mainKey] && activeTabs[mainKey].label === "node_labels") && (
              <div>
                {[
                  "Select primary label",
                  "Select secondary label",
                  "Select alternative primary label (optional)",
                ].map((placeholder, i) => (
                  <div key={i} style={inputContainer}>
                    <select
                      style={inputStyle}
                      value={cfg.node_labels && cfg.node_labels[i] || ""}
                      onChange={(e) => {
                        const newLabels = [...(cfg.node_labels || [])];
                        newLabels[i] = e.target.value;
                        setConfig((prev) => ({
                          ...prev,
                          [mainKey]: {
                            ...prev[mainKey],
                            node_labels: newLabels,
                          },
                        }));
                      }}
                    >
                      <option value="">{placeholder}</option>
                      {fieldlist &&
                        fieldlist.map((field) => (
                          <option key={field.BucketField} value={field.BucketField}>
                            {field.fieldname}
                          </option>
                        ))}
                    </select>
                  </div>
                ))}
              </div>
            )}

            {/* SOURCE LABELS (Shown when tab clicked, 2 fixed dropdowns) */}
            {activeTabs[mainKey]&& activeTabs[mainKey].label === "source_labels" && (
              <div>
                {["Select primary label", "Select secondary label"].map(
                  (placeholder, i) => (
                    <div key={i} style={inputContainer}>
                      <select
                        style={inputStyle}
                        value={cfg.source_labels && cfg.source_labels[i] || ""}
                        onChange={(e) => {
                          const newLabels = [...(cfg.source_labels || [])];
                          newLabels[i] = e.target.value;
                          setConfig((prev) => ({
                            ...prev,
                            [mainKey]: {
                              ...prev[mainKey],
                              source_labels: newLabels,
                            },
                          }));
                        }}
                      >
                        <option value="">{placeholder}</option>
                        {fieldlist &&
                          fieldlist.map((field) => (
                            <option key={field.BucketField} value={field.BucketField}>
                              {field.fieldname}
                            </option>
                          ))}
                      </select>
                    </div>
                  )
                )}
              </div>
            )}
          </div>
            
            
        </div>
      ))}
    </div>
            <div className="card mt-4 p-2">
              {configurations.map((config, configIndex) => (
                <div
                  key={configIndex}
                  style={{ marginBottom: 20, marginTop: 20 }}
                >
                  <Row key={configIndex} gutter={16} style={{ marginBottom: 10 }}>
                    <Col span={6}>
                      <Input
                        placeholder="Config Name"
                        value={config.name}
                        onChange={(e) =>
                          handleInputChange(configIndex, "name", e.target.value)
                        }
                      />
                    </Col>
                    <Col span={6}>
                      <div>
                        <button
                          className="btn btn-primary"
                          onClick={() =>
                            setDisplayColorPicker(!displayColorPicker)
                          }
                        >
                          {displayColorPicker ? "Close" : "Pick Color"}
                        </button>
                        {displayColorPicker ? (
                          <div>
                            <div onClick={() => setDisplayColorPicker(false)} />
                            <ChromePicker
                              color={config.color}
                              onChangeComplete={(color) =>
                                handleInputChange(
                                  configIndex,
                                  "color",
                                  color.hex
                                )
                              }
                            />
                          </div>
                        ) : null}
                      </div>
                    </Col>
                  </Row>
                  {config.items.map((item, itemIndex) => (
                    <Row
                      gutter={16}
                      key={itemIndex}
                      style={{ marginBottom: 10 }}
                    >
                      <Col span={3}>
                        <Select
                          value={item.dropdown1}
                          onChange={(value) =>
                            handleItemChange(
                              configIndex,
                              itemIndex,
                              "dropdown1",
                              value
                            )
                          }
                          placeholder="Select Value 1"
                        >
                          {allRules.map(({ field }) => (
                            <Option key={field} value={field}>
                              {field}
                            </Option>
                          ))}
                        </Select>
                      </Col>
                      <Col span={3}>
                        <Select
                          value={item.dropdown2}
                          onChange={(value) =>
                            handleItemChange(
                              configIndex,
                              itemIndex,
                              "dropdown2",
                              value
                            )
                          }
                          placeholder="Select Value 2"
                        >
                          {allRules.length > 0 &&
                            allRules[0].values.map((field) => (
                              <Option key={field} value={field}>
                                {field}
                              </Option>
                            ))}
                        </Select>
                      </Col>
                      <Col span={4}>
                        <Input
                          placeholder="Label name"
                          value={item.name ? item.name : ''}
                          onChange={(e) =>
                            handleItemChange(configIndex, itemIndex, "name", e.target.value)
                          }
                        />
                      </Col>
                      <Col span={4}>
                        <Select
                          value={item.operator}
                          onChange={(value) =>
                            handleItemChange(
                              configIndex,
                              itemIndex,
                              "operator",
                              value
                            )
                          }
                          placeholder="Operator"
                        >
                          {operatorOptions.map((operator) => (
                            <Option key={operator} value={operator}>
                              {operator}
                            </Option>
                          ))}
                        </Select>
                      </Col>

                      <Col span={4}>
                        <Select
                          value={item.isEditable}
                          onChange={(value) =>
                            handleItemChange(
                              configIndex,
                              itemIndex,
                              "isEditable",
                              value
                            )
                          }
                          placeholder="Is Editable"
                        >
                          {<>
                            <Option value={1}>
                              Yes
                            </Option>
                            <Option value={0}>
                              No
                            </Option>
                          </>
                          }
                        </Select>
                      </Col>
                      {item.isEditable == 1 && <Col span={4}>
                        <Select
                          value={item.popupfield}
                          onChange={(value) =>
                            handleItemChange(
                              configIndex,
                              itemIndex,
                              "popupfield",
                              value
                            )
                          }
                          placeholder="Select Field"
                        >
                          {fieldlist && fieldlist.map((operator, index) => (
                            <Option key={index} value={operator.fieldname}>
                              {operator.fieldname}
                            </Option>
                          ))}
                        </Select>
                      </Col>
                      }

                      <Col span={4}>
                        <Button
                          onClick={() =>
                            handleRemoveItem(configIndex, itemIndex)
                          }
                          danger
                        >
                          Remove Item
                        </Button>
                      </Col>
                    </Row>
                  ))}
                  <Button onClick={() => handleAddItem(configIndex)}>
                    Add Item
                  </Button>
                  <Button
                    onClick={() => handleRemoveConfig(configIndex)}
                    danger
                    style={{ marginLeft: 10 }}
                  >
                    Remove Config
                  </Button>
                </div>
              ))}
              <Button
                onClick={handleAddConfig}
                className="col-md-2"
                type="primary"
              >
                Add Config
              </Button>

              <div
                element_id="create_view_fieldlist"
                className="form-group col-md-12"
              >
                <label htmlFor="fieldlist">
                  Select Fields for Partial Submit
                </label>
                {console.log("entries", entries)}
                {entries && entries.map((entry, index) => (
                  <Row className="mb-2">
                    <>
                      <Col span={6} className="mr-2">
                        <Select
                          placeholder="Select"
                          name="fieldlist"
                          value={entry.partialfield}
                          options={
                            fieldForPartialSubmit &&
                            fieldForPartialSubmit.map((item, index) => ({
                              label: item["fieldname"], // Displayed text
                              value: item["BucketField"], // Unique key for each option
                              key: index,
                            }))
                          }
                          onChange={(value) =>
                            handleChangepartial(index, "partialfield", value)
                          }
                        />
                      </Col>
                      <Col span={6} className="mr-2">
                        <Input
                          className="form-control"
                          value={entry.defaultvalue}
                          onChange={(e) =>
                            handleChangepartial(
                              index,
                              "defaultvalue",
                              e.target.value
                            )
                          }
                          placeholder="Enter text"
                        />
                      </Col>
                      <Col className="mr-2">
                        {entries.length > 1 && (
                          <Button
                            type="danger"
                            onClick={() => removeEntry(index)}
                          >
                            Remove
                          </Button>
                        )}
                      </Col>
                    </>
                  </Row>
                ))}

                {/* Add button */}
                <Button type="primary" onClick={addEntry}>
                  Add
                </Button>
              </div>
            </div>
            {/* Field Dependencies Section */}
            <div className="card mt-4 p-2">
              <div className="create-label">Field Dependencies</div>
              {fieldDependencies.map((dep, index) => (
                <Row key={dep.id} gutter={16} style={{ marginBottom: 10 }}>
                  <Col span={5}>
                    <label>Controller Field</label>
                    <select
                      className="form-control"
                      value={dep.controllerField}
                      onChange={(e) => updateFieldDependency(index, "controllerField", e.target.value)}
                    >
                      <option value="">Select Field</option>
                      {fieldlist && fieldlist.map((f, i) => (
                        <option key={`cf-${i}`} value={f.BucketField}>{f.fieldname}</option>
                      ))}
                    </select>
                  </Col>
                  <Col span={4}>
                    <label>Operator</label>
                    <select
                      className="form-control"
                      value={dep.operator}
                      onChange={(e) => updateFieldDependency(index, "operator", e.target.value)}
                    >
                      <option value="">select</option>
                      <option value="==">==</option>
                      <option value="exists">exists</option>
                      <option value=">">&#62;</option>
                      <option value="<">&#60;</option>
                      <option value="!=">!=</option>
                      <option value=">=">&gt;=</option>
                      <option value="<=">&lt;=</option>
                    </select>
                  </Col>
                  {dep.operator !== "exists" && (
                    <Col span={4}>
                      <label>Value</label>
                      <Input
                        value={dep.value}
                        placeholder="Enter value"
                        onChange={(e) => updateFieldDependency(index, "value", e.target.value)}
                      />
                    </Col>
                  )}
                  <Col span={5}>
                    <label>Target Field</label>
                    <select
                      className="form-control"
                      value={dep.targetField}
                      onChange={(e) => updateFieldDependency(index, "targetField", e.target.value)}
                    >
                      <option value="">Select Field</option>
                      {fieldlist && fieldlist.map((f, i) => (
                        <option key={`tf-${i}`} value={f.BucketField}>{f.fieldname}</option>
                      ))}
                    </select>
                  </Col>
                  <Col span={4}>
                    <label>Action</label>
                    <select
                      className="form-control"
                      value={dep.action}
                      onChange={(e) => updateFieldDependency(index, "action", e.target.value)}
                    >
                      <option value="" selected>Select Action</option>
                      {dependencyActionOptions.map(({label, value}) => (
                        <option key={value} value={value}>{label}</option>
                      ))}
                    </select>
                  </Col>
                  <Col span={4}>
                    <label>Action Value (optional)</label>
                    <Input
                      value={dep.actionValue}
                      placeholder="Enter default/dynamic value"
                      onChange={(e) => updateFieldDependency(index, "actionValue", e.target.value)}
                    />
                  </Col>
                  {fieldDependencies.length > 1 && (
                    <Col span={2}>
                      <Button danger onClick={() => removeFieldDependency(index)}>-</Button>
                    </Col>
                  )}
                </Row>
              ))}
              <Button type="primary" onClick={addFieldDependency}>Add Dependency</Button>
            </div>
            <div
              element_id="create_view_hide_dropdown_conditions"
              className="card mt-4 p-2"
            >
              <div className="create-label">Hide Dropdown Options Conditions</div>
              <ConditionBuilder
                group={dropdownList_hideConditions || []}
                fieldlist={fieldlist}
                onChange={(updatedGroup) => setDropdownListHideConditions(updatedGroup)}
              />
            </div>
            <div
              element_id="create_view_createapi"
              className="create-label"
            //onClick={handleAddfield}
            >
              Create Action API Mapping
            </div>
            <button
              element_id="create_view_addapi"
              onClick={handleAddDiv}
              className="btn btn-info"
            >
              Add API
            </button>
            {divs && divs.map((x, i) => {
              return (
                <div
                  key={i}
                  className="row"
                  style={{ border: "1px solid", marginTop: "5px" }}
                >
                  <div
                    element_id="create_view_actionname"
                    className="form-group col-md-6"
                  >
                    <label htmlFor="inputEmail4">Action Name</label>
                    <input
                      name="action_name"
                      className="form-control"
                      placeholder="Enter Action Name"
                      value={x.action_name}
                      onChange={(e) => handleInputAPI(e, i)}
                    />
                  </div>
                  <div
                    element_id="create_view_actionevent"
                    className="form-group col-md-6"
                  >
                    <label htmlFor="inputEmail4">Action Event</label>
                    <select
                      name="action_event"
                      className="form-control"
                      value={x.action_event}
                      onChange={(e) => handleInputAPI(e, i)}
                    >
                      <option value="">Select Event</option>
                      <option value="action">Action</option>
                      <option value="onsave">On Save</option>
                      <option value="beforesave">Before Save</option>
                      <option value="massupdate">Mass Update</option>
                      <option value="condition">Condition</option>
                    </select>
                  </div>
                  {divs.length !== 1 && (
                    <div
                      element_id="create_view_removeAction"
                      className="form-group col-md-2"
                    >
                      <button
                        element_id="create_view_removediv"
                        className="btn btn-danger"
                        onClick={() => removeDiv(i)}
                      >
                        -
                      </button>
                    </div>
                  )}
                  <div
                    element_id="create_view_url"
                    className="form-group col-md-6"
                  >
                    <label>Url Type</label>
                    <select
                      className="form-control"
                      name="url_type"
                      value={x.url_type}
                      onChange={(e) => handleInputAPI(e, i)}
                    >
                      <option value="">select</option>
                      <option value="B">With Base URL</option>
                      <option value="N">Without Base URL</option>
                    </select>
                  </div>
                  <div
                    element_id="create_view_apiurl"
                    className="form-group col-md-6"
                  >
                    <label htmlFor="inputEmail4">API URL</label>
                    <input
                      name="api_url"
                      className="form-control"
                      placeholder="Enter API URL"
                      value={x.api_url}
                      onChange={(e) => handleInputAPI(e, i)}
                    />
                  </div>
                  {
                    x.action_event === 'condition' && (
                      <div className="form-group col-md-3">
                        <label htmlFor="select_field">Select Field</label>
                        <select
                          className="form-control"
                          name="select_field"
                          onChange={(e) => handleInputAPI(e, i)}
                          value={x.select_field}
                        >
                          <option value="">Select API Field</option>
                          {fieldlist &&
                            fieldlist.map((field) => (
                              <option value={field.fieldname}>
                                {field.fieldname}
                              </option>
                            ))}
                        </select>
                        {/* {x.select_field} */}
                      </div>
                    )
                  }
                  {
                    x.action_event === 'condition' && (
                      <div className="form-group col-md-6">
                        <label htmlFor="condition_value">Condition Value</label>
                        <input 
                          name="condition_value"
                          className="form-control"
                          placeholder="Condition Value"
                          value={x.condition_value}
                          onChange={(e) => handleInputAPI(e, i)} />
                      </div>
                    )
                  }
                  <div
                    element_id="create_view_iptype"
                    className="form-group col-md-12"
                  >
                    <label>Input Type</label>
                    <select
                      className="form-control"
                      name="inputType"
                      value={x.inputType}
                      onChange={(e) => handleInputAPI(e, i)}
                    >
                      <option value="formdata">Form Data</option>
                      <option value="formrow">Row Data</option>
                    </select>
                  </div>

                  {x.inputType == "formdata" &&
                    x.formdata.map((head, index) => (
                      <>
                        <div
                          element_id="create_view_formdata"
                          className="form-group col-md-3"
                          key={index}
                        >
                          <label htmlFor="inputEmail4">Formdata Field</label>
                          <input
                            className="form-control"
                            name="formdatakey"
                            placeholder="Enter Header Field"
                            value={head.formdatakey}
                            onChange={(e) => handleInputAPI(e, i, head.id)}
                          />
                        </div>
                        <div
                          element_id="create_view_formval"
                          className="form-group col-md-3"
                        >
                          <label htmlFor="inputEmail4">Formdata Value</label>

                          <select
                            className="form-control"
                            name="formdatavalue"
                            onChange={(e) => handleInputAPI(e, i, head.id)}
                            value={head.formdatavalue}
                          >
                            <option value="">Select API Field</option>
                            {fieldlist &&
                              fieldlist.map((field) => (
                                <option value={field.fieldname} key={field.fieldname}>
                                  {field.fieldname}
                                </option>
                              ))}
                          </select>
                          {head.formdatavalue}
                        </div>
                        <div
                          element_id="create_view_formdata"
                          className="form-group col-md-2"
                          key={index}
                        >
                          <label htmlFor="inputEmail4">Type</label>
                          {/* <input
                            className="form-control"
                            name="userdata"
                            placeholder="Enter Header Field"
                            value={head.userdata}
                            onChange={(e) => handleInputAPI(e, i, head.id)}
                          /> */}
                          <select
                            name="inputtype"
                            className="form-control"
                            onChange={(e) => handleInputAPI(e, i, head.id)}
                            value={head.inputtype}
                          >
                            {api_input_type.map((item) => (
                              <option value={item.value} key={item.value}>{item.option}</option>
                            ))}
                          </select>
                        </div>
                        <div
                          element_id="create_view_formdata"
                          className="form-group col-md-2"
                          key={index}
                        >
                          <label htmlFor="inputEmail4">Defaultvalue</label>
                          <input
                            className="form-control"
                            name="defaultvalue"
                            placeholder="Enter Header Field"
                            value={head.defaultvalue}
                            onChange={(e) => handleInputAPI(e, i, head.id)}
                          />
                        </div>
                        <div className="form-group col-md-2">
                          {x.formdata.length !== 1 && (
                            <button
                              className="btn btn-danger"
                              onClick={() => removeFormdata(x.id, head.id)}
                            >
                              -
                            </button>
                          )}
                          {x.formdata.length - 1 === index && (
                            <button
                              className="btn btn-primary"
                              onClick={() => handleAddheaderfield(i)}
                            >
                              +
                            </button>
                          )}
                        </div>
                      </>
                    ))}
                  {x.inputType == "formrow" && (
                    <div
                      element_id="create_view_uid"
                      className="form-group col-md-12"
                    >
                      <label>
                        Use {"{{ user_id }}"} for user id and for other fields
                        use {"{{ fieldname }}"}
                      </label>
                      <textarea
                        name="formrow"
                        className="form-control"
                        placeholder="Enter Action Name"
                        onChange={(e) => handleInputAPI(e, i)}
                        rows="10"
                      >
                        {x.formrow}
                      </textarea>
                    </div>
                  )}
                  <div
                    element_id = "create_view_hide_conditions"
                    className="form-group col-md-12"
                  >
                    <label>Hide API Action Conditions</label>
                    <ConditionBuilder
                      group={x.hide_conditions || []}
                      fieldlist={fieldlist}
                      onChange={(updatedGroup) => handleInputAPI({target: {name: "hide_conditions", value: updatedGroup}}, i)}
                    />
                  </div>
                </div>
              );
            })}
          </div>
          <div className="form-group">
            <div className="create-label">Create Get API</div>
            <button
              element_id="create_view_addapi"
              onClick={handleAddApidata}
              className="btn btn-info"
            >
              Add API
            </button>

            {apidata.map((x, i) => {
              return (
                <>
                  <div
                    key={i}
                    className="row"
                    style={{ border: "1px solid", marginTop: "5px" }}
                  >
                    <div
                      element_id="create_view_api_action"
                      className="form-group col-md-10"
                    >
                      <label htmlFor="inputEmail4">Action Name</label>
                      <input
                        name="action_name"
                        className="form-control"
                        placeholder="Enter Action Name"
                        value={x.action_name}
                        onChange={(e) => handleApiInput(e, i)}
                      />
                    </div>

                    {apidata.length !== 1 && (
                      <div className="form-group col-md-2">
                        <button
                          className="btn btn-danger"
                          onClick={() => removeGetApi(i)}
                        >
                          -
                        </button>
                      </div>
                    )}
                    <div
                      element_id="create_view_api_url"
                      className="form-group col-md-12"
                    >
                      <label htmlFor="inputEmail4">API URL</label>
                      <input
                        name="api_url"
                        className="form-control"
                        placeholder="Enter API URL"
                        value={x.api_url}
                        onChange={(e) => handleApiInput(e, i)}
                      />
                    </div>
                    <div className="form-group col-md-12">
                      <label htmlFor="inputEmail4">Output Path</label>
                      <input
                        name="output_path"
                        className="form-control"
                        placeholder="Enter Output Path"
                        value={x.output_path}
                        onChange={(e) => handleApiInput(e, i)}
                      />
                    </div>
                    <div
                      element_id="create_view_api_priority"
                      className="form-group col-md-12">
                      <label>Set Priority</label>
                      <input
                        type="number"
                        name="priority"
                        className="form-control"
                        placeholder={"Default Value: 0"}
                        value={x.priority}
                        onChange={(e) => handleApiInput(e, i)}
                      ></input>
                    </div>
                    <div className="form-group col-md-12">
                      <label>Configure Output</label>
                      <div className="form-group col-md-12">
                        {x.getoutputdata}
                        <textarea
                          name="getoutputdata"
                          className="form-control"
                          placeholder={"{key:value,key:value}"}
                          onChange={(e) => handleApiInput(e, i)}
                        ></textarea>
                      </div>
                    </div>

                    {/* <div className="row form-group col-md-12">
                      <label className="col-md-12">Output Fields</label>

                      {x.outputdata.map((head, index) => (
                        <>
                          <div className="form-group col-md-4" key={index}>
                            <label htmlFor="inputEmail4">Output Key</label>
                            <input
                              className="form-control"
                              name="outputkey"
                              placeholder="Enter Header Field"
                              value={head.outputkey}
                              onChange={(e) => handleApiInput(e, i, head.id)}
                            />
                          </div>
                          <div className="form-group col-md-4">
                            <label htmlFor="inputEmail4">Output Value</label>

                            <input
                              className="form-control"
                              name="outputvalue"
                              placeholder="Enter Header Field"
                              value={head.outputvalue}
                              onChange={(e) => handleApiInput(e, i, head.id)}
                            />
                            {head.formdatavalue}
                          </div>
                          <div className="form-group col-md-2">
                            {x.outputdata.length !== 1 && (
                              <button
                                className="btn btn-danger"
                                onClick={() =>
                                  removeApioutputFormdata(x.id, head.id)
                                }
                              >
                                -
                              </button>
                            )}
                            {x.outputdata.length - 1 === index && (
                              <button
                                className="btn btn-primary"
                                onClick={() => handleAddapioutputheaderfield(i)}
                              >
                                +
                              </button>
                            )}
                          </div>
                        </>
                      ))}
                      <div className="form-group row col-md-12">
                        <div className="col-md-12">
                          <label className="mr-2">is Table ?</label>
                        </div>

                        {x.tabledata.map((tabledata, index) => (
                          <>
                            <div className="form-group col-md-4" key={index}>
                              <label>Table Key</label>
                              <input
                                className="form-control"
                                value={tabledata.tablekey}
                                onChange={(e) =>
                                  handlechangetablekey(e, i, index)
                                }
                                name="tablekey"
                              />
                            </div>
                            <div className="form-group col-md-4">
                              <label>Table Source</label>
                              <input
                                className="form-control"
                                value={tabledata.tablevalue}
                                onChange={(e) =>
                                  handlechangetablevalue(e, i, index)
                                }
                                name="tablevalue"
                              />
                            </div>
                            <div className="form-group col-md-2">
                              {x.tabledata.length !== 1 && (
                                <button
                                  className="btn btn-danger"
                                  onClick={() =>
                                    handleRemoveTable(i, tabledata.id)
                                  }
                                >
                                  -
                                </button>
                              )}

                              {x.tabledata.length - 1 === index && (
                                <button
                                  className="btn btn-primary"
                                  onClick={() => handleAddTableData(i)}
                                >
                                  +
                                </button>
                              )}
                            </div>
                          </>
                        ))}
                      </div>
                    </div> */}
                  </div>
                </>
              );
            })}
          </div>
          <div className="text-center">
            <button
              className="btn btn-primary mr-2"
              onClick={() => setisMobileview(true)}
            >
              Create Mobile View
            </button>
            <button
              className="btn btn-primary"
              onClick={() => setSaveConfigModalVisible(true)}
            >
              Save Configuration
            </button>
          </div>
          {/* <br/> */}
          <div></div>
        </div>
      </div>
      {console.log("fieldlist_data", fieldlist)}
      {console.log("props.location.state", props.location.state)}
      {/* {props.location.state.payloadTile && isMobileview ? (
        <PayloadTile
          flag={props.location.state.flag}
          fieldslist={fieldlist}
          create_view={getData}
        />
      ) : (
        ""
      )} */}
    </div>
  );
}

export default Create_view;